export const listSVGIcon01 = {
  'arrow-right-circle': (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0.5 11C0.5 13.0767 1.11581 15.1068 2.26957 16.8335C3.42332 18.5602 5.0632 19.906 6.98182 20.7007C8.90045 21.4955 11.0116 21.7034 13.0484 21.2982C15.0852 20.8931 16.9562 19.8931 18.4246 18.4246C19.8931 16.9562 20.8931 15.0852 21.2982 13.0484C21.7034 11.0116 21.4955 8.90045 20.7007 6.98182C19.906 5.0632 18.5602 3.42332 16.8335 2.26957C15.1068 1.11581 13.0767 0.5 11 0.5C8.21523 0.5 5.54451 1.60625 3.57538 3.57538C1.60625 5.54451 0.5 8.21523 0.5 11ZM5 10.25H14.1125L9.9275 6.04475L11 5L17 11L11 17L9.9275 15.9298L14.1125 11.75H5V10.25Z"
        fill="#01638D"
      />
    </svg>
  ),
  'arrow-left-circle': (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.5 11C21.5 8.9233 20.8842 6.89323 19.7304 5.16651C18.5767 3.4398 16.9368 2.09398 15.0182 1.29926C13.0996 0.504545 10.9884 0.29661 8.95155 0.701756C6.91475 1.1069 5.04383 2.10693 3.57538 3.57538C2.10693 5.04383 1.1069 6.91475 0.701756 8.95155C0.29661 10.9884 0.504545 13.0996 1.29926 15.0182C2.09398 16.9368 3.4398 18.5767 5.16651 19.7304C6.89323 20.8842 8.9233 21.5 11 21.5C13.7848 21.5 16.4555 20.3938 18.4246 18.4246C20.3938 16.4555 21.5 13.7848 21.5 11ZM17 11.75L7.8875 11.75L12.0725 15.9553L11 17L5 11L11 5L12.0725 6.07025L7.8875 10.25L17 10.25V11.75Z"
        fill="#01638D"
      />
    </svg>
  ),
  'reload-yellow': (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 4.05273V10.0527H7"
        stroke="#FFA800"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 20.0527V14.0527H17"
        stroke="#FFA800"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.49 9.05232C19.9828 7.61911 19.1209 6.33772 17.9845 5.32774C16.8482 4.31776 15.4745 3.61209 13.9917 3.27658C12.5089 2.94107 10.9652 2.98666 9.50481 3.4091C8.04437 3.83153 6.71475 4.61704 5.64 5.69232L1 10.0523M23 14.0523L18.36 18.4123C17.2853 19.4876 15.9556 20.2731 14.4952 20.6955C13.0348 21.118 11.4911 21.1636 10.0083 20.8281C8.52547 20.4926 7.1518 19.7869 6.01547 18.7769C4.87913 17.7669 4.01717 16.4855 3.51 15.0523"
        stroke="#FFA800"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'folder-blue': (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M53.6234 21.8151C53.9259 22.4378 53.4455 23.125 52.7532 23.125H6C5.44771 23.125 5 22.6773 5 22.125V16.05C5 9.95 9.95 5 16.05 5H21.85C25.925 5 27.2 6.325 28.825 8.5L32.325 13.15C33.1 14.175 33.2 14.3 34.65 14.3H41.625C46.8973 14.3 51.4611 17.363 53.6234 21.8151Z"
        fill="url(#paint0_linear_162_257)"
      />
      <path
        d="M53.9534 26.8743C54.5043 26.8743 54.9515 27.3199 54.9534 27.8709L55 41.6249C55 48.9999 49 54.9999 41.625 54.9999H18.375C11 54.9999 5 48.9999 5 41.6249V27.8749C5 27.3226 5.44771 26.8749 5.99999 26.8749L53.9534 26.8743Z"
        fill="url(#paint1_linear_162_257)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_162_257"
          x1="9.5"
          y1="7.5"
          x2="30"
          y2="23"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D81E0" />
          <stop offset="1" stopColor="#48BBF6" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_162_257"
          x1="7"
          y1="26.9999"
          x2="49.5"
          y2="51.9999"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1E81E0" />
          <stop offset="1" stopColor="#49BCF7" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'file-blue': (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.475 5H19.525C10.425 5 5 10.425 5 19.525V40.45C5 49.575 10.425 55 19.525 55H40.45C49.55 55 54.975 49.575 54.975 40.475V19.525C55 10.425 49.575 5 40.475 5ZM42.5 43.125H17.5C16.475 43.125 15.625 42.275 15.625 41.25C15.625 40.225 16.475 39.375 17.5 39.375H42.5C43.525 39.375 44.375 40.225 44.375 41.25C44.375 42.275 43.525 43.125 42.5 43.125ZM42.5 31.875H17.5C16.475 31.875 15.625 31.025 15.625 30C15.625 28.975 16.475 28.125 17.5 28.125H42.5C43.525 28.125 44.375 28.975 44.375 30C44.375 31.025 43.525 31.875 42.5 31.875ZM42.5 20.625H17.5C16.475 20.625 15.625 19.775 15.625 18.75C15.625 17.725 16.475 16.875 17.5 16.875H42.5C43.525 16.875 44.375 17.725 44.375 18.75C44.375 19.775 43.525 20.625 42.5 20.625Z"
        fill="url(#paint0_linear_162_36)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_162_36"
          x1="9.5"
          y1="8"
          x2="48.5"
          y2="52"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1C80DF" />
          <stop offset="1" stopColor="#4ABEF7" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'image-blue': (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.45 47.525L6.4 47.575C5.725 46.1 5.3 44.425 5.125 42.575C5.3 44.4 5.775 46.05 6.45 47.525Z"
        fill="black"
      />
      <path
        d="M22.5 25.95C25.7861 25.95 28.45 23.2861 28.45 20C28.45 16.714 25.7861 14.05 22.5 14.05C19.2139 14.05 16.55 16.714 16.55 20C16.55 23.2861 19.2139 25.95 22.5 25.95Z"
        fill="url(#paint0_linear_162_286)"
      />
      <path
        d="M40.475 5H19.525C10.425 5 5 10.425 5 19.525V40.475C5 43.2 5.475 45.575 6.4 47.575C8.55 52.325 13.15 55 19.525 55H40.475C49.575 55 55 49.575 55 40.475V34.75V19.525C55 10.425 49.575 5 40.475 5ZM50.925 31.25C48.975 29.575 45.825 29.575 43.875 31.25L33.475 40.175C31.525 41.85 28.375 41.85 26.425 40.175L25.575 39.475C23.8 37.925 20.975 37.775 18.975 39.125L9.625 45.4C9.075 44 8.75 42.375 8.75 40.475V19.525C8.75 12.475 12.475 8.75 19.525 8.75H40.475C47.525 8.75 51.25 12.475 51.25 19.525V31.525L50.925 31.25Z"
        fill="url(#paint1_linear_162_286)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_162_286"
          x1="18.5"
          y1="15.5"
          x2="27.5"
          y2="24.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1D81DF" />
          <stop offset="1" stopColor="#4BBFF7" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_162_286"
          x1="9.5"
          y1="8"
          x2="50.5"
          y2="51.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B7FDE" />
          <stop offset="1" stopColor="#4DC2F8" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'video-blue': (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.475 5H19.525C10.425 5 5 10.425 5 19.525V40.45C5 49.575 10.425 55 19.525 55H40.45C49.55 55 54.975 49.575 54.975 40.475V19.525C55 10.425 49.575 5 40.475 5ZM36.65 34.325L33.45 36.175L30.25 38.025C26.125 40.4 22.75 38.45 22.75 33.7V30V26.3C22.75 21.525 26.125 19.6 30.25 21.975L33.45 23.825L36.65 25.675C40.775 28.05 40.775 31.95 36.65 34.325Z"
        fill="url(#paint0_linear_162_3)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_162_3"
          x1="9"
          y1="8.5"
          x2="52.5"
          y2="51"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#197DDD" />
          <stop offset="1" stopColor="#4EC4F8" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'document-blue': (
    <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M32.3775 50.0517C32.8492 50.1614 32.896 50.7884 32.439 50.9486C32.2222 51.0245 32.0009 51.0998 31.775 51.1751L27.825 52.4751C17.9 55.6751 12.675 53.0001 9.45 43.0751L6.25 33.2001C3.05 23.2751 5.7 18.0251 15.625 14.8251L18.459 13.8866C18.8619 13.7532 19.2436 14.1531 19.1075 14.5551C18.7869 15.5015 18.4993 16.5415 18.225 17.6751L15.775 28.1501C13.025 39.9251 17.05 46.4251 28.825 49.2251L32.3775 50.0517Z"
        fill="url(#paint0_linear_155_248)"
      />
      <path
        d="M42.925 8.02514L38.75 7.05014C30.4 5.07514 25.425 6.70014 22.5 12.7501C21.75 14.2751 21.15 16.1251 20.65 18.2501L18.2 28.7251C15.75 39.1751 18.975 44.3251 29.4 46.8001L33.6 47.8001C35.05 48.1501 36.4 48.3751 37.65 48.4751C45.45 49.2251 49.6 45.5751 51.7 36.5501L54.15 26.1001C56.6 15.6501 53.4 10.4751 42.925 8.02514ZM38.225 33.3251C38 34.1751 37.25 34.7251 36.4 34.7251C36.25 34.7251 36.1 34.7001 35.925 34.6751L28.65 32.8251C27.65 32.5751 27.05 31.5501 27.3 30.5501C27.55 29.5501 28.575 28.9501 29.575 29.2001L36.85 31.0501C37.875 31.3001 38.475 32.3251 38.225 33.3251ZM45.55 24.8751C45.325 25.7251 44.575 26.2751 43.725 26.2751C43.575 26.2751 43.425 26.2501 43.25 26.2251L31.125 23.1501C30.125 22.9001 29.525 21.8751 29.775 20.8751C30.025 19.8751 31.05 19.2751 32.05 19.5251L44.175 22.6001C45.2 22.8251 45.8 23.8501 45.55 24.8751Z"
        fill="url(#paint1_linear_155_248)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_155_248"
          x1="9.5"
          y1="18.5"
          x2="18"
          y2="53.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#2993E5" />
          <stop offset="1" stopColor="#47BAF5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_155_248"
          x1="27.5001"
          y1="6"
          x2="46.5001"
          y2="45.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1578DB" />
          <stop offset="1" stopColor="#4EC4F8" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'post-card': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM20 18H4V6H20V18ZM6 10H8V12H6V10ZM6 14H14V16H6V14ZM16 14H18V16H16V14ZM10 10H18V12H10V10Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'service-support': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 1C7.03 1 3 5.03 3 10V17C3 18.66 4.34 20 6 20H9V12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H15V20H19V21H12V23H18C19.66 23 21 21.66 21 20V10C21 5.03 16.97 1 12 1Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'img-file': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 19H5V14.42L5.99 15.41L9.99 11.41L13.99 15.41L17.99 11.42L19 12.43V19ZM19 9.59L17.99 8.58L13.99 12.59L9.99 8.59L5.99 12.59L5 11.59V5H19V9.59Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'manager-file': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 1H2V17H4V3H16V1ZM15 5L21 11V23H6V5H15ZM14 12H19.5L14 6.5V12Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'manager-video': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 6H20V8H4V6ZM6 2H18V4H6V2ZM20 10H4C2.9 10 2 10.9 2 12V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V12C22 10.9 21.1 10 20 10ZM20 20H4V12H20V20ZM10 12.73V19.26L16 16L10 12.73Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'manager-image': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 5H3V19H1V5ZM5 5H7V19H5V5ZM22 5H10C9.45 5 9 5.45 9 6V18C9 18.55 9.45 19 10 19H22C22.55 19 23 18.55 23 18V6C23 5.45 22.55 5 22 5ZM21 17H11V7H21V17ZM17.43 12.62L15.43 15.19L14 13.47L12 15.99H20L17.43 12.62Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'trashIcon-white': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16 9V19H8V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z"
        fill="#fff"
      />
    </svg>
  ),
  'Arrow-next-blue': (
    <svg
      fill="#40a9ff"
      height="8px"
      width="8px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.094 512.094"
    >
      <path
        d="M263.641,248.4L18.308,3.067c-4.16-4.053-10.987-3.947-15.04,0.32c-3.947,4.16-3.947,10.667,0,14.827l237.76,237.76
				L3.268,493.733c-4.267,4.053-4.373,10.88-0.213,15.04c4.16,4.16,10.88,4.373,15.04,0.213c0.107-0.107,0.213-0.213,0.213-0.213
				L263.641,263.44C267.801,259.28,267.801,252.56,263.641,248.4z"
      />
      <path
        d="M508.974,248.4L263.641,3.067c-4.267-4.053-10.987-3.947-15.04,0.213c-3.947,4.16-3.947,10.667,0,14.827l237.76,237.76
				l-237.76,237.867c-4.267,4.053-4.373,10.88-0.213,15.04c4.16,4.16,10.88,4.373,15.04,0.213c0.107-0.107,0.213-0.213,0.213-0.213
				L508.974,263.44C513.135,259.28,513.135,252.56,508.974,248.4z"
      />
    </svg>
  ),
  'Arrow-next': (
    <svg
      fill="#000000"
      height="8px"
      width="8px"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512.094 512.094"
    >
      <path
        d="M263.641,248.4L18.308,3.067c-4.16-4.053-10.987-3.947-15.04,0.32c-3.947,4.16-3.947,10.667,0,14.827l237.76,237.76
          L3.268,493.733c-4.267,4.053-4.373,10.88-0.213,15.04c4.16,4.16,10.88,4.373,15.04,0.213c0.107-0.107,0.213-0.213,0.213-0.213
          L263.641,263.44C267.801,259.28,267.801,252.56,263.641,248.4z"
      />
      <path
        d="M508.974,248.4L263.641,3.067c-4.267-4.053-10.987-3.947-15.04,0.213c-3.947,4.16-3.947,10.667,0,14.827l237.76,237.76
          l-237.76,237.867c-4.267,4.053-4.373,10.88-0.213,15.04c4.16,4.16,10.88,4.373,15.04,0.213c0.107-0.107,0.213-0.213,0.213-0.213
          L508.974,263.44C513.135,259.28,513.135,252.56,508.974,248.4z"
      />
    </svg>
  ),
  view: (
    <svg width="17" height="17" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 4.37402C3.75 4.37402 1.25 9.99963 1.25 9.99963C1.25 9.99963 3.75 15.624 10 15.624C16.25 15.624 18.75 9.99963 18.75 9.99963C18.75 9.99963 16.25 4.37402 10 4.37402Z"
        stroke="#777777"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 13.125C11.7259 13.125 13.125 11.7259 13.125 10C13.125 8.27411 11.7259 6.875 10 6.875C8.27411 6.875 6.875 8.27411 6.875 10C6.875 11.7259 8.27411 13.125 10 13.125Z"
        stroke="#777777"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  bell: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.39144 8.12495C4.3904 7.38371 4.53609 6.64959 4.8201 5.96491C5.1041 5.28024 5.52082 4.65854 6.04621 4.13567C6.57161 3.61279 7.19531 3.19907 7.88134 2.91837C8.56738 2.63766 9.30219 2.49551 10.0434 2.50011C13.1364 2.5231 15.6103 5.09396 15.6103 8.19557V8.74995C15.6103 11.548 16.1957 13.1717 16.7113 14.0592C16.7669 14.154 16.7964 14.2618 16.797 14.3717C16.7976 14.4816 16.7692 14.5897 16.7147 14.6851C16.6602 14.7805 16.5814 14.8599 16.4865 14.9151C16.3915 14.9704 16.2836 14.9997 16.1737 15H3.82742C3.71752 14.9997 3.60963 14.9704 3.51464 14.9151C3.41966 14.8598 3.34093 14.7805 3.28641 14.685C3.23189 14.5896 3.2035 14.4815 3.20411 14.3716C3.20472 14.2617 3.2343 14.1539 3.28987 14.059C3.80575 13.1716 4.39143 11.5479 4.39143 8.74995L4.39144 8.12495Z"
        stroke="#2160bd"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 15V15.625C7.5 16.288 7.76339 16.9239 8.23223 17.3928C8.70107 17.8616 9.33696 18.125 10 18.125C10.663 18.125 11.2989 17.8616 11.7678 17.3928C12.2366 16.9239 12.5 16.288 12.5 15.625V15"
        stroke="#2160bd"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'gitbranch-slide': (
    <svg
      width="130"
      height="132"
      viewBox="0 0 130 132"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7538 69.0241L32.53 33.5581C33.5044 30.8531 35.8555 28.879 38.6884 28.3873L75.8785 21.932C78.687 21.4445 81.5428 22.4882 83.375 24.6718L108.16 54.2099C109.993 56.3934 110.525 59.3867 109.557 62.0678L96.7462 97.5676C95.7702 100.272 93.4181 102.245 90.585 102.735L53.4342 109.162C50.627 109.648 47.7734 108.604 45.9421 106.421L21.152 76.8777C19.3208 74.6955 18.7883 71.7042 19.7538 69.0241Z"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M55.625 79.75C58.0412 79.75 60 77.7912 60 75.375C60 72.9588 58.0412 71 55.625 71C53.2088 71 51.25 72.9588 51.25 75.375C51.25 77.7912 53.2088 79.75 55.625 79.75Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M74.375 61C76.7912 61 78.75 59.0412 78.75 56.625C78.75 54.2088 76.7912 52.25 74.375 52.25C71.9588 52.25 70 54.2088 70 56.625C70 59.0412 71.9588 61 74.375 61Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.625 61C58.0412 61 60 59.0412 60 56.625C60 54.2088 58.0412 52.25 55.625 52.25C53.2088 52.25 51.25 54.2088 51.25 56.625C51.25 59.0412 53.2088 61 55.625 61Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.625 71V69.75C55.625 68.7554 56.0201 67.8017 56.7234 67.0984C57.4266 66.3952 58.3804 66.0001 59.3749 66.0001L70.6251 65.9999C71.6196 65.9999 72.5734 65.6048 73.2766 64.9016C73.9799 64.1983 74.375 63.2446 74.375 62.25V61"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.625 61V71"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'gear-slide': (
    <svg
      width="180"
      height="182"
      viewBox="0 0 180 182"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9239 97.6039L45.1697 44.1787C46.1441 41.4737 48.4952 39.4996 51.3281 39.0079L107.346 29.2845C110.155 28.797 113.011 29.8407 114.843 32.0243L152.1 76.4253C153.932 78.6088 154.464 81.6021 153.496 84.2832L134.2 137.756C133.224 140.46 130.872 142.433 128.038 142.923L72.0758 152.605C69.2686 153.09 66.415 152.047 64.5837 149.864L27.3221 105.458C25.491 103.275 24.9584 100.284 25.9239 97.6039Z"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M90 100.375C95.1777 100.375 99.375 96.1777 99.375 91C99.375 85.8223 95.1777 81.625 90 81.625C84.8223 81.625 80.625 85.8223 80.625 91C80.625 96.1777 84.8223 100.375 90 100.375Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M88.9991 74.6229L85.3137 71.8596C85.1159 71.7108 84.8857 71.6112 84.6419 71.5689C84.3981 71.5266 84.1477 71.5429 83.9114 71.6163C82.77 71.9737 81.6626 72.4319 80.6023 72.9854C80.3828 73.1006 80.1939 73.2662 80.051 73.4688C79.9082 73.6713 79.8156 73.9049 79.7808 74.1503L79.1293 78.7111C78.881 78.9312 78.6378 79.1602 78.3999 79.3979C78.1621 79.6358 77.9331 79.879 77.7129 80.1275L77.7128 80.1276L73.1529 80.7797C72.9079 80.8143 72.6746 80.9067 72.4723 81.0492C72.27 81.1917 72.1044 81.3802 71.9893 81.5992C71.4349 82.659 70.9759 83.7661 70.6175 84.9072C70.5437 85.1438 70.5273 85.3946 70.5695 85.6388C70.6117 85.883 70.7114 86.1137 70.8603 86.3118L73.6246 89.9974C73.6046 90.3287 73.5946 90.6625 73.5945 90.9989C73.5945 91.3352 73.6045 91.6691 73.6246 92.0006L73.6246 92.0007L70.8613 95.6861C70.7126 95.8839 70.6129 96.1141 70.5706 96.3579C70.5283 96.6017 70.5446 96.8521 70.618 97.0884C70.9754 98.2298 71.4336 99.3372 71.9871 100.397C72.1023 100.617 72.2679 100.806 72.4705 100.949C72.673 101.092 72.9067 101.184 73.1521 101.219L77.7128 101.87C77.9329 102.119 78.1619 102.362 78.3996 102.6C78.6375 102.838 78.8807 103.067 79.1292 103.287L79.1293 103.287L79.7814 107.847C79.816 108.092 79.9084 108.325 80.0509 108.528C80.1934 108.73 80.3819 108.895 80.6009 109.011C81.6607 109.565 82.7678 110.024 83.9089 110.382C84.1455 110.456 84.3963 110.473 84.6405 110.43C84.8847 110.388 85.1154 110.288 85.3135 110.139L88.9991 107.375C89.3304 107.395 89.6642 107.405 90.0006 107.405C90.3369 107.405 90.6708 107.395 91.0023 107.375L91.0024 107.375L94.6878 110.138C94.8856 110.287 95.1158 110.387 95.3596 110.429C95.6034 110.471 95.8538 110.455 96.0901 110.382C97.2315 110.024 98.3389 109.566 99.3992 109.013C99.6187 108.898 99.8076 108.732 99.9505 108.529C100.093 108.327 100.186 108.093 100.221 107.848L100.872 103.287C101.121 103.067 101.364 102.838 101.602 102.6C101.839 102.362 102.068 102.119 102.289 101.871L102.289 101.871L106.849 101.218C107.094 101.184 107.327 101.091 107.529 100.949C107.732 100.806 107.897 100.618 108.012 100.399C108.567 99.3391 109.026 98.232 109.384 97.0909C109.458 96.8543 109.474 96.6035 109.432 96.3593C109.39 96.1151 109.29 95.8844 109.141 95.6863L106.377 92.0007C106.397 91.6694 106.407 91.3356 106.407 90.9992C106.407 90.6629 106.397 90.329 106.377 89.9975L106.377 89.9974L109.14 86.312C109.289 86.1142 109.389 85.884 109.431 85.6402C109.473 85.3964 109.457 85.146 109.383 84.9097C109.026 83.7683 108.568 82.6609 108.014 81.6006C107.899 81.3811 107.734 81.1922 107.531 81.0493C107.328 80.9065 107.095 80.8139 106.849 80.7791L102.289 80.1276C102.069 79.8793 101.84 79.6361 101.602 79.3982C101.364 79.1604 101.121 78.9314 100.872 78.7112L100.872 78.7111L100.22 74.1512C100.185 73.9061 100.093 73.6729 99.9506 73.4706C99.8082 73.2683 99.6196 73.1027 99.4006 72.9876C98.3408 72.4332 97.2337 71.9742 96.0926 71.6158C95.856 71.542 95.6052 71.5255 95.361 71.5678C95.1168 71.61 94.8861 71.7097 94.688 71.8586L91.0024 74.6229C90.6711 74.6029 90.3373 74.5929 90.001 74.5928C89.6646 74.5928 89.3307 74.6028 88.9993 74.6229L88.9991 74.6229Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'users-slide': (
    <svg
      width="246"
      height="250"
      viewBox="0 0 246 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.0581 136.28L61.833 59.1789C62.8075 56.4739 65.1586 54.4998 67.9914 54.0081L148.832 39.9762C151.64 39.4887 154.496 40.5324 156.328 42.716L210.026 106.711C211.859 108.895 212.391 111.888 211.423 114.569L183.576 191.736C182.6 194.441 180.248 196.413 177.415 196.904L96.6517 210.876C93.8444 211.361 90.9908 210.317 89.1596 208.135L35.4563 144.134C33.6252 141.952 33.0927 138.96 34.0581 136.28Z"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M113.625 132.5C120.356 132.5 125.812 127.043 125.812 120.312C125.812 113.582 120.356 108.125 113.625 108.125C106.894 108.125 101.438 113.582 101.438 120.312C101.438 127.043 106.894 132.5 113.625 132.5Z"
        stroke="white"
        strokeWidth="4"
        strokeMiterlimit="10"
      />
      <path
        d="M129.425 108.58C131.101 108.108 132.859 108 134.581 108.264C136.302 108.529 137.947 109.159 139.404 110.112C140.861 111.066 142.097 112.321 143.029 113.792C143.96 115.264 144.566 116.918 144.804 118.643C145.043 120.368 144.909 122.124 144.412 123.793C143.914 125.462 143.065 127.005 141.921 128.318C140.777 129.632 139.365 130.684 137.78 131.406C136.195 132.127 134.473 132.501 132.732 132.501"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M96.75 141.265C98.6534 138.557 101.18 136.348 104.117 134.822C107.055 133.297 110.316 132.5 113.625 132.5C116.935 132.5 120.196 133.296 123.133 134.821C126.07 136.347 128.597 138.556 130.501 141.264"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M132.732 132.5C136.042 132.498 139.303 133.293 142.241 134.818C145.178 136.344 147.705 138.555 149.607 141.264"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'laptop-slide': (
    <svg
      width="246"
      height="250"
      viewBox="0 0 246 250"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.0581 136.28L61.833 59.1789C62.8075 56.4739 65.1586 54.4998 67.9914 54.0081L148.832 39.9762C151.64 39.4887 154.496 40.5324 156.328 42.716L210.026 106.711C211.859 108.895 212.391 111.888 211.423 114.569L183.576 191.736C182.6 194.441 180.248 196.413 177.415 196.904L96.6517 210.876C93.8444 211.361 90.9908 210.317 89.1596 208.135L35.4563 144.134C33.6252 141.952 33.0927 138.96 34.0581 136.28Z"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M102.375 136.25V111.875C102.375 110.88 102.77 109.927 103.473 109.223C104.177 108.52 105.13 108.125 106.125 108.125H139.875C140.87 108.125 141.823 108.52 142.527 109.223C143.23 109.927 143.625 110.88 143.625 111.875V136.25"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M98.625 136.25H147.375V140C147.375 140.995 146.98 141.948 146.277 142.652C145.573 143.355 144.62 143.75 143.625 143.75H102.375C101.38 143.75 100.427 143.355 99.7233 142.652C99.0201 141.948 98.625 140.995 98.625 140V136.25Z"
        fill="white"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M126.75 115.625H119.25"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'chartbar-slide': (
    <svg
      width="130"
      height="133"
      viewBox="0 0 130 133"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7538 70.0202L32.53 34.5542C33.5044 31.8492 35.8555 29.8751 38.6884 29.3834L75.8785 22.9281C78.687 22.4406 81.5428 23.4843 83.375 25.6679L108.16 55.206C109.993 57.3895 110.525 60.3828 109.557 63.0639L96.7462 98.5637C95.7702 101.268 93.4181 103.241 90.585 103.731L53.4342 110.158C50.627 110.644 47.7734 109.6 45.9421 107.418L21.152 77.8738C19.3208 75.6916 18.7883 72.7003 19.7538 70.0202Z"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M51.875 79.498V68.248H60.625"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M80.625 79.498H49.375"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.625 79.498V60.748H69.375"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M78.125 53.248H69.375V79.498H78.125V53.248Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'search-slide': (
    <svg
      width="180"
      height="183"
      viewBox="0 0 180 183"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M25.9239 98.6019L45.1697 45.1768C46.1442 42.4717 48.4952 40.4977 51.3281 40.006L107.346 30.2825C110.155 29.795 113.011 30.8387 114.843 33.0224L152.1 77.4234C153.932 79.6068 154.464 82.6002 153.496 85.2812L134.2 138.754C133.224 141.458 130.872 143.431 128.038 143.921L72.0758 153.603C69.2686 154.089 66.415 153.045 64.5837 150.862L27.3221 106.456C25.491 104.273 24.9584 101.282 25.9239 98.6019Z"
        stroke="white"
        strokeWidth="4"
      />
      <path
        d="M87.6562 106.062C96.7172 106.062 104.062 98.7172 104.062 89.6562C104.062 80.5953 96.7172 73.25 87.6562 73.25C78.5953 73.25 71.25 80.5953 71.25 89.6562C71.25 98.7172 78.5953 106.062 87.6562 106.062Z"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M99.2559 101.258L108.748 110.75"
        stroke="white"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'teacher-orange': (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M15 15.0026C16.8417 15.0026 18.3333 13.5109 18.3333 11.6693C18.3333 9.8276 16.8417 8.33594 15 8.33594C13.1583 8.33594 11.6667 9.8276 11.6667 11.6693C11.6667 13.5109 13.1583 15.0026 15 15.0026ZM15 16.6693C12.775 16.6693 8.33334 17.7859 8.33334 20.0026V20.8359C8.33334 21.2943 8.70834 21.6693 9.16668 21.6693H20.8333C21.2917 21.6693 21.6667 21.2943 21.6667 20.8359V20.0026C21.6667 17.7859 17.225 16.6693 15 16.6693Z"
        fill="white"
      />
    </svg>
  ),
  'book-orange': (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M22.5 9.16667C21.575 8.875 20.5583 8.75 19.5833 8.75C17.9583 8.75 16.2083 9.08333 15 10C13.7917 9.08333 12.0417 8.75 10.4167 8.75C8.79168 8.75 7.04168 9.08333 5.83334 10V22.2083C5.83334 22.4167 6.04168 22.625 6.25001 22.625C6.33334 22.625 6.37501 22.5833 6.45834 22.5833C7.58334 22.0417 9.20834 21.6667 10.4167 21.6667C12.0417 21.6667 13.7917 22 15 22.9167C16.125 22.2083 18.1667 21.6667 19.5833 21.6667C20.9583 21.6667 22.375 21.9167 23.5417 22.5417C23.625 22.5833 23.6667 22.5833 23.75 22.5833C23.9583 22.5833 24.1667 22.375 24.1667 22.1667V10C23.6667 9.625 23.125 9.375 22.5 9.16667ZM22.5 20.4167C21.5833 20.125 20.5833 20 19.5833 20C18.1667 20 16.125 20.5417 15 21.25V11.6667C16.125 10.9583 18.1667 10.4167 19.5833 10.4167C20.5833 10.4167 21.5833 10.5417 22.5 10.8333V20.4167Z"
        fill="white"
      />
      <path
        d="M19.5833 13.75C20.3167 13.75 21.025 13.825 21.6667 13.9667V12.7C21.0083 12.575 20.3 12.5 19.5833 12.5C18.1667 12.5 16.8833 12.7417 15.8333 13.1917V14.575C16.775 14.0417 18.0833 13.75 19.5833 13.75Z"
        fill="white"
      />
      <path
        d="M15.8333 15.4104V16.7937C16.775 16.2604 18.0833 15.9688 19.5833 15.9688C20.3167 15.9688 21.025 16.0438 21.6667 16.1854V14.9187C21.0083 14.7937 20.3 14.7188 19.5833 14.7188C18.1667 14.7188 16.8833 14.9687 15.8333 15.4104Z"
        fill="white"
      />
      <path
        d="M19.5833 16.9453C18.1667 16.9453 16.8833 17.187 15.8333 17.637V19.0203C16.775 18.487 18.0833 18.1953 19.5833 18.1953C20.3167 18.1953 21.025 18.2703 21.6667 18.412V17.1453C21.0083 17.012 20.3 16.9453 19.5833 16.9453Z"
        fill="white"
      />
    </svg>
  ),
  'student-orange': (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M18.75 14.9974C19.9 14.9974 20.825 14.0641 20.825 12.9141C20.825 11.7641 19.9 10.8307 18.75 10.8307C17.6 10.8307 16.6667 11.7641 16.6667 12.9141C16.6667 14.0641 17.6 14.9974 18.75 14.9974ZM12.5 14.1641C13.8833 14.1641 14.9917 13.0474 14.9917 11.6641C14.9917 10.2807 13.8833 9.16406 12.5 9.16406C11.1167 9.16406 9.99999 10.2807 9.99999 11.6641C9.99999 13.0474 11.1167 14.1641 12.5 14.1641ZM18.75 16.6641C17.225 16.6641 14.1667 17.4307 14.1667 18.9557V19.9974C14.1667 20.4557 14.5417 20.8307 15 20.8307H22.5C22.9583 20.8307 23.3333 20.4557 23.3333 19.9974V18.9557C23.3333 17.4307 20.275 16.6641 18.75 16.6641ZM12.5 15.8307C10.5583 15.8307 6.66666 16.8057 6.66666 18.7474V19.9974C6.66666 20.4557 7.04166 20.8307 7.49999 20.8307H12.5V18.9557C12.5 18.2474 12.775 17.0057 14.475 16.0641C13.75 15.9141 13.05 15.8307 12.5 15.8307Z"
        fill="white"
      />
    </svg>
  ),
  'register-orange': (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M17.5 15.0026C19.3417 15.0026 20.8333 13.5109 20.8333 11.6693C20.8333 9.8276 19.3417 8.33594 17.5 8.33594C15.6583 8.33594 14.1667 9.8276 14.1667 11.6693C14.1667 13.5109 15.6583 15.0026 17.5 15.0026ZM10 13.3359V11.6693C10 11.2109 9.62501 10.8359 9.16668 10.8359C8.70834 10.8359 8.33334 11.2109 8.33334 11.6693V13.3359H6.66668C6.20834 13.3359 5.83334 13.7109 5.83334 14.1693C5.83334 14.6276 6.20834 15.0026 6.66668 15.0026H8.33334V16.6693C8.33334 17.1276 8.70834 17.5026 9.16668 17.5026C9.62501 17.5026 10 17.1276 10 16.6693V15.0026H11.6667C12.125 15.0026 12.5 14.6276 12.5 14.1693C12.5 13.7109 12.125 13.3359 11.6667 13.3359H10ZM17.5 16.6693C15.275 16.6693 10.8333 17.7859 10.8333 20.0026V20.8359C10.8333 21.2943 11.2083 21.6693 11.6667 21.6693H23.3333C23.7917 21.6693 24.1667 21.2943 24.1667 20.8359V20.0026C24.1667 17.7859 19.725 16.6693 17.5 16.6693Z"
        fill="white"
      />
    </svg>
  ),
  'date-orange': (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M20.8333 8.33073H20V7.4974C20 7.03906 19.625 6.66406 19.1667 6.66406C18.7083 6.66406 18.3333 7.03906 18.3333 7.4974V8.33073H11.6667V7.4974C11.6667 7.03906 11.2917 6.66406 10.8333 6.66406C10.375 6.66406 10 7.03906 10 7.4974V8.33073H9.16667C8.24167 8.33073 7.50833 9.08073 7.50833 9.9974L7.5 21.6641C7.5 22.5807 8.24167 23.3307 9.16667 23.3307H20.8333C21.75 23.3307 22.5 22.5807 22.5 21.6641V9.9974C22.5 9.08073 21.75 8.33073 20.8333 8.33073ZM20.8333 20.8307C20.8333 21.2891 20.4583 21.6641 20 21.6641H10C9.54167 21.6641 9.16667 21.2891 9.16667 20.8307V12.4974H20.8333V20.8307ZM10.8333 14.1641H12.5V15.8307H10.8333V14.1641ZM14.1667 14.1641H15.8333V15.8307H14.1667V14.1641ZM17.5 14.1641H19.1667V15.8307H17.5V14.1641Z"
        fill="white"
      />
    </svg>
  ),
  'check-blu': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.14644 13.8282L7.49981 14.1815L7.85337 13.8283L16.0867 5.60334L16.0869 5.60316C16.2166 5.47342 16.425 5.47342 16.5548 5.60316C16.6845 5.7329 16.6845 5.94132 16.5548 6.07106L7.73811 14.8877C7.60837 15.0175 7.39995 15.0175 7.27021 14.8877L3.78688 11.4044C3.65714 11.2747 3.65714 11.0662 3.78688 10.9365C3.91662 10.8068 4.12503 10.8068 4.25477 10.9365L7.14644 13.8282Z"
        fill="#0D99FF"
        stroke="#0D99FF"
      />
    </svg>
  ),
  activity: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.38056 2.50136C8.74477 2.5221 9.05315 2.77732 9.14162 3.13123L11.8259 13.8683L13.3862 9.70741C13.5082 9.38215 13.8191 9.16668 14.1665 9.16668H17.4998C17.9601 9.16668 18.3332 9.53977 18.3332 10C18.3332 10.4602 17.9601 10.8333 17.4998 10.8333H14.744L12.4468 16.9593C12.3187 17.3009 11.9833 17.5194 11.6191 17.4987C11.2549 17.4779 10.9465 17.2227 10.8581 16.8688L8.17378 6.13171L6.61345 10.2926C6.49148 10.6179 6.18054 10.8333 5.83317 10.8333H2.49984C2.0396 10.8333 1.6665 10.4602 1.6665 10C1.6665 9.53977 2.0396 9.16668 2.49984 9.16668H5.25567L7.5529 3.04074C7.68099 2.69917 8.01635 2.48061 8.38056 2.50136Z"
        fill="#154398"
      />
    </svg>
  ),
  'reply-right': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.6667 7.50152V6.17652C11.6667 5.43485 12.5667 5.05985 13.0917 5.58485L16.9167 9.40985C17.2417 9.73485 17.2417 10.2599 16.9167 10.5849L13.0917 14.4099C12.5667 14.9349 11.6667 14.5682 11.6667 13.8265V12.4182C7.49998 12.4182 4.58332 13.7515 2.49998 16.6682C3.33332 12.5015 5.83332 8.33485 11.6667 7.50152Z"
        fill="#F88C00"
      />
    </svg>
  ),
  'mode-comment': (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3335 11.9454L12.5535 11.1654H2.66683V3.16536H13.3335V11.9454ZM13.3335 1.83203H2.66683C1.9335 1.83203 1.3335 2.43203 1.3335 3.16536V11.1654C1.3335 11.8987 1.9335 12.4987 2.66683 12.4987H12.0002L14.6668 15.1654V3.16536C14.6668 2.43203 14.0668 1.83203 13.3335 1.83203Z"
        fill="#777777"
      />
    </svg>
  ),
  'mic-orange': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 11.668C11.3833 11.668 12.5 10.5513 12.5 9.16797V4.16797C12.5 2.78464 11.3833 1.66797 10 1.66797C8.61668 1.66797 7.50001 2.78464 7.50001 4.16797V9.16797C7.50001 10.5513 8.61668 11.668 10 11.668ZM14.925 9.16797C14.5167 9.16797 14.175 9.46797 14.1083 9.8763C13.7667 11.8346 12.0583 13.3346 10 13.3346C7.94168 13.3346 6.23334 11.8346 5.89168 9.8763C5.82501 9.46797 5.48334 9.16797 5.07501 9.16797C4.56668 9.16797 4.16668 9.61797 4.24168 10.118C4.65001 12.618 6.65001 14.5763 9.16668 14.9346V16.668C9.16668 17.1263 9.54168 17.5013 10 17.5013C10.4583 17.5013 10.8333 17.1263 10.8333 16.668V14.9346C13.35 14.5763 15.35 12.618 15.7583 10.118C15.8417 9.61797 15.4333 9.16797 14.925 9.16797Z"
        fill="#F88C00"
      />
    </svg>
  ),
  'more-horiz': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 10C4.9 10 4 10.9 4 12C4 13.1 4.9 14 6 14C7.1 14 8 13.1 8 12C8 10.9 7.1 10 6 10ZM18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12C20 10.9 19.1 10 18 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z"
        fill="#777777"
      />
    </svg>
  ),
  like: (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.752433 9.66386H5.87347C6.28712 9.66386 6.6259 10.056 6.6259 10.537V22.13C6.6259 22.6088 6.28712 23.0031 5.87347 23.0031H0.752433C0.338782 23.0031 0 22.611 0 22.13V10.537C0 10.056 0.338782 9.66386 0.752433 9.66386ZM11.8031 0.967462C12.1999 -1.36154 15.4941 0.783308 15.7112 4.53788C15.7768 5.68613 15.6738 7.02287 15.4305 8.5156H20.1379C22.0957 8.60443 23.8046 10.2272 22.5973 12.892C22.8725 14.0532 22.9136 15.416 22.1668 15.9533C22.2604 17.7861 21.8224 18.9214 21.0026 19.8183C20.9483 20.7348 20.7799 21.5494 20.398 22.1755C19.7654 23.2089 19.2525 22.9619 18.2568 22.9619H10.3076C9.04791 22.9619 8.36099 22.5611 7.53743 21.3652V11.1176C9.90703 10.3766 11.1667 6.62423 11.8031 4.16091V0.967462Z"
        fill="white"
      />
    </svg>
  ),
  liked: (
    <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.752433 9.66386H5.87347C6.28712 9.66386 6.6259 10.056 6.6259 10.537V22.13C6.6259 22.6088 6.28712 23.0031 5.87347 23.0031H0.752433C0.338782 23.0031 0 22.611 0 22.13V10.537C0 10.056 0.338782 9.66386 0.752433 9.66386ZM11.8031 0.967462C12.1999 -1.36154 15.4941 0.783308 15.7112 4.53788C15.7768 5.68613 15.6738 7.02287 15.4305 8.5156H20.1379C22.0957 8.60443 23.8046 10.2272 22.5973 12.892C22.8725 14.0532 22.9136 15.416 22.1668 15.9533C22.2604 17.7861 21.8224 18.9214 21.0026 19.8183C20.9483 20.7348 20.7799 21.5494 20.398 22.1755C19.7654 23.2089 19.2525 22.9619 18.2568 22.9619H10.3076C9.04791 22.9619 8.36099 22.5611 7.53743 21.3652V11.1176C9.90703 10.3766 11.1667 6.62423 11.8031 4.16091V0.967462Z"
        fill="#0870EA"
      />
    </svg>
  ),
  'arrow-bend-down': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11 6.5L14 9.5L11 12.5"
        stroke="#666666"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 3.5C2 5.0913 2.63214 6.61742 3.75736 7.74264C4.88258 8.86786 6.4087 9.5 8 9.5H14"
        stroke="#666666"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'react-like-fb': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.81871 7.0625C1.58137 7.0625 1.33337 8.57249 1.33337 8.83183V12.3292C1.33337 12.5892 1.58071 14.0985 2.81871 14.0985H2.8927C3.21404 14.09 3.51936 13.9563 3.74353 13.7259C3.9677 13.4955 4.093 13.1866 4.09271 12.8652V8.29783C4.09317 7.97626 3.96794 7.66723 3.74375 7.43669C3.51957 7.20615 3.21416 7.07234 2.8927 7.06382L2.81871 7.0625Z"
        stroke="#777777"
        strokeWidth="1.5"
      />
      <path
        d="M11.5572 5.97116C11.1033 5.952 10.6485 5.97163 10.1979 6.02983C10.4674 5.61996 10.6229 5.14568 10.6483 4.65579C10.6737 4.1659 10.5682 3.67807 10.3426 3.2425C10.1589 2.74624 9.79555 2.33703 9.32455 2.09583C9.19372 2.02936 9.0484 1.99652 8.9017 2.00029C8.755 2.00407 8.61156 2.04433 8.48432 2.11744C8.35709 2.19055 8.25007 2.29421 8.17294 2.41905C8.09581 2.5439 8.051 2.68598 8.04255 2.83249C8.03485 3.18644 8.05537 3.54046 8.10389 3.89116C8.29589 4.83516 7.95787 5.21715 7.21654 5.83249C7.21654 5.83249 5.80587 7.0485 5.80587 8.03783C5.80587 8.6585 5.78055 9.20316 5.81855 11.5605C5.85655 13.9178 9.27855 13.5212 11.4132 13.4065C11.8875 13.4067 12.3537 13.284 12.7665 13.0505C14.4005 12.3425 14.5432 10.4718 14.5432 7.98983C14.5432 5.50783 11.5572 5.97116 11.5572 5.97116Z"
        stroke="#777777"
        strokeWidth="1.5"
      />
    </svg>
  ),
  'arrow-back-red': (
    <svg width="7" height="20" viewBox="0 0 7 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.25833 13.2331L2.02499 9.99974L5.25833 6.76641C5.58333 6.44141 5.58333 5.91641 5.25833 5.59141C4.93333 5.26641 4.40833 5.26641 4.08333 5.59141L0.258325 9.41641C-0.0666752 9.74141 -0.0666752 10.2664 0.258325 10.5914L4.08333 14.4164C4.40833 14.7414 4.93333 14.7414 5.25833 14.4164C5.57499 14.0914 5.58333 13.5581 5.25833 13.2331Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'pen-red': (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.37333 6.51333L9.98667 7.12667L3.94667 13.1667H3.33333V12.5533L9.37333 6.51333ZM11.7733 2.5C11.6067 2.5 11.4333 2.56667 11.3067 2.69333L10.0867 3.91333L12.5867 6.41333L13.8067 5.19333C14.0667 4.93333 14.0667 4.51333 13.8067 4.25333L12.2467 2.69333C12.1133 2.56 11.9467 2.5 11.7733 2.5ZM9.37333 4.62667L2 12V14.5H4.5L11.8733 7.12667L9.37333 4.62667Z"
        fill="#ED1117"
      />
    </svg>
  ),
  fall: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.9289 4.4601V5.53153C13.9289 5.62944 13.8488 5.70954 13.7509 5.70954H5.17946C5.08155 5.70954 5.00145 5.62944 5.00145 5.53153V4.4601C5.00145 4.36219 5.08155 4.28209 5.17946 4.28209H13.7509C13.8488 4.28209 13.9289 4.36219 13.9289 4.4601ZM5.00145 7.67439C5.00145 7.57648 5.08155 7.49637 5.17946 7.49637H9.2866C9.38451 7.49637 9.46462 7.57648 9.46462 7.67439V8.74582C9.46462 8.84372 9.38451 8.92383 9.2866 8.92383H5.17946C5.08155 8.92383 5.00145 8.84372 5.00145 8.74582V7.67439ZM8.75145 14.9065C8.75145 12.2439 10.9097 10.0857 13.5723 10.0857C16.235 10.0857 18.3932 12.2439 18.3932 14.9065C18.3932 17.5692 16.235 19.7274 13.5723 19.7274C10.9097 19.7274 8.75145 17.5692 8.75145 14.9065ZM13.5723 18.2999C14.4787 18.2999 15.3315 17.9472 15.9723 17.3065C16.613 16.6657 16.9657 15.8129 16.9657 14.9065C16.9657 14.0001 16.613 13.1473 15.9723 12.5066C15.3315 11.8659 14.4787 11.5131 13.5723 11.5131C12.6659 11.5131 11.8131 11.8659 11.1724 12.5066C10.5316 13.1473 10.1789 14.0001 10.1789 14.9065C10.1789 15.8129 10.5316 16.6657 11.1724 17.3065C11.8131 17.9472 12.6659 18.2999 13.5723 18.2999ZM3.21518 17.5851V17.5857H8.39375C8.49165 17.5857 8.57176 17.6658 8.57176 17.7637V19.0137C8.57176 19.1116 8.49165 19.1917 8.39375 19.1917H2.32232C1.92754 19.1917 1.60859 18.8727 1.60859 18.478V0.977958C1.60859 0.583176 1.92754 0.26423 2.32232 0.26423H16.608C17.0028 0.26423 17.3218 0.583176 17.3218 0.977958V9.54939C17.3218 9.64729 17.2417 9.7274 17.1437 9.7274H15.8937C15.7958 9.7274 15.7157 9.64729 15.7157 9.54939V1.87081H15.7152V1.87026H3.21518V1.87081H3.21462V17.5851H3.21518Z"
        fill="#ED1117"
        stroke="#ED1117"
        strokeWidth="0.00111607"
      />
      <path
        d="M14.4004 13.3008C14.4628 13.2383 14.5641 13.2383 14.6266 13.3008L15.2842 13.9584C15.3467 14.0209 15.3467 14.1222 15.2842 14.1847L12.6821 16.7868C12.6196 16.8493 12.5183 16.8493 12.4558 16.7868L11.7982 16.1292C11.7357 16.0667 11.7357 15.9654 11.7982 15.9029L14.4004 13.3008Z"
        fill="#ED1117"
      />
      <path
        d="M11.7982 14.1847C11.7357 14.1222 11.7357 14.0209 11.7982 13.9584L12.4558 13.3008C12.5183 13.2383 12.6196 13.2383 12.6821 13.3008L15.2842 15.9029C15.3467 15.9654 15.3467 16.0667 15.2842 16.1292L14.6266 16.7868C14.5641 16.8493 14.4628 16.8493 14.4004 16.7868L11.7982 14.1847Z"
        fill="#ED1117"
      />
    </svg>
  ),
  elect: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.0076 15.2436L13.008 15.2433L13.009 15.2425L14.4254 13.2841L14.425 13.2838L14.4255 13.2841C14.4588 13.2374 14.5122 13.2107 14.5701 13.2107H15.5589C15.7036 13.2107 15.7881 13.3753 15.7013 13.4933L13.1522 17.02C13.081 17.1179 12.9364 17.1179 12.8652 17.02L11.2179 14.741C11.1333 14.6231 11.2179 14.4584 11.3625 14.4584H12.3469C12.3751 14.4582 12.403 14.4647 12.4281 14.4775C12.4533 14.4903 12.475 14.5089 12.4915 14.5319L13.0071 15.2439L13.0076 15.2436ZM13.9289 4.4601V5.53153C13.9289 5.62944 13.8488 5.70954 13.7509 5.70954H5.17946C5.08155 5.70954 5.00145 5.62944 5.00145 5.53153V4.4601C5.00145 4.36219 5.08155 4.28209 5.17946 4.28209H13.7509C13.8488 4.28209 13.9289 4.36219 13.9289 4.4601ZM5.00145 7.67439C5.00145 7.57648 5.08155 7.49637 5.17946 7.49637H9.2866C9.38451 7.49637 9.46462 7.57648 9.46462 7.67439V8.74582C9.46462 8.84372 9.38451 8.92383 9.2866 8.92383H5.17946C5.08155 8.92383 5.00145 8.84372 5.00145 8.74582V7.67439ZM8.75145 14.9065C8.75145 12.2439 10.9097 10.0857 13.5723 10.0857C16.235 10.0857 18.3932 12.2439 18.3932 14.9065C18.3932 17.5692 16.235 19.7274 13.5723 19.7274C10.9097 19.7274 8.75145 17.5692 8.75145 14.9065ZM13.5723 18.2999C14.4787 18.2999 15.3315 17.9472 15.9723 17.3065C16.613 16.6657 16.9657 15.8129 16.9657 14.9065C16.9657 14.0001 16.613 13.1473 15.9723 12.5066C15.3315 11.8659 14.4787 11.5131 13.5723 11.5131C12.6659 11.5131 11.8131 11.8659 11.1724 12.5066C10.5316 13.1473 10.1789 14.0001 10.1789 14.9065C10.1789 15.8129 10.5316 16.6657 11.1724 17.3065C11.8131 17.9472 12.6659 18.2999 13.5723 18.2999ZM3.21518 17.5851V17.5857H8.39375C8.49165 17.5857 8.57176 17.6658 8.57176 17.7637V19.0137C8.57176 19.1116 8.49165 19.1917 8.39375 19.1917H2.32232C1.92754 19.1917 1.60859 18.8727 1.60859 18.478V0.977958C1.60859 0.583176 1.92754 0.26423 2.32232 0.26423H16.608C17.0028 0.26423 17.3218 0.583176 17.3218 0.977958V9.54939C17.3218 9.64729 17.2417 9.7274 17.1437 9.7274H15.8937C15.7958 9.7274 15.7157 9.64729 15.7157 9.54939V1.87081H15.7152V1.87026H3.21518V1.87081H3.21462V17.5851H3.21518Z"
        fill="#0D99FF"
        stroke="#0D99FF"
        strokeWidth="0.00111607"
      />
    </svg>
  ),
  'shopping-bag': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.3334 7.63987H14.3417L10.6917 2.42747C10.5334 2.20499 10.2667 2.09375 10 2.09375C9.73337 2.09375 9.46671 2.20499 9.30837 2.43542L5.65837 7.63987H1.66671C1.20837 7.63987 0.833374 7.99743 0.833374 8.43445C0.833374 8.50596 0.841707 8.57747 0.866707 8.64898L2.98337 16.0147C3.17504 16.6821 3.81671 17.1748 4.58337 17.1748H15.4167C16.1834 17.1748 16.825 16.6821 17.025 16.0147L19.1417 8.64898L19.1667 8.43445C19.1667 7.99743 18.7917 7.63987 18.3334 7.63987ZM10 4.30266L12.3334 7.63987H7.66671L10 4.30266ZM15.4167 15.5856L4.59171 15.5936L2.75837 9.22902H17.25L15.4167 15.5856ZM10 10.8182C9.08337 10.8182 8.33337 11.5333 8.33337 12.4073C8.33337 13.2813 9.08337 13.9965 10 13.9965C10.9167 13.9965 11.6667 13.2813 11.6667 12.4073C11.6667 11.5333 10.9167 10.8182 10 10.8182Z"
        fill="#212529"
      />
    </svg>
  ),
  'login-facebook': (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_2296_73794)" />
      <path
        d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_2296_73794"
          x1="16"
          y1="2"
          x2="16"
          y2="29.917"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18ACFE" />
          <stop offset="1" stopColor="#0163E0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'login-google': (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M30.0014 16.3114C30.0014 15.1603 29.9061 14.3203 29.6998 13.4492H16.2871V18.6447H24.1601C24.0014 19.9359 23.1442 21.8803 21.2394 23.1869L21.2127 23.3609L25.4536 26.5805L25.7474 26.6092C28.4458 24.167 30.0014 20.5736 30.0014 16.3114Z"
        fill="#4285F4"
      />
      <path
        d="M16.2863 30.0008C20.1434 30.0008 23.3814 28.7562 25.7466 26.6096L21.2386 23.1873C20.0323 24.0117 18.4132 24.5873 16.2863 24.5873C12.5086 24.5873 9.30225 22.1451 8.15929 18.7695L7.99176 18.7835L3.58208 22.128L3.52441 22.2851C5.87359 26.8584 10.699 30.0008 16.2863 30.0008Z"
        fill="#34A853"
      />
      <path
        d="M8.15964 18.7699C7.85806 17.8988 7.68352 16.9654 7.68352 16.001C7.68352 15.0365 7.85806 14.1032 8.14377 13.2321L8.13578 13.0466L3.67083 9.64844L3.52475 9.71653C2.55654 11.6143 2.00098 13.7455 2.00098 16.001C2.00098 18.2566 2.55654 20.3876 3.52475 22.2854L8.15964 18.7699Z"
        fill="#FBBC05"
      />
      <path
        d="M16.2864 7.4133C18.9689 7.4133 20.7784 8.54885 21.8102 9.4978L25.8419 5.64C23.3658 3.38445 20.1435 2 16.2864 2C10.699 2 5.8736 5.1422 3.52441 9.71549L8.14345 13.2311C9.30229 9.85555 12.5086 7.4133 16.2864 7.4133Z"
        fill="#EB4335"
      />
    </svg>
  ),
  info: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  'dot-black': (
    <svg width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2" r="2" fill="#212529" />
    </svg>
  ),
  'person-seminar': (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99992 5.50004C10.9166 5.50004 11.6666 6.25004 11.6666 7.16671C11.6666 8.08337 10.9166 8.83337 9.99992 8.83337C9.08325 8.83337 8.33325 8.08337 8.33325 7.16671C8.33325 6.25004 9.08325 5.50004 9.99992 5.50004ZM9.99992 13.8334C12.2499 13.8334 14.8333 14.9084 14.9999 15.5H4.99992C5.19159 14.9 7.75825 13.8334 9.99992 13.8334ZM9.99992 3.83337C8.15825 3.83337 6.66659 5.32504 6.66659 7.16671C6.66659 9.00837 8.15825 10.5 9.99992 10.5C11.8416 10.5 13.3333 9.00837 13.3333 7.16671C13.3333 5.32504 11.8416 3.83337 9.99992 3.83337ZM9.99992 12.1667C7.77492 12.1667 3.33325 13.2834 3.33325 15.5V17.1667H16.6666V15.5C16.6666 13.2834 12.2249 12.1667 9.99992 12.1667Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'edit-seminar': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#00AEAC"
      />
    </svg>
  ),
  reply: (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.83335 7.50152V6.17652C8.83335 5.43485 7.93335 5.05985 7.40835 5.58485L3.58335 9.40985C3.25835 9.73485 3.25835 10.2599 3.58335 10.5849L7.40835 14.4099C7.93335 14.9349 8.83335 14.5682 8.83335 13.8265V12.4182C13 12.4182 15.9167 13.7515 18 16.6682C17.1667 12.5015 14.6667 8.33485 8.83335 7.50152Z"
        fill="#F88C00"
      />
    </svg>
  ),
  'ellipe-blue': (
    <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2.5" r="2" fill="#0D99FF" />
    </svg>
  ),
  ellipe: (
    <svg width="4" height="5" viewBox="0 0 4 5" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="2" cy="2.5" r="2" fill="#212529" />
    </svg>
  ),
  status_order_1: (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10 12H26"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 16L26 16"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 20L26 20"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 31V5.875C4.5 5.57663 4.61853 5.29048 4.82951 5.07951C5.04048 4.86853 5.32663 4.75 5.625 4.75H30.375C30.6734 4.75 30.9595 4.86853 31.1705 5.07951C31.3815 5.29048 31.5 5.57663 31.5 5.875V31L26.5 27L22 31L17.5 27L13 31L8.5 27L4.5 31Z"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  status_order_2: (
    <svg width="31" height="34" viewBox="0 0 31 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.871 0C19.0599 0 19.2362 0.0541495 19.3851 0.147822C19.4462 0.186162 19.5032 0.231446 19.5551 0.283306L26.522 7.2502C26.7033 7.43149 26.8051 7.67734 26.8051 7.93368V14.9877C26.8051 15.5216 26.3723 15.9543 25.8384 15.9543C25.3045 15.9543 24.8718 15.5216 24.8718 14.9877V8.90018H18.871C18.3372 8.90018 17.9044 8.46742 17.9044 7.93354V1.9335H1.93328V31.9782H13.8554C14.3892 31.9782 14.8221 32.4109 14.8221 32.9448C14.8221 33.4787 14.3892 33.9114 13.8554 33.9114H0.966638C0.432752 33.9114 0 33.4787 0 32.9448V0.966861C0 0.432975 0.432752 0.000146539 0.966638 0.000146539H18.8528L18.871 0ZM19.8377 6.9669V3.30002L23.5045 6.9669H19.8377ZM7.79414 10.9378C7.26032 10.9378 6.8275 11.3706 6.8275 11.9045C6.8275 12.4384 7.26032 12.8711 7.79414 12.8711H18.3141C18.848 12.8711 19.2808 12.4384 19.2808 11.9045C19.2808 11.3706 18.848 10.9378 18.3141 10.9378H7.79414ZM3.71822 16.3633C3.71822 15.8294 4.15097 15.3966 4.68486 15.3966H14.8218C15.3557 15.3966 15.7885 15.8294 15.7885 16.3633C15.7885 16.8972 15.3557 17.3299 14.8218 17.3299H4.68486C4.15097 17.3299 3.71822 16.8972 3.71822 16.3633ZM5.00702 19.8555C4.47314 19.8555 4.04038 20.2882 4.04038 20.8221C4.04038 21.356 4.47314 21.7887 5.00702 21.7887H11.0857C11.6195 21.7887 12.0523 21.356 12.0523 20.8221C12.0523 20.2882 11.6195 19.8555 11.0857 19.8555H5.00702ZM4.04038 25.2809C4.04038 24.747 4.47314 24.3143 5.00702 24.3143H10.18C10.7138 24.3143 11.1466 24.747 11.1466 25.2809C11.1466 25.8148 10.7138 26.2475 10.18 26.2475H5.00702C4.47314 26.2475 4.04038 25.8148 4.04038 25.2809ZM14.2644 25.0023C14.2644 21.1113 17.4186 17.957 21.3097 17.957C25.2006 17.957 28.3549 21.1113 28.3549 25.0023C28.3549 28.8933 25.2006 32.0475 21.3097 32.0475C17.4186 32.0475 14.2644 28.8933 14.2644 25.0023ZM21.3097 16.0238C16.3509 16.0238 12.331 20.0435 12.331 25.0023C12.331 29.961 16.3509 33.9809 21.3097 33.9809C26.2684 33.9809 30.2882 29.961 30.2882 25.0023C30.2882 20.0435 26.2684 16.0238 21.3097 16.0238Z"
        fill="#154398"
      />
      <path
        d="M21.2652 24.4158C23.0414 24.4158 24.4874 25.7011 24.4874 27.28C24.4874 28.61 23.4562 29.7217 22.0707 30.0421V30.7707C22.0707 31.2156 21.7101 31.5762 21.2652 31.5762C20.8203 31.5762 20.4596 31.2156 20.4596 30.7707V30.0421C19.3607 29.7879 18.4847 29.036 18.1694 28.0722C18.031 27.6494 18.4036 27.28 18.8486 27.28C19.2934 27.28 19.6414 27.6706 19.8968 28.0349C20.1814 28.4411 20.6885 28.712 21.2652 28.712C22.1533 28.712 22.8762 28.0694 22.8762 27.28C22.8762 26.4905 22.1533 25.8479 21.2652 25.8479C19.489 25.8479 18.043 24.5626 18.043 22.9837C18.043 21.6537 19.0741 20.542 20.4596 20.2216V19.493C20.4596 19.0482 20.8203 18.6875 21.2652 18.6875C21.7101 18.6875 22.0707 19.0482 22.0707 19.493V20.2216C23.1697 20.4758 24.0456 21.2277 24.361 22.1915C24.4993 22.6143 24.1267 22.9837 23.6818 22.9837C23.2369 22.9837 22.8889 22.5931 22.6336 22.2288C22.3489 21.8226 21.8419 21.5517 21.2652 21.5517C20.377 21.5517 19.6541 22.1943 19.6541 22.9837C19.6541 23.7732 20.377 24.4158 21.2652 24.4158Z"
        fill="#154398"
      />
    </svg>
  ),
  status_order_3: (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1872_78335)">
        <path
          d="M28.7989 17.1729L14.5612 2.9352C14.7748 2.60565 14.7381 2.15405 14.4513 1.86111C14.1157 1.52546 13.5725 1.52546 13.2369 1.86111L3.47244 11.6255C3.13679 11.9612 3.13679 12.5043 3.47244 12.84C3.77148 13.139 4.16205 13.1878 4.54653 12.9498L18.7843 27.1876C20.9141 29.3174 25.1494 30.837 28.7989 27.1876C32.485 23.5015 30.8738 19.2479 28.7989 17.1729ZM5.77318 11.7476L13.365 4.16185L23.5017 14.2985H8.32413L5.77318 11.7476ZM27.5905 25.9731C24.9725 28.5912 21.4756 27.45 20.0048 25.9731L10.039 16.0134H25.2166L27.5905 18.3874C29.1223 19.9192 30.2452 23.3184 27.5905 25.9731Z"
          fill="#154398"
        />
        <path
          d="M4.74184 18.7475C4.57097 18.54 4.32075 18.418 4.05833 18.418C3.78981 18.418 3.5396 18.54 3.38093 18.7536C2.81337 19.486 0 23.2453 0 25.2042C0 27.4378 1.81862 29.2626 4.05833 29.2626C6.29194 29.2626 8.11667 27.4439 8.11667 25.2042C8.11667 23.2453 5.3033 19.486 4.74184 18.7475ZM4.05833 27.5477C2.77065 27.5477 1.72098 26.498 1.72098 25.2103C1.72098 24.3682 2.93543 22.3298 4.06444 20.7309C5.19345 22.3359 6.40179 24.3682 6.40179 25.2103C6.39569 26.498 5.34602 27.5477 4.05833 27.5477Z"
          fill="#154398"
        />
      </g>
      <defs>
        <clipPath id="clip0_1872_78335">
          <rect width="31" height="31" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  status_order_4: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1872_78348)">
        <path
          d="M24.5508 4.79297C25.1836 5.42578 25.9746 5.0625 26.2441 4.79297C26.6602 4.37695 26.7539 3.60937 26.2441 3.09961L24.1641 1.01953C23.6953 0.550781 22.9395 0.550781 22.4707 1.01953C22.002 1.48828 22.002 2.24414 22.4707 2.71289L24.5508 4.79297Z"
          fill="#154398"
        />
        <path
          d="M28.1309 26.9902H19.4004C19.7227 26.7324 20.0273 26.457 20.3262 26.1641C24.4102 22.0801 24.6035 15.5527 20.9004 11.2344L24.1875 7.94727C24.6562 7.47852 24.6562 6.72266 24.1875 6.25391L21.0117 3.07812C20.543 2.60938 19.7871 2.60938 19.3184 3.07812L10.7812 11.6152C10.3125 12.084 10.3125 12.8398 10.7812 13.3086L11.5254 14.0527L10.5996 14.9785C10.1309 15.4473 10.1309 16.2031 10.5996 16.6719C11.0684 17.1406 11.8242 17.1406 12.293 16.6719L13.2188 15.7461L13.9629 16.4902C14.666 17.1465 15.4336 16.7363 15.6563 16.4902L19.207 12.9395C21.9785 16.3145 21.791 21.3242 18.6387 24.4766C16.9629 26.1523 14.7363 27.0371 12.3574 26.9961C12.3457 26.9961 12.3398 26.9961 12.3281 26.9961C12.3105 26.9961 12.2988 26.9961 12.2812 26.9961H8.90625V23.5391H10.6582C11.3203 23.5391 11.8535 23.0059 11.8535 22.3437C11.8535 21.6816 11.3203 21.1484 10.6582 21.1484H4.75195C4.08984 21.1484 3.55664 21.6816 3.55664 22.3437C3.55664 23.0059 4.08984 23.5391 4.75195 23.5391H6.50391V26.9961H1.81641C1.1543 26.9961 0.621094 27.5293 0.621094 28.1914C0.621094 28.8535 1.1543 29.3867 1.81641 29.3867H28.1367C28.7988 29.3867 29.332 28.8535 29.332 28.1914C29.332 27.5293 28.793 26.9902 28.1309 26.9902V26.9902ZM14.8008 13.9473L13.3184 12.4648L20.1621 5.61523L21.6445 7.09766L14.8008 13.9473V13.9473Z"
          fill="#154398"
        />
      </g>
      <defs>
        <clipPath id="clip0_1872_78348">
          <rect width="30" height="30" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  status_order_5: (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.23423 27.2986H14.1148C13.4494 26.7335 12.8844 26.0555 12.47 25.2771H7.34722C6.054 25.2771 5.36341 24.6116 5.36341 23.356V4.3591C5.36341 3.11608 6.04141 2.40042 7.34722 2.40042H20.468C21.7236 2.40042 22.4393 3.10355 22.4393 4.3591V15.3078C23.2178 15.7221 23.8958 16.2746 24.4608 16.94V4.32144C24.4608 1.69725 23.1676 0.378906 20.5685 0.378906H7.23423C4.64775 0.378906 3.34195 1.70983 3.34195 4.32144V23.3686C3.34195 25.9927 4.64775 27.2986 7.23423 27.2986ZM9.15525 7.52319H18.6726C19.112 7.52319 19.451 7.1716 19.451 6.73216C19.451 6.30525 19.112 5.97878 18.6726 5.97878H9.15525C8.69073 5.97878 8.36427 6.30525 8.36427 6.73216C8.36427 7.1716 8.69073 7.52319 9.15525 7.52319ZM9.15525 11.9051H18.6726C19.112 11.9051 19.451 11.5536 19.451 11.1141C19.451 10.6872 19.112 10.3608 18.6726 10.3608H9.15525C8.69073 10.3608 8.36427 10.6872 8.36427 11.1141C8.36427 11.5536 8.69073 11.9051 9.15525 11.9051ZM18.8232 27.2986C19.9533 27.2986 21.0205 26.9721 21.8994 26.382L24.7245 29.2196C25.0258 29.5084 25.3021 29.6214 25.6411 29.6214C26.2186 29.6214 26.6581 29.1694 26.6581 28.529C26.6581 28.2528 26.52 27.9766 26.3066 27.7631L23.4438 24.9004C24.0841 23.9838 24.4608 22.8664 24.4608 21.661C24.4608 18.5346 21.9371 16.0109 18.8232 16.0109C15.7094 16.0109 13.1606 18.5597 13.1606 21.661C13.1606 24.7749 15.7094 27.2986 18.8232 27.2986ZM18.8232 25.5031C16.6888 25.5031 14.9561 23.7829 14.9561 21.661C14.9561 19.5642 16.6888 17.8189 18.8232 17.8189C20.9201 17.8189 22.6527 19.5642 22.6527 21.661C22.6527 23.7829 20.9326 25.5031 18.8232 25.5031Z"
        fill="#154398"
      />
    </svg>
  ),
  status_order_6: (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.6203 26.8218L25.7128 31.3153C26.6194 31.8897 27.745 31.0354 27.476 29.9771L25.4268 21.9162C25.3691 21.6916 25.3759 21.4554 25.4465 21.2346C25.5171 21.0138 25.6486 20.8174 25.8258 20.668L32.1859 15.3744C33.0216 14.6788 32.5903 13.2919 31.5166 13.2222L23.2107 12.6832C22.987 12.6672 22.7724 12.588 22.592 12.4548C22.4115 12.3216 22.2727 12.1398 22.1915 11.9307L19.0938 4.12984C19.0096 3.90792 18.8598 3.71685 18.6645 3.58203C18.4691 3.44721 18.2374 3.375 18 3.375C17.7626 3.375 17.5309 3.44721 17.3355 3.58203C17.1402 3.71685 16.9904 3.90792 16.9062 4.12984L13.8085 11.9307C13.7273 12.1398 13.5885 12.3216 13.408 12.4548C13.2276 12.588 13.013 12.6672 12.7893 12.6832L4.48341 13.2222C3.40972 13.2919 2.97839 14.6788 3.81408 15.3744L10.1742 20.668C10.3514 20.8174 10.4829 21.0138 10.5535 21.2346C10.6241 21.4554 10.6309 21.6916 10.5732 21.9162L8.67282 29.3918C8.35 30.6617 9.70072 31.6869 10.7886 30.9976L17.3797 26.8218C17.5651 26.7038 17.7803 26.6411 18 26.6411C18.2197 26.6411 18.4349 26.7038 18.6203 26.8218V26.8218Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  status_order_7: (
    <svg width="55" height="54" viewBox="0 0 55 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M27.5 18V27"
        stroke="#ED1117"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 40V14.875C14 14.5766 14.1185 14.2905 14.3295 14.0795C14.5405 13.8685 14.8266 13.75 15.125 13.75H39.875C40.1734 13.75 40.4595 13.8685 40.6705 14.0795C40.8815 14.2905 41 14.5766 41 14.875V40L36 36L31.5 40L27 36L22.5 40L18 36L14 40Z"
        stroke="#ED1117"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="27.5" cy="30" r="1" fill="#ED1117" />
      <circle cx="27.5" cy="27" r="26" stroke="#ED1117" strokeWidth="2" />
    </svg>
  ),
  'date-range': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8333 3.33464H15V2.5013C15 2.04297 14.625 1.66797 14.1667 1.66797C13.7083 1.66797 13.3333 2.04297 13.3333 2.5013V3.33464H6.66667V2.5013C6.66667 2.04297 6.29167 1.66797 5.83333 1.66797C5.375 1.66797 5 2.04297 5 2.5013V3.33464H4.16667C3.24167 3.33464 2.50833 4.08464 2.50833 5.0013L2.5 16.668C2.5 17.5846 3.24167 18.3346 4.16667 18.3346H15.8333C16.75 18.3346 17.5 17.5846 17.5 16.668V5.0013C17.5 4.08464 16.75 3.33464 15.8333 3.33464ZM15.8333 15.8346C15.8333 16.293 15.4583 16.668 15 16.668H5C4.54167 16.668 4.16667 16.293 4.16667 15.8346V7.5013H15.8333V15.8346ZM5.83333 9.16797H7.5V10.8346H5.83333V9.16797ZM9.16667 9.16797H10.8333V10.8346H9.16667V9.16797ZM12.5 9.16797H14.1667V10.8346H12.5V9.16797Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  person: (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99998 5.4987C10.9166 5.4987 11.6666 6.2487 11.6666 7.16536C11.6666 8.08203 10.9166 8.83203 9.99998 8.83203C9.08331 8.83203 8.33331 8.08203 8.33331 7.16536C8.33331 6.2487 9.08331 5.4987 9.99998 5.4987ZM9.99998 13.832C12.25 13.832 14.8333 14.907 15 15.4987H4.99998C5.19165 14.8987 7.75831 13.832 9.99998 13.832ZM9.99998 3.83203C8.15831 3.83203 6.66665 5.3237 6.66665 7.16536C6.66665 9.00703 8.15831 10.4987 9.99998 10.4987C11.8416 10.4987 13.3333 9.00703 13.3333 7.16536C13.3333 5.3237 11.8416 3.83203 9.99998 3.83203ZM9.99998 12.1654C7.77498 12.1654 3.33331 13.282 3.33331 15.4987V17.1654H16.6666V15.4987C16.6666 13.282 12.225 12.1654 9.99998 12.1654Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'delete-small': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="white" />
      <path
        d="M7.99992 1.33301C4.31325 1.33301 1.33325 4.31301 1.33325 7.99967C1.33325 11.6863 4.31325 14.6663 7.99992 14.6663C11.6866 14.6663 14.6666 11.6863 14.6666 7.99967C14.6666 4.31301 11.6866 1.33301 7.99992 1.33301ZM10.8666 10.8663C10.6066 11.1263 10.1866 11.1263 9.92659 10.8663L7.99992 8.93967L6.07325 10.8663C5.81325 11.1263 5.39325 11.1263 5.13325 10.8663C4.87325 10.6063 4.87325 10.1863 5.13325 9.92634L7.05992 7.99967L5.13325 6.07301C4.87325 5.81301 4.87325 5.39301 5.13325 5.13301C5.39325 4.87301 5.81325 4.87301 6.07325 5.13301L7.99992 7.05967L9.92659 5.13301C10.1866 4.87301 10.6066 4.87301 10.8666 5.13301C11.1266 5.39301 11.1266 5.81301 10.8666 6.07301L8.93992 7.99967L10.8666 9.92634C11.1199 10.1797 11.1199 10.6063 10.8666 10.8663Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'person-register': (
    <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="40"
        cy="40.5"
        r="39"
        fill="url(#paint0_linear_1801_17715)"
        stroke="url(#paint1_linear_1801_17715)"
        strokeWidth="2"
      />
      <path
        d="M39.9997 40.5007C44.0513 40.5007 47.333 37.219 47.333 33.1673C47.333 29.1157 44.0513 25.834 39.9997 25.834C35.948 25.834 32.6663 29.1157 32.6663 33.1673C32.6663 37.219 35.948 40.5007 39.9997 40.5007ZM39.9997 44.1673C35.1047 44.1673 25.333 46.624 25.333 51.5007V53.334C25.333 54.3423 26.158 55.1673 27.1663 55.1673H52.833C53.8413 55.1673 54.6663 54.3423 54.6663 53.334V51.5007C54.6663 46.624 44.8947 44.1673 39.9997 44.1673Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1801_17715"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82D99F" />
          <stop offset="1" stopColor="#31966D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1801_17715"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#31966D" />
          <stop offset="1" stopColor="#82D99F" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'enterprise-register': (
    <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="40"
        cy="40.5"
        r="39"
        fill="url(#paint0_linear_1801_4689)"
        stroke="url(#paint1_linear_1801_4689)"
        strokeWidth="2"
      />
      <path
        d="M40.0003 22.166C29.8803 22.166 21.667 30.3793 21.667 40.4993C21.667 50.6193 29.8803 58.8327 40.0003 58.8327C50.1203 58.8327 58.3337 50.6193 58.3337 40.4993C58.3337 30.3793 50.1203 22.166 40.0003 22.166ZM46.6187 33.7893C48.5803 33.7893 50.157 35.366 50.157 37.3277C50.157 39.2893 48.5803 40.866 46.6187 40.866C44.657 40.866 43.0803 39.2893 43.0803 37.3277C43.062 35.366 44.657 33.7893 46.6187 33.7893ZM35.6187 30.8927C38.002 30.8927 39.9453 32.836 39.9453 35.2193C39.9453 37.6027 38.002 39.546 35.6187 39.546C33.2353 39.546 31.292 37.6027 31.292 35.2193C31.292 32.8177 33.217 30.8927 35.6187 30.8927ZM35.6187 47.631V54.506C31.2187 53.131 27.7353 49.7393 26.1953 45.4127C28.1203 43.3593 32.9237 42.3143 35.6187 42.3143C36.5903 42.3143 37.8187 42.461 39.102 42.7177C36.0953 44.3127 35.6187 46.421 35.6187 47.631ZM40.0003 55.166C39.5053 55.166 39.0287 55.1477 38.552 55.0927V47.631C38.552 45.0277 43.942 43.726 46.6187 43.726C48.5803 43.726 51.972 44.441 53.6587 45.8343C51.5137 51.2793 46.2153 55.166 40.0003 55.166Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1801_4689"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D1BC9A" />
          <stop offset="1" stopColor="#BD9C6D" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1801_4689"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#BD9C6D" />
          <stop offset="1" stopColor="#D1BC9A" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'test-site-register': (
    <svg width="80" height="81" viewBox="0 0 80 81" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="40"
        cy="40.5"
        r="39"
        fill="url(#paint0_linear_1801_17703)"
        stroke="url(#paint1_linear_1801_17703)"
        strokeWidth="2"
      />
      <path
        d="M39.9997 38.666C37.5613 38.666 32.6663 39.8944 32.6663 42.3327V42.626C34.4447 44.6793 37.0663 45.9993 39.9997 45.9993C42.933 45.9993 45.5547 44.6793 47.333 42.626V42.3327C47.333 39.8944 42.438 38.666 39.9997 38.666ZM39.9997 36.8327C42.0163 36.8327 43.6663 35.1827 43.6663 33.166C43.6663 31.1493 42.0163 29.4993 39.9997 29.4993C37.983 29.4993 36.333 31.1493 36.333 33.166C36.333 35.1827 37.983 36.8327 39.9997 36.8327ZM39.9997 22.166C47.6997 22.166 54.6663 28.0693 54.6663 37.1993C54.6663 43.0293 50.1747 49.886 41.2097 57.7877C40.513 58.3927 39.468 58.3927 38.7713 57.7877C29.8247 49.886 25.333 43.0293 25.333 37.1993C25.333 28.0693 32.2997 22.166 39.9997 22.166Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1801_17703"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5CD9E1" />
          <stop offset="1" stopColor="#01AFEF" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1801_17703"
          x1="40"
          y1="78.5"
          x2="40"
          y2="2.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#01AFEF" />
          <stop offset="1" stopColor="#5CD9E1" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'delete-outline': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.99999 15.8333C4.99999 16.75 5.74999 17.5 6.66666 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V7.5C15 6.58333 14.25 5.83333 13.3333 5.83333H6.66666C5.74999 5.83333 4.99999 6.58333 4.99999 7.5V15.8333ZM7.49999 7.5H12.5C12.9583 7.5 13.3333 7.875 13.3333 8.33333V15C13.3333 15.4583 12.9583 15.8333 12.5 15.8333H7.49999C7.04166 15.8333 6.66666 15.4583 6.66666 15V8.33333C6.66666 7.875 7.04166 7.5 7.49999 7.5ZM12.9167 3.33333L12.325 2.74167C12.175 2.59167 11.9583 2.5 11.7417 2.5H8.25832C8.04166 2.5 7.82499 2.59167 7.67499 2.74167L7.08332 3.33333H4.99999C4.54166 3.33333 4.16666 3.70833 4.16666 4.16667C4.16666 4.625 4.54166 5 4.99999 5H15C15.4583 5 15.8333 4.625 15.8333 4.16667C15.8333 3.70833 15.4583 3.33333 15 3.33333H12.9167Z"
        fill="#FF4648"
      />
    </svg>
  ),
  'face-book': (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="14" fill="url(#paint0_linear_1615_165267)" />
      <path
        d="M21.2137 20.2816L21.8356 16.3301H17.9452V13.767C17.9452 12.6857 18.4877 11.6311 20.2302 11.6311H22V8.26699C22 8.26699 20.3945 8 18.8603 8C15.6548 8 13.5617 9.89294 13.5617 13.3184V16.3301H10V20.2816H13.5617V29.8345C14.2767 29.944 15.0082 30 15.7534 30C16.4986 30 17.2302 29.944 17.9452 29.8345V20.2816H21.2137Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1615_165267"
          x1="16"
          y1="2"
          x2="16"
          y2="29.917"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#18ACFE" />
          <stop offset="1" stopColor="#0163E0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'reset-pass': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.4555 14.1025L16.458 14.1037L16.5258 13.9967C16.5599 13.9444 16.5934 13.8917 16.6262 13.8385L16.6979 13.7253C16.7268 13.6798 16.7745 13.6444 16.8328 13.6301C16.8914 13.6158 16.953 13.6246 17.0039 13.6535C17.0544 13.6822 17.0889 13.7274 17.1032 13.7772C17.117 13.825 17.1122 13.8762 17.0889 13.9214C16.0338 15.7067 14.3005 17.014 12.2636 17.5555C10.2233 18.0978 8.0473 17.8266 6.21128 16.8022L6.19596 16.7936L6.18007 16.7862C6.16638 16.7797 6.15321 16.7724 6.14066 16.7643L6.12968 16.7572L6.11834 16.7507C4.30214 15.708 2.98108 14.0073 2.43795 12.0195C1.8949 10.0321 2.17232 7.91454 3.21137 6.1251L3.22063 6.10915L3.22869 6.09257C3.23419 6.08124 3.24077 6.07028 3.24838 6.05985L3.26155 6.0418L3.27306 6.02264C4.34172 4.24421 6.08568 2.94912 8.12733 2.42299C10.1692 1.89681 12.34 2.18332 14.1663 3.21888L14.1678 3.21975C15.3734 3.89773 16.375 4.87352 17.0735 6.04853L17.684 7.07548L17.987 5.91985L18.1294 5.37667L18.1314 5.36906L18.1331 5.36138C18.1405 5.32897 18.1546 5.29779 18.1751 5.2698C18.1955 5.24179 18.222 5.21744 18.2534 5.19866C18.2847 5.17987 18.3201 5.16717 18.3574 5.16172L18.2851 4.66697L18.3574 5.16172C18.3947 5.15626 18.4328 5.15824 18.4692 5.16745C18.5056 5.17667 18.5391 5.19282 18.568 5.21449L18.8682 4.81466L18.568 5.21449C18.5968 5.23615 18.6203 5.26277 18.6374 5.29238C18.6546 5.32197 18.6652 5.35414 18.6691 5.38699C18.673 5.41982 18.6701 5.45315 18.6606 5.48514L18.6582 5.49312L18.6561 5.50118L18.1306 7.50073C18.1252 7.52108 18.1174 7.5409 18.107 7.55977L18.0946 7.58257L18.0846 7.60653C18.0622 7.65997 18.0208 7.70647 17.9651 7.73633C17.9093 7.76625 17.8436 7.77687 17.7797 7.76545C17.7796 7.76544 17.7796 7.76543 17.7795 7.76542L15.7139 7.39161C15.7137 7.39157 15.7135 7.39154 15.7134 7.39151C15.6772 7.38479 15.6432 7.37127 15.6132 7.35209L15.3438 7.77327L15.6132 7.35209C15.5831 7.33284 15.5579 7.30839 15.5384 7.28054C15.519 7.25273 15.5058 7.22196 15.4989 7.19008L15.01 7.29492L15.4989 7.19007C15.4921 7.1582 15.4917 7.12542 15.4978 7.09345C15.504 7.06146 15.5165 7.03047 15.5353 7.00232C15.554 6.97414 15.5787 6.94921 15.6083 6.92936C15.6379 6.9095 15.6717 6.89523 15.7079 6.88778C15.744 6.88033 15.7814 6.87992 15.8178 6.88661L15.8192 6.88687L16.1511 6.94691L17.2461 7.14506L16.6671 6.19473C15.9925 5.08767 15.0361 4.17321 13.8931 3.54049C12.7501 2.9078 11.4595 2.57835 10.1482 2.58392C8.83691 2.5895 7.5492 2.92992 6.41184 3.57232C5.27442 4.21476 4.32615 5.13736 3.66138 6.25015L3.65673 6.25793L3.65236 6.26588L3.63603 6.29561C2.63557 7.99658 2.36267 10.0184 2.87862 11.9175C3.39518 13.8189 4.65921 15.4386 6.38966 16.4236L6.39083 16.4243C8.1251 17.4053 10.1845 17.6704 12.117 17.1624C13.8979 16.6943 15.4394 15.6041 16.4555 14.1025ZM10.9984 10.0601L11.9378 10.9943H11.9184L12.7925 11.8513L13.6114 12.6542L13.7501 12.7902L13.6494 12.8898L13.4997 12.743L13.1497 12.3998L12.7996 12.743L12.3564 13.1776L12.2517 13.0749L12.6808 12.6542L13.045 12.2972L12.6808 11.9401L12.2536 11.5212L11.9033 11.1778L11.5532 11.5215L10.9904 12.0742L10.8859 11.9718L11.4361 11.4324L11.8002 11.0754L11.4361 10.7184L11.1513 10.4391L10.8665 10.1598L10.5171 9.81734L10.1671 10.1591C9.80913 10.5086 9.32245 10.7065 8.81312 10.7065C8.3067 10.7065 7.82269 10.5108 7.46529 10.1651L7.4321 10.1302L7.43212 10.1302L7.42853 10.1265C7.08594 9.77396 6.89917 9.30612 6.905 8.82327C6.91084 8.34041 7.10889 7.8769 7.46005 7.53227L7.4608 7.53153L8.28356 6.72065C8.28361 6.7206 8.28367 6.72054 8.28373 6.72049C8.64128 6.36898 9.12865 6.16938 9.63916 6.16865C10.1498 6.16792 10.6378 6.36619 10.9964 6.71679C11.3547 7.06706 11.5546 7.54042 11.5553 8.03215C11.5561 8.52388 11.3576 8.99778 11.0004 9.34906L10.6399 9.70358L10.9984 10.0601ZM10.7512 6.93024L10.7513 6.9302L10.7457 6.92484C10.4471 6.63616 10.0466 6.47598 9.63129 6.47598C9.21599 6.47598 8.8155 6.63616 8.51687 6.92484L8.51557 6.9261L7.68814 7.73178L7.68812 7.73176L7.68425 7.73561C7.39639 8.02209 7.23004 8.40802 7.2226 8.81422C7.21516 9.22044 7.36729 9.61219 7.64468 9.90884L7.65647 9.92145L7.66911 9.93321L7.69474 9.95709C7.99313 10.2431 8.39189 10.4017 8.80528 10.4017C9.22026 10.4017 9.62049 10.2419 9.91924 9.9538L9.91925 9.95381L9.92131 9.9518L10.7473 9.14611L10.7473 9.14613L10.7512 9.14227C11.0454 8.84892 11.2121 8.4519 11.2121 8.03625C11.2121 7.62061 11.0454 7.22359 10.7512 6.93024Z"
        fill="#0D99FF"
        stroke="#0D99FF"
      />
    </svg>
  ),
  'cloud-upload': (
    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_631_26457)">
        <path
          d="M16.1344 8.46303L16.2085 8.8387L16.5905 8.86515C18.5001 8.99735 20 10.5675 20 12.4997C20 14.5235 18.3572 16.1663 16.3333 16.1663H5.5C3.01781 16.1663 1 14.1485 1 11.6663C1 9.34916 2.75498 7.43674 5.01119 7.19687L5.2779 7.16852L5.40179 6.93064C6.36089 5.08918 8.28562 3.83301 10.5 3.83301C13.2897 3.83301 15.613 5.81771 16.1344 8.46303ZM5.0822 7.86063L5.08188 7.86066C3.13251 8.06232 1.66667 9.70465 1.66667 11.6663C1.66667 13.7842 3.38219 15.4997 5.5 15.4997H16.3333C17.9845 15.4997 19.3333 14.1508 19.3333 12.4997C19.3333 10.9455 18.1134 9.63539 16.5506 9.53416C16.55 9.53412 16.5493 9.53407 16.5487 9.53403L15.6573 9.46993L15.4821 8.59402C15.4821 8.5938 15.482 8.59359 15.482 8.59338C15.0104 6.21857 12.9223 4.49967 10.5 4.49967C8.5954 4.49967 6.87563 5.55467 5.99857 7.243L5.70733 7.79636L5.0822 7.86063ZM9.79167 10.833V10.333H9.29167H8.37377L10.5 8.20678L12.6262 10.333H11.7083H11.2083V10.833V12.833H9.79167V10.833Z"
          fill="#0D99FF"
          stroke="#0D99FF"
        />
      </g>
      <defs>
        <clipPath id="clip0_631_26457">
          <rect width="20" height="20" fill="white" transform="translate(0.5)" />
        </clipPath>
      </defs>
    </svg>
  ),
  'green-accept': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.0003 1.66699C5.40033 1.66699 1.66699 5.40033 1.66699 10.0003C1.66699 14.6003 5.40033 18.3337 10.0003 18.3337C14.6003 18.3337 18.3337 14.6003 18.3337 10.0003C18.3337 5.40033 14.6003 1.66699 10.0003 1.66699ZM10.0003 16.667C6.32533 16.667 3.33366 13.6753 3.33366 10.0003C3.33366 6.32533 6.32533 3.33366 10.0003 3.33366C13.6753 3.33366 16.667 6.32533 16.667 10.0003C16.667 13.6753 13.6753 16.667 10.0003 16.667ZM13.8253 6.31699L8.33366 11.8087L6.17533 9.65866L5.00033 10.8337L8.33366 14.167L15.0003 7.50033L13.8253 6.31699Z"
        fill="#00C590"
      />
    </svg>
  ),
  'cloud-icon': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.6344 8.46303L15.7085 8.8387L16.0905 8.86515C18.0001 8.99735 19.5 10.5675 19.5 12.4997C19.5 14.5235 17.8572 16.1663 15.8333 16.1663H5C2.51781 16.1663 0.5 14.1485 0.5 11.6663C0.5 9.34916 2.25498 7.43674 4.51119 7.19687L4.7779 7.16852L4.90179 6.93064C5.86089 5.08918 7.78562 3.83301 10 3.83301C12.7897 3.83301 15.113 5.81771 15.6344 8.46303ZM4.5822 7.86063L4.58188 7.86066C2.63251 8.06232 1.16667 9.70465 1.16667 11.6663C1.16667 13.7842 2.88219 15.4997 5 15.4997H15.8333C17.4845 15.4997 18.8333 14.1508 18.8333 12.4997C18.8333 10.9455 17.6134 9.63539 16.0506 9.53416C16.05 9.53412 16.0493 9.53407 16.0487 9.53403L15.1573 9.46993L14.9821 8.59402C14.9821 8.5938 14.982 8.59359 14.982 8.59338C14.5104 6.21857 12.4223 4.49967 10 4.49967C8.0954 4.49967 6.37563 5.55467 5.49857 7.243L5.20733 7.79636L4.5822 7.86063ZM8.79167 11.333H9.29167V10.833V8.83301H10.7083V10.833V11.333H11.2083H12.1262L10 13.4592L7.87377 11.333H8.79167Z"
        fill="#0D99FF"
        stroke="#0D99FF"
      />
    </svg>
  ),
  'yellow-print': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8337 6.66667H15.0003V2.5H5.00033V6.66667H4.16699C2.78366 6.66667 1.66699 7.78333 1.66699 9.16667V14.1667H5.00033V17.5H15.0003V14.1667H18.3337V9.16667C18.3337 7.78333 17.217 6.66667 15.8337 6.66667ZM6.66699 4.16667H13.3337V6.66667H6.66699V4.16667ZM13.3337 14.1667V15.8333H6.66699V12.5H13.3337V14.1667ZM15.0003 12.5V10.8333H5.00033V12.5H3.33366V9.16667C3.33366 8.70833 3.70866 8.33333 4.16699 8.33333H15.8337C16.292 8.33333 16.667 8.70833 16.667 9.16667V12.5H15.0003Z"
        fill="#FEC328"
      />
      <path
        d="M15.3337 9.58333C15.3337 9.76743 15.1844 9.91667 15.0003 9.91667C14.8162 9.91667 14.667 9.76743 14.667 9.58333C14.667 9.39924 14.8162 9.25 15.0003 9.25C15.1844 9.25 15.3337 9.39924 15.3337 9.58333Z"
        fill="#FEC328"
        stroke="#FEC328"
      />
    </svg>
  ),
  'delete-box': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.00002 15.8333C5.00002 16.75 5.75002 17.5 6.66669 17.5H13.3334C14.25 17.5 15 16.75 15 15.8333V5.83333H5.00002V15.8333ZM6.66669 7.5H13.3334V15.8333H6.66669V7.5ZM12.9167 3.33333L12.0834 2.5H7.91669L7.08335 3.33333H4.16669V5H15.8334V3.33333H12.9167Z"
        fill="#666666"
      />
    </svg>
  ),
  'edit-box': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#666666"
      />
    </svg>
  ),
  'add-box': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8333 2.5H4.16667C3.24167 2.5 2.5 3.25 2.5 4.16667V15.8333C2.5 16.75 3.24167 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V4.16667C17.5 3.25 16.75 2.5 15.8333 2.5ZM15.8333 15.8333H4.16667V4.16667H15.8333V15.8333ZM9.16667 14.1667H10.8333V10.8333H14.1667V9.16667H10.8333V5.83333H9.16667V9.16667H5.83333V10.8333H9.16667V14.1667Z"
        fill="#666666"
      />
    </svg>
  ),
  recallIcon: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.33335 7.49957V6.17457C8.33335 5.4329 7.43335 5.0579 6.90835 5.5829L3.08335 9.4079C2.75835 9.7329 2.75835 10.2579 3.08335 10.5829L6.90835 14.4079C7.43335 14.9329 8.33335 14.5662 8.33335 13.8246V12.4162C12.5 12.4162 15.4167 13.7496 17.5 16.6662C16.6667 12.4996 14.1667 8.3329 8.33335 7.49957Z"
        fill="#F88C00"
      />
    </svg>
  ),
  'code-request': (
    <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_2316_56202)">
        <path
          d="M2 0C0.896875 0 0 0.896875 0 2V14C0 15.1031 0.896875 16 2 16H10C11.1031 16 12 15.1031 12 14V5H8C7.44688 5 7 4.55312 7 4V0H2ZM8 0V4H12L8 0ZM2.5 2H4.5C4.775 2 5 2.225 5 2.5C5 2.775 4.775 3 4.5 3H2.5C2.225 3 2 2.775 2 2.5C2 2.225 2.225 2 2.5 2ZM2.5 4H4.5C4.775 4 5 4.225 5 4.5C5 4.775 4.775 5 4.5 5H2.5C2.225 5 2 4.775 2 4.5C2 4.225 2.225 4 2.5 4ZM3 7H9C9.55313 7 10 7.44688 10 8V10C10 10.5531 9.55313 11 9 11H3C2.44688 11 2 10.5531 2 10V8C2 7.44688 2.44688 7 3 7ZM3 8V10H9V8H3ZM7.5 13H9.5C9.775 13 10 13.225 10 13.5C10 13.775 9.775 14 9.5 14H7.5C7.225 14 7 13.775 7 13.5C7 13.225 7.225 13 7.5 13Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_2316_56202">
          <rect width="12" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  location: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99992 10.0001C9.08325 10.0001 8.33325 9.25008 8.33325 8.33342C8.33325 7.41675 9.08325 6.66675 9.99992 6.66675C10.9166 6.66675 11.6666 7.41675 11.6666 8.33342C11.6666 9.25008 10.9166 10.0001 9.99992 10.0001ZM14.9999 8.50008C14.9999 5.47508 12.7916 3.33341 9.99992 3.33341C7.20825 3.33341 4.99992 5.47508 4.99992 8.50008C4.99992 10.4501 6.62492 13.0334 9.99992 16.1167C13.3749 13.0334 14.9999 10.4501 14.9999 8.50008ZM9.99992 1.66675C13.4999 1.66675 16.6666 4.35008 16.6666 8.50008C16.6666 11.2667 14.4416 14.5417 9.99992 18.3334C5.55825 14.5417 3.33325 11.2667 3.33325 8.50008C3.33325 4.35008 6.49992 1.66675 9.99992 1.66675Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  ship: (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.6667 6.65333L11.4734 6.65333L8.55342 2.28C8.42675 2.09333 8.21342 2 8.00008 2C7.78675 2 7.57342 2.09333 7.44675 2.28667L4.52675 6.65333H1.33341C0.966748 6.65333 0.666748 6.95333 0.666748 7.32C0.666748 7.38 0.673415 7.44 0.693415 7.5L2.38675 13.68C2.54008 14.24 3.05341 14.6533 3.66675 14.6533L12.3334 14.6533C12.9467 14.6533 13.4601 14.24 13.6201 13.68L15.3134 7.5L15.3334 7.32C15.3334 6.95333 15.0334 6.65333 14.6667 6.65333ZM8.00008 3.85333L9.86675 6.65333H6.13341L8.00008 3.85333ZM12.3334 13.32L3.67342 13.3267L2.20675 7.98667L13.8001 7.98667L12.3334 13.32ZM8.00008 9.32C7.26675 9.32 6.66675 9.92 6.66675 10.6533C6.66675 11.3867 7.26675 11.9867 8.00008 11.9867C8.73342 11.9867 9.33342 11.3867 9.33342 10.6533C9.33342 9.92 8.73342 9.32 8.00008 9.32Z"
        fill="black"
      />
    </svg>
  ),
  hiring: (
    <svg width="17" height="13" viewBox="0 0 17 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5164 3.97126V3.3284C11.5164 3.26948 11.4682 3.22126 11.4093 3.22126H6.26639C6.20746 3.22126 6.15925 3.26948 6.15925 3.3284V3.97126C6.15925 4.03019 6.20746 4.0784 6.26639 4.0784H11.4093C11.4682 4.0784 11.5164 4.03019 11.5164 3.97126ZM6.26639 5.14983C6.20746 5.14983 6.15925 5.19805 6.15925 5.25698V5.89983C6.15925 5.95876 6.20746 6.00698 6.26639 6.00698H8.73068C8.78961 6.00698 8.83782 5.95876 8.83782 5.89983V5.25698C8.83782 5.19805 8.78961 5.14983 8.73068 5.14983H6.26639ZM11.3021 6.7034C9.70434 6.7034 8.40925 7.99849 8.40925 9.59626C8.40925 11.194 9.70434 12.4891 11.3021 12.4891C12.8999 12.4891 14.195 11.194 14.195 9.59626C14.195 7.99849 12.8999 6.7034 11.3021 6.7034ZM12.7418 11.036C12.3575 11.4204 11.8459 11.632 11.3021 11.632C10.7584 11.632 10.2467 11.4204 9.86237 11.036C9.478 10.6516 9.26639 10.14 9.26639 9.59626C9.26639 9.05251 9.478 8.5409 9.86237 8.15653C10.2467 7.77215 10.7584 7.56055 11.3021 7.56055C11.8459 7.56055 12.3575 7.77215 12.7418 8.15653C13.1262 8.5409 13.3378 9.05251 13.3378 9.59626C13.3378 10.14 13.1262 10.6516 12.7418 11.036ZM12.4941 8.5784H11.9008C11.8659 8.5784 11.8338 8.59448 11.8137 8.6226L10.9633 9.79849L10.6539 9.37126C10.644 9.35746 10.6309 9.34624 10.6158 9.33855C10.6006 9.33086 10.5838 9.32692 10.5668 9.32707H9.97621C9.88916 9.32707 9.83827 9.42617 9.88916 9.49715L10.8776 10.8646C10.9204 10.9235 11.0075 10.9235 11.0503 10.8646L12.5798 8.74849C12.632 8.67751 12.5811 8.5784 12.4941 8.5784ZM8.19496 11.2034H5.08782V1.77483H12.5878V6.38198C12.5878 6.4409 12.636 6.48912 12.695 6.48912H13.445C13.5039 6.48912 13.5521 6.4409 13.5521 6.38198V1.23912C13.5521 1.00206 13.3606 0.810547 13.1235 0.810547H4.55211C4.31505 0.810547 4.12354 1.00206 4.12354 1.23912V11.7391C4.12354 11.9762 4.31505 12.1677 4.55211 12.1677H8.19496C8.25389 12.1677 8.30211 12.1195 8.30211 12.0605V11.3105C8.30211 11.2516 8.25389 11.2034 8.19496 11.2034Z"
        fill="#212529"
      />
    </svg>
  ),
  register: (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.545 8.49935C12.0183 8.49935 13.2117 7.30602 13.2117 5.83268C13.2117 4.35935 12.0183 3.16602 10.545 3.16602C9.07167 3.16602 7.87834 4.35935 7.87834 5.83268C7.87834 7.30602 9.07167 8.49935 10.545 8.49935ZM10.545 4.49935C11.2783 4.49935 11.8783 5.09935 11.8783 5.83268C11.8783 6.56602 11.2783 7.16602 10.545 7.16602C9.81167 7.16602 9.21167 6.56602 9.21167 5.83268C9.21167 5.09935 9.81167 4.49935 10.545 4.49935ZM10.545 9.83268C8.765 9.83268 5.21167 10.726 5.21167 12.4993V13.8327H15.8783V12.4993C15.8783 10.726 12.325 9.83268 10.545 9.83268ZM6.545 12.4993C6.69167 12.0193 8.75167 11.166 10.545 11.166C12.345 11.166 14.4117 12.026 14.545 12.4993H6.545ZM4.545 10.4993V8.49935H6.545V7.16602H4.545V5.16602H3.21167V7.16602H1.21167V8.49935H3.21167V10.4993H4.545Z"
        fill="black"
      />
    </svg>
  ),
  'next-ios': (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5">
        <path
          d="M17.22 6.97664C18.3633 5.83331 20.2067 5.83331 21.35 6.97664L40.74 26.3666C41.65 27.2766 41.65 28.7466 40.74 29.6566L21.35 49.0466C20.2067 50.19 18.3633 50.19 17.22 49.0466C16.0767 47.9033 16.0767 46.06 17.22 44.9166L34.1133 28L17.1967 11.0833C16.0767 9.96331 16.0767 8.09664 17.22 6.97664Z"
          fill="white"
        />
      </g>
    </svg>
  ),

  'back-ios': (
    <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g opacity="0.5">
        <path
          d="M38.78 6.97664C37.6367 5.83331 35.7933 5.83331 34.65 6.97664L15.26 26.3666C14.35 27.2766 14.35 28.7466 15.26 29.6566L34.65 49.0466C35.7933 50.19 37.6367 50.19 38.78 49.0466C39.9233 47.9033 39.9233 46.06 38.78 44.9166L21.8867 28L38.8033 11.0833C39.9233 9.96331 39.9233 8.09664 38.78 6.97664Z"
          fill="white"
        />
      </g>
    </svg>
  ),

  'playlist-add-check': (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.75 7.5H2.25C1.8375 7.5 1.5 7.8375 1.5 8.25C1.5 8.6625 1.8375 9 2.25 9H9.75C10.1625 9 10.5 8.6625 10.5 8.25C10.5 7.8375 10.1625 7.5 9.75 7.5ZM9.75 4.5H2.25C1.8375 4.5 1.5 4.8375 1.5 5.25C1.5 5.6625 1.8375 6 2.25 6H9.75C10.1625 6 10.5 5.6625 10.5 5.25C10.5 4.8375 10.1625 4.5 9.75 4.5ZM2.25 12H6.75C7.1625 12 7.5 11.6625 7.5 11.25C7.5 10.8375 7.1625 10.5 6.75 10.5H2.25C1.8375 10.5 1.5 10.8375 1.5 11.25C1.5 11.6625 1.8375 12 2.25 12ZM16.6575 9.1575L16.725 9.225C17.0175 9.5175 17.0175 9.99 16.725 10.2825L12.54 14.475C12.2475 14.7675 11.775 14.7675 11.4825 14.475L9.165 12.1575C8.8725 11.865 8.8725 11.3925 9.165 11.1L9.2325 11.0325C9.525 10.74 9.9975 10.74 10.29 11.0325L12.015 12.7575L15.6 9.165C15.885 8.865 16.365 8.865 16.6575 9.1575Z"
        fill="#666666"
      />
    </svg>
  ),

  'search-blue': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5006 14.0006H14.7106L14.4306 13.7306C15.6306 12.3306 16.2506 10.4206 15.9106 8.39063C15.4406 5.61063 13.1206 3.39063 10.3206 3.05063C6.09063 2.53063 2.53063 6.09063 3.05063 10.3206C3.39063 13.1206 5.61063 15.4406 8.39063 15.9106C10.4206 16.2506 12.3306 15.6306 13.7306 14.4306L14.0006 14.7106V15.5006L18.2506 19.7506C18.6606 20.1606 19.3306 20.1606 19.7406 19.7506C20.1506 19.3406 20.1506 18.6706 19.7406 18.2606L15.5006 14.0006ZM9.50063 14.0006C7.01063 14.0006 5.00063 11.9906 5.00063 9.50063C5.00063 7.01063 7.01063 5.00063 9.50063 5.00063C11.9906 5.00063 14.0006 7.01063 14.0006 9.50063C14.0006 11.9906 11.9906 14.0006 9.50063 14.0006Z"
        fill="#154398"
      />
    </svg>
  ),

  'star-green': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.0003 17.5198L16.1503 20.0298C16.9103 20.4898 17.8403 19.8098 17.6403 18.9498L16.5403 14.2298L20.2103 11.0498C20.8803 10.4698 20.5203 9.36977 19.6403 9.29977L14.8103 8.88977L12.9203 4.42977C12.5803 3.61977 11.4203 3.61977 11.0803 4.42977L9.19032 8.87977L4.36032 9.28977C3.48032 9.35977 3.12032 10.4598 3.79032 11.0398L7.46032 14.2198L6.36032 18.9398C6.16032 19.7998 7.09032 20.4798 7.85032 20.0198L12.0003 17.5198Z"
        fill="#00C590"
      />
    </svg>
  ),

  'user-green': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V19C4 19.55 4.45 20 5 20H19C19.55 20 20 19.55 20 19V18C20 15.34 14.67 14 12 14Z"
        fill="#fff"
      />
    </svg>
  ),

  'library-books': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3 6C2.45 6 2 6.45 2 7V20C2 21.1 2.9 22 4 22H17C17.55 22 18 21.55 18 21C18 20.45 17.55 20 17 20H5C4.45 20 4 19.55 4 19V7C4 6.45 3.55 6 3 6ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM18 11H10C9.45 11 9 10.55 9 10C9 9.45 9.45 9 10 9H18C18.55 9 19 9.45 19 10C19 10.55 18.55 11 18 11ZM14 15H10C9.45 15 9 14.55 9 14C9 13.45 9.45 13 10 13H14C14.55 13 15 13.45 15 14C15 14.55 14.55 15 14 15ZM18 7H10C9.45 7 9 6.55 9 6C9 5.45 9.45 5 10 5H18C18.55 5 19 5.45 19 6C19 6.55 18.55 7 18 7Z"
        fill="#00C590"
      />
    </svg>
  ),

  'video-youtube': (
    <svg width="20" height="15" viewBox="0 0 20 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="0.5" width="20" height="14" rx="3" fill="#777777" />
      <path
        d="M7.66797 4.03075V9.96617C7.66797 10.4188 8.17547 10.6938 8.5663 10.4474L13.3146 7.47971C13.6763 7.25627 13.6763 6.74065 13.3146 6.51148L8.5663 3.5495C8.17547 3.30315 7.66797 3.57815 7.66797 4.03075Z"
        fill="white"
      />
    </svg>
  ),

  up: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.11973 14.7105L11.9997 10.8305L15.8797 14.7105C16.2697 15.1005 16.8997 15.1005 17.2897 14.7105C17.6797 14.3205 17.6797 13.6905 17.2897 13.3005L12.6997 8.71047C12.3097 8.32047 11.6797 8.32047 11.2897 8.71047L6.69973 13.3005C6.30973 13.6905 6.30973 14.3205 6.69973 14.7105C7.08973 15.0905 7.72973 15.1005 8.11973 14.7105Z"
        fill="#ED1117"
      />
    </svg>
  ),

  infor: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 17C11.45 17 11 16.55 11 16V12C11 11.45 11.45 11 12 11C12.55 11 13 11.45 13 12V16C13 16.55 12.55 17 12 17ZM13 9H11V7H13V9Z"
        fill="#00C590"
      />
    </svg>
  ),

  'shopping-cart-white': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z"
        fill="white"
      />
    </svg>
  ),

  'check-green': (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.00009 10.7809L3.68676 8.46753C3.42676 8.20753 3.00676 8.20753 2.74676 8.46753C2.48676 8.72753 2.48676 9.14753 2.74676 9.40753L5.53342 12.1942C5.79342 12.4542 6.21342 12.4542 6.47342 12.1942L13.5268 5.14086C13.7868 4.88086 13.7868 4.46086 13.5268 4.20086C13.2668 3.94086 12.8468 3.94086 12.5868 4.20086L6.00009 10.7809Z"
        fill="#00C590"
      />
    </svg>
  ),

  'sms-message': (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3333 3.32031L2.66659 3.32031C1.93325 3.32031 1.33992 3.92031 1.33992 4.65365L1.33325 12.6536C1.33325 13.387 1.93325 13.987 2.66659 13.987L13.3333 13.987C14.0666 13.987 14.6666 13.387 14.6666 12.6536L14.6666 4.65365C14.6666 3.92031 14.0666 3.32031 13.3333 3.32031ZM12.6666 12.6536L3.33325 12.6536C2.96659 12.6536 2.66659 12.3536 2.66659 11.987L2.66659 5.98698L7.29325 8.88031C7.72659 9.15365 8.27325 9.15365 8.70659 8.88031L13.3333 5.98698L13.3333 11.987C13.3333 12.3536 13.0333 12.6536 12.6666 12.6536ZM7.99992 7.98698L2.66659 4.65365L13.3333 4.65365L7.99992 7.98698Z"
        fill="black"
      />
    </svg>
  ),

  'menu-book': (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.125 3.49609C11.6625 3.49609 10.0875 3.79609 9 4.62109C7.9125 3.79609 6.3375 3.49609 4.875 3.49609C3.7875 3.49609 2.6325 3.66109 1.665 4.08859C1.1175 4.33609 0.75 4.86859 0.75 5.47609V13.9361C0.75 14.9111 1.665 15.6311 2.61 15.3911C3.345 15.2036 4.125 15.1211 4.875 15.1211C6.045 15.1211 7.29 15.3161 8.295 15.8111C8.745 16.0361 9.255 16.0361 9.6975 15.8111C10.7025 15.3086 11.9475 15.1211 13.1175 15.1211C13.8675 15.1211 14.6475 15.2036 15.3825 15.3911C16.3275 15.6386 17.2425 14.9186 17.2425 13.9361V5.47609C17.2425 4.86859 16.875 4.33609 16.3275 4.08859C15.3675 3.66109 14.2125 3.49609 13.125 3.49609ZM15.75 13.0436C15.75 13.5161 15.315 13.8611 14.85 13.7786C14.2875 13.6736 13.7025 13.6286 13.125 13.6286C11.85 13.6286 10.0125 14.1161 9 14.7536V6.12109C10.0125 5.48359 11.85 4.99609 13.125 4.99609C13.815 4.99609 14.4975 5.06359 15.15 5.20609C15.495 5.28109 15.75 5.58859 15.75 5.94109V13.0436Z"
        fill="#666666"
      />
      <path
        d="M10.4854 8.37897C10.2454 8.37897 10.0279 8.22897 9.9529 7.98897C9.8554 7.69647 10.0204 7.37397 10.3129 7.28397C11.4679 6.90897 12.9604 6.78897 14.3329 6.94647C14.6404 6.98397 14.8654 7.26147 14.8279 7.56897C14.7904 7.87647 14.5129 8.10147 14.2054 8.06397C12.9904 7.92147 11.6629 8.03397 10.6579 8.35647C10.5979 8.36397 10.5379 8.37897 10.4854 8.37897Z"
        fill="#666666"
      />
      <path
        d="M10.4854 10.3751C10.2454 10.3751 10.0279 10.2251 9.9529 9.98507C9.8554 9.69257 10.0204 9.37007 10.3129 9.28007C11.4604 8.90507 12.9604 8.78507 14.3329 8.94257C14.6404 8.98007 14.8654 9.25757 14.8279 9.56507C14.7904 9.87257 14.5129 10.0976 14.2054 10.0601C12.9904 9.91757 11.6629 10.0301 10.6579 10.3526C10.5979 10.3676 10.5379 10.3751 10.4854 10.3751Z"
        fill="#666666"
      />
      <path
        d="M10.4854 12.3673C10.2454 12.3673 10.0279 12.2173 9.9529 11.9773C9.8554 11.6848 10.0204 11.3623 10.3129 11.2723C11.4604 10.8973 12.9604 10.7773 14.3329 10.9348C14.6404 10.9723 14.8654 11.2498 14.8279 11.5573C14.7904 11.8648 14.5129 12.0823 14.2054 12.0523C12.9904 11.9098 11.6629 12.0223 10.6579 12.3448C10.5979 12.3598 10.5379 12.3673 10.4854 12.3673Z"
        fill="#666666"
      />
    </svg>
  ),
  'supervisor-account': (
    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.375 9.12109C13.41 9.12109 14.2425 8.28109 14.2425 7.24609C14.2425 6.21109 13.41 5.37109 12.375 5.37109C11.34 5.37109 10.5 6.21109 10.5 7.24609C10.5 8.28109 11.34 9.12109 12.375 9.12109ZM6.75 8.37109C7.995 8.37109 8.9925 7.36609 8.9925 6.12109C8.9925 4.87609 7.995 3.87109 6.75 3.87109C5.505 3.87109 4.5 4.87609 4.5 6.12109C4.5 7.36609 5.505 8.37109 6.75 8.37109ZM12.375 10.6211C11.0025 10.6211 8.25 11.3111 8.25 12.6836V13.6211C8.25 14.0336 8.5875 14.3711 9 14.3711H15.75C16.1625 14.3711 16.5 14.0336 16.5 13.6211V12.6836C16.5 11.3111 13.7475 10.6211 12.375 10.6211ZM6.75 9.87109C5.0025 9.87109 1.5 10.7486 1.5 12.4961V13.6211C1.5 14.0336 1.8375 14.3711 2.25 14.3711H6.75V12.6836C6.75 12.0461 6.9975 10.9286 8.5275 10.0811C7.875 9.94609 7.245 9.87109 6.75 9.87109Z"
        fill="#666666"
      />
    </svg>
  ),
  'next-arrow-slide': (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="17.5" fill="white" stroke="#DDDDDD" />
      <path
        d="M14.1501 25.507C14.5584 25.9154 15.2167 25.9154 15.6251 25.507L22.5501 18.582C22.8751 18.257 22.8751 17.732 22.5501 17.407L15.6251 10.482C15.2167 10.0737 14.5584 10.0737 14.1501 10.482C13.7417 10.8904 13.7417 11.5487 14.1501 11.957L20.1834 17.9987L14.1417 24.0404C13.7417 24.4404 13.7417 25.107 14.1501 25.507Z"
        fill="#666666"
      />
    </svg>
  ),
  'prev-arrow-slide': (
    <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="18" cy="18" r="17.5" fill="white" stroke="#DDDDDD" />
      <path
        d="M21.8498 10.4898C21.4415 10.0815 20.7831 10.0815 20.3748 10.4898L13.4498 17.4148C13.1248 17.7398 13.1248 18.2648 13.4498 18.5898L20.3748 25.5148C20.7831 25.9232 21.4415 25.9232 21.8498 25.5148C22.2581 25.1065 22.2581 24.4482 21.8498 24.0398L15.8165 17.9982L21.8581 11.9565C22.2581 11.5565 22.2581 10.8898 21.8498 10.4898Z"
        fill="#666666"
      />
    </svg>
  ),
  'manual-step1': (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12425)" />
      <path
        d="M25 34.3346L23.9967 33.3313C22.62 31.9546 22.6317 29.7146 24.02 28.3613L25 27.4046C24.545 27.358 24.2067 27.3346 23.8333 27.3346C20.7183 27.3346 14.5 28.898 14.5 32.0013V34.3346H25ZM23.8333 25.0013C26.4117 25.0013 28.5 22.913 28.5 20.3346C28.5 17.7563 26.4117 15.668 23.8333 15.668C21.255 15.668 19.1667 17.7563 19.1667 20.3346C19.1667 22.913 21.255 25.0013 23.8333 25.0013Z"
        fill="white"
      />
      <path
        d="M29.8768 34.0765C29.4218 34.5315 28.6752 34.5315 28.2202 34.0765L25.8052 31.6382C25.3618 31.1832 25.3618 30.4598 25.8052 30.0165L25.8168 30.0048C26.2718 29.5498 27.0068 29.5498 27.4502 30.0048L29.0485 31.6032L34.2168 26.3998C34.6718 25.9448 35.4068 25.9448 35.8618 26.3998L35.8735 26.4115C36.3168 26.8665 36.3168 27.5898 35.8735 28.0332L29.8768 34.0765Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_204_12425"
          x1="0"
          y1="50.0011"
          x2="50"
          y2="50.0011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154297" />
          <stop offset="1" stopColor="#ED1E24" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'manual-step2': (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12431)" />
      <path
        d="M22.6667 22.69H28.5V35.5H22.6667V22.69ZM30.8333 35.5H34.3333C35.6167 35.5 36.6667 34.45 36.6667 33.1667V22.6667H30.8333V35.5ZM34.3333 14.5H16.8333C15.55 14.5 14.5 15.55 14.5 16.8333V20.3333H36.6667V16.8333C36.6667 15.55 35.6167 14.5 34.3333 14.5ZM14.5 33.1667C14.5 34.45 15.55 35.5 16.8333 35.5H20.3333V22.6667H14.5V33.1667Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_204_12431"
          x1="0"
          y1="50.0011"
          x2="50"
          y2="50.0011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154297" />
          <stop offset="1" stopColor="#ED1E24" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'manual-step3': (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12437)" />
      <path
        d="M33.1667 14.5013H28.29C27.8 13.148 26.5167 12.168 25 12.168C23.4833 12.168 22.2 13.148 21.71 14.5013H16.8333C15.55 14.5013 14.5 15.5513 14.5 16.8346V33.168C14.5 34.4513 15.55 35.5013 16.8333 35.5013H33.1667C34.45 35.5013 35.5 34.4513 35.5 33.168V16.8346C35.5 15.5513 34.45 14.5013 33.1667 14.5013ZM25 14.5013C25.6417 14.5013 26.1667 15.0263 26.1667 15.668C26.1667 16.3096 25.6417 16.8346 25 16.8346C24.3583 16.8346 23.8333 16.3096 23.8333 15.668C23.8333 15.0263 24.3583 14.5013 25 14.5013ZM25 19.168C26.9367 19.168 28.5 20.7313 28.5 22.668C28.5 24.6046 26.9367 26.168 25 26.168C23.0633 26.168 21.5 24.6046 21.5 22.668C21.5 20.7313 23.0633 19.168 25 19.168ZM32 33.168H18V31.5346C18 29.2013 22.6667 27.918 25 27.918C27.3333 27.918 32 29.2013 32 31.5346V33.168Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_204_12437"
          x1="0"
          y1="50.0011"
          x2="50"
          y2="50.0011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154297" />
          <stop offset="1" stopColor="#ED1E24" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'manual-step4': (
    <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="25" cy="25" r="25" fill="url(#paint0_linear_204_12443)" />
      <path
        d="M24.9997 13.332C18.5597 13.332 13.333 18.5587 13.333 24.9987C13.333 31.4387 18.5597 36.6654 24.9997 36.6654C31.4397 36.6654 36.6663 31.4387 36.6663 24.9987C36.6663 18.5587 31.4397 13.332 24.9997 13.332ZM29.2113 20.7287C30.4597 20.7287 31.463 21.732 31.463 22.9804C31.463 24.2287 30.4597 25.232 29.2113 25.232C27.963 25.232 26.9597 24.2287 26.9597 22.9804C26.948 21.732 27.963 20.7287 29.2113 20.7287ZM22.2113 18.8854C23.728 18.8854 24.9647 20.122 24.9647 21.6387C24.9647 23.1554 23.728 24.392 22.2113 24.392C20.6947 24.392 19.458 23.1554 19.458 21.6387C19.458 20.1104 20.683 18.8854 22.2113 18.8854ZM22.2113 29.537V33.912C19.4113 33.037 17.1947 30.8787 16.2147 28.1254C17.4397 26.8187 20.4963 26.1537 22.2113 26.1537C22.8297 26.1537 23.6113 26.247 24.428 26.4104C22.5147 27.4254 22.2113 28.767 22.2113 29.537ZM24.9997 34.332C24.6847 34.332 24.3813 34.3204 24.078 34.2854V29.537C24.078 27.8804 27.508 27.052 29.2113 27.052C30.4597 27.052 32.618 27.507 33.6913 28.3937C32.3263 31.8587 28.9547 34.332 24.9997 34.332Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_204_12443"
          x1="0"
          y1="50.0011"
          x2="50"
          y2="50.0011"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154297" />
          <stop offset="1" stopColor="#ED1E24" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'file-excel-icon': (
    <svg width="26" height="34" viewBox="0 0 26 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_363_14496)">
        <path
          d="M4.25 0C1.90586 0 0 1.90586 0 4.25V29.75C0 32.0941 1.90586 34 4.25 34H21.25C23.5941 34 25.5 32.0941 25.5 29.75V10.625H17C15.8246 10.625 14.875 9.67539 14.875 8.5V0H4.25ZM17 0V8.5H25.5L17 0ZM10.3395 16.6148L12.75 20.0613L15.1605 16.6148C15.6652 15.891 16.6613 15.7184 17.3785 16.223C18.0957 16.7277 18.275 17.7238 17.7703 18.441L14.6957 22.8438L17.777 27.2398C18.2816 27.9637 18.109 28.9531 17.3852 29.4578C16.6613 29.9625 15.6719 29.7898 15.1672 29.066L12.75 25.6195L10.3395 29.066C9.83477 29.7898 8.83867 29.9625 8.12148 29.4578C7.4043 28.9531 7.225 27.957 7.72969 27.2398L10.8043 22.8438L7.72305 18.4477C7.21836 17.7238 7.39102 16.7344 8.11484 16.2297C8.83867 15.725 9.82812 15.8977 10.3328 16.6215L10.3395 16.6148Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_363_14496">
          <rect width="25.5" height="34" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'seminar-time': (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#F88C00" />
      <path
        d="M14.9917 6.66675C10.3917 6.66675 6.66675 10.4001 6.66675 15.0001C6.66675 19.6001 10.3917 23.3334 14.9917 23.3334C19.6001 23.3334 23.3334 19.6001 23.3334 15.0001C23.3334 10.4001 19.6001 6.66675 14.9917 6.66675ZM15.0001 21.6667C11.3167 21.6667 8.33341 18.6834 8.33341 15.0001C8.33341 11.3167 11.3167 8.33341 15.0001 8.33341C18.6834 8.33341 21.6667 11.3167 21.6667 15.0001C21.6667 18.6834 18.6834 21.6667 15.0001 21.6667ZM14.8167 10.8334H14.7667C14.4334 10.8334 14.1667 11.1001 14.1667 11.4334V15.3667C14.1667 15.6584 14.3167 15.9334 14.5751 16.0834L18.0334 18.1584C18.3167 18.3251 18.6834 18.2417 18.8501 17.9584C19.0251 17.6751 18.9334 17.3001 18.6417 17.1334L15.4167 15.2167V11.4334C15.4167 11.1001 15.1501 10.8334 14.8167 10.8334Z"
        fill="white"
      />
    </svg>
  ),
  'send-mess-primary': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7792 20.8284L21.8291 3.2002C22.1543 2.37995 21.3482 1.57385 20.528 1.89912L2.89982 8.94898C2.22807 9.21061 2.05837 10.0733 2.56041 10.5753L5.8131 13.8422C6.16666 14.1957 6.73234 14.2381 7.12832 13.927L18.4562 5.27202L9.79411 16.5928C9.49006 16.9959 9.53248 17.5615 9.88604 17.9151L13.1529 21.1678C13.6549 21.6698 14.5176 21.5001 14.7792 20.8284Z"
        fill="#154398"
      />
    </svg>
  ),
  'refresh-icon': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.709 5.29182C13.3507 3.93349 11.4257 3.15016 9.30904 3.36682C6.25071 3.67516 3.73404 6.15849 3.39238 9.21682C2.93404 13.2585 6.05904 16.6668 10.0007 16.6668C12.659 16.6668 14.9424 15.1085 16.009 12.8668C16.2757 12.3085 15.8757 11.6668 15.259 11.6668C14.9507 11.6668 14.659 11.8335 14.5257 12.1085C13.584 14.1335 11.3257 15.4168 8.85904 14.8668C7.00904 14.4585 5.51738 12.9502 5.12571 11.1002C4.42571 7.86682 6.88404 5.00016 10.0007 5.00016C11.384 5.00016 12.6174 5.57516 13.5174 6.48349L12.259 7.74182C11.734 8.26682 12.1007 9.16682 12.8424 9.16682H15.834C16.2924 9.16682 16.6674 8.79182 16.6674 8.33349V5.34182C16.6674 4.60016 15.7674 4.22516 15.2424 4.75016L14.709 5.29182Z"
        fill="#212529"
      />
    </svg>
  ),
  'face-sad': (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28.2563 61.051C28.4875 60.733 28.95 60.733 29.1812 61.051C30.1352 62.3012 32.1225 65.2207 32.1225 66.666C32.1225 68.5449 30.6338 70.0625 28.6537 70.0625C26.8037 70.0625 25.185 68.5449 25.185 66.666C25.185 65.2207 27.3168 62.3012 28.2563 61.051ZM42.5938 65.0617C43.3092 65.6977 43.367 66.7961 42.7311 67.5115C42.0879 68.227 40.9967 68.2848 40.2162 67.6488C38.742 66.2686 36.7186 65.4375 34.5 65.4375C33.5389 65.4375 32.7656 64.6643 32.7656 63.7031C32.7656 62.742 33.5389 61.9688 34.5 61.9688C37.6074 61.9688 40.4475 63.1395 42.5938 65.0617ZM40.2523 52.7188C41.5314 52.7188 42.5648 53.7521 42.5648 55.0312C42.5648 56.3104 41.5314 57.3438 40.2523 57.3438C38.9154 57.3438 37.9398 56.3104 37.9398 55.0312C37.9398 53.7521 38.9154 52.7188 40.2523 52.7188ZM28.6898 57.3438C27.3529 57.3438 26.3773 56.3104 26.3773 55.0312C26.3773 53.7521 27.3529 52.7188 28.6898 52.7188C29.9689 52.7188 31.0023 53.7521 31.0023 55.0312C31.0023 56.3104 29.9689 57.3438 28.6898 57.3438ZM34.5 40C44.7184 40 53 48.2816 53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40ZM28.7115 72.375C30.4893 73.1193 32.4477 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 62.3084 20.8844 65.7844 23.2179 68.4293C23.9781 70.7418 26.1822 72.3678 28.7115 72.375Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  'face-frown': (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.399 68.8051C25.4957 68.4799 25.026 67.4826 25.3512 66.5865C26.6158 63.0816 30.3736 60.8125 34.5 60.8125C38.6264 60.8125 42.3842 63.0816 43.6488 66.5865C43.974 67.4826 43.5043 68.4799 42.601 68.8051C41.7049 69.1303 40.7076 68.6605 40.3824 67.7572C39.7176 65.9072 37.4773 64.2812 34.5 64.2812C31.5227 64.2812 29.2824 65.9072 28.6176 67.7572C28.2924 68.6605 27.2951 69.1303 26.399 68.8051ZM31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312ZM37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  'face-meh': (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312ZM42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312ZM39.7031 63.7031C40.6643 63.7031 41.4375 64.4764 41.4375 65.4375C41.4375 66.3986 40.6643 67.1719 39.7031 67.1719H29.2969C28.3357 67.1719 27.5625 66.3986 27.5625 65.4375C27.5625 64.4764 28.3357 63.7031 29.2969 63.7031H39.7031ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  'face-smile': (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M34.5 65.4375C37.1883 65.4375 39.0672 64.1729 40.1656 62.9877C40.8088 62.2867 41.9072 62.2361 42.6154 62.8865C43.3164 63.5369 43.3598 64.6354 42.7094 65.3363C41.1268 67.0635 38.3807 68.9062 34.5 68.9062C30.6193 68.9062 27.8732 67.0635 26.2906 65.3363C25.6402 64.6354 25.6186 63.5369 26.3846 62.8865C27.0928 62.2361 28.1912 62.2867 28.8344 62.9877C29.9328 64.1729 31.8117 65.4375 34.5 65.4375ZM31.0602 55.0312C31.0602 56.3104 30.0195 57.3438 28.7477 57.3438C27.4686 57.3438 26.4352 56.3104 26.4352 55.0312C26.4352 53.7521 27.4686 52.7188 28.7477 52.7188C30.0195 52.7188 31.0602 53.7521 31.0602 55.0312ZM37.9977 55.0312C37.9977 53.7521 39.0311 52.7188 40.3102 52.7188C41.582 52.7188 42.6227 53.7521 42.6227 55.0312C42.6227 56.3104 41.582 57.3438 40.3102 57.3438C39.0311 57.3438 37.9977 56.3104 37.9977 55.0312ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  'face-grin-hearts': (
    <svg
      width="69"
      height="117"
      viewBox="0 0 69 117"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M41.2568 62.2867C42.6082 61.9037 43.8512 63.1539 43.0346 64.3174C41.3219 67.0707 38.135 68.8412 34.4928 68.8412C30.8578 68.8412 27.6709 67.0707 25.8932 64.3174C25.1416 63.1539 26.3846 61.9037 27.7287 62.2867C29.8244 62.7709 32.1008 63.0383 34.4928 63.0383C36.8848 63.0383 39.1684 62.7709 41.2568 62.2867ZM33.2643 52.7982L31.9996 57.5605C31.8334 58.182 31.2047 58.5434 30.5832 58.3771L25.8787 57.1197C24.5924 56.7729 23.8336 55.4504 24.1732 54.1713C24.5201 52.885 25.8426 52.1189 27.0639 52.4658L28.2924 52.7766L28.6031 51.6131C28.95 50.3268 30.2725 49.568 31.5588 49.9076C32.8451 50.2545 33.6039 51.577 33.2643 52.7982ZM40.7076 52.7766L41.8711 52.4658C43.1574 52.1189 44.4799 52.885 44.8268 54.1713C45.1664 55.4504 44.4076 56.7729 43.1213 57.1197L38.4168 58.3771C37.7953 58.5434 37.1666 58.182 37.0004 57.5605L35.7357 52.7982C35.3961 51.577 36.1549 50.2545 37.4412 49.9076C38.7275 49.568 40.05 50.3268 40.3969 51.6131L40.7076 52.7766ZM53 58.5C53 68.7184 44.7184 77 34.5 77C24.2816 77 16 68.7184 16 58.5C16 48.2816 24.2816 40 34.5 40C44.7184 40 53 48.2816 53 58.5ZM34.5 43.4688C26.1967 43.4688 19.4688 50.1967 19.4688 58.5C19.4688 66.8033 26.1967 73.5312 34.5 73.5312C42.8033 73.5312 49.5312 66.8033 49.5312 58.5C49.5312 50.1967 42.8033 43.4688 34.5 43.4688Z"
        fill="#B2B2B2"
      />
    </svg>
  ),
  'order-step1': (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 21H35"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 25L35 25"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19 29L35 29"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5 40V14.875C13.5 14.5766 13.6185 14.2905 13.8295 14.0795C14.0405 13.8685 14.3266 13.75 14.625 13.75H39.375C39.6734 13.75 39.9595 13.8685 40.1705 14.0795C40.3815 14.2905 40.5 14.5766 40.5 14.875V40L35.5 36L31 40L26.5 36L22 40L17.5 36L13.5 40Z"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="27" cy="27" r="26" stroke="#154398" strokeWidth="2" />
    </svg>
  ),
  'order-step2': (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" fill="white" stroke="#154398" strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M31.871 10C32.0599 10 32.2362 10.0541 32.3851 10.1478C32.4462 10.1862 32.5032 10.2314 32.5551 10.2833L39.522 17.2502C39.7033 17.4315 39.8051 17.6773 39.8051 17.9337V24.9877C39.8051 25.5216 39.3723 25.9543 38.8384 25.9543C38.3045 25.9543 37.8718 25.5216 37.8718 24.9877V18.9002H31.871C31.3372 18.9002 30.9044 18.4674 30.9044 17.9335V11.9335H14.9333V41.9782H26.8554C27.3892 41.9782 27.8221 42.4109 27.8221 42.9448C27.8221 43.4787 27.3892 43.9114 26.8554 43.9114H13.9666C13.4328 43.9114 13 43.4787 13 42.9448V10.9669C13 10.433 13.4328 10.0001 13.9666 10.0001H31.8528L31.871 10ZM32.8377 16.9669V13.3L36.5045 16.9669H32.8377ZM20.7941 20.9378C20.2603 20.9378 19.8275 21.3706 19.8275 21.9045C19.8275 22.4384 20.2603 22.8711 20.7941 22.8711H31.3141C31.848 22.8711 32.2808 22.4384 32.2808 21.9045C32.2808 21.3706 31.848 20.9378 31.3141 20.9378H20.7941ZM16.7182 26.3633C16.7182 25.8294 17.151 25.3966 17.6849 25.3966H27.8218C28.3557 25.3966 28.7885 25.8294 28.7885 26.3633C28.7885 26.8972 28.3557 27.3299 27.8218 27.3299H17.6849C17.151 27.3299 16.7182 26.8972 16.7182 26.3633ZM18.007 29.8555C17.4731 29.8555 17.0404 30.2882 17.0404 30.8221C17.0404 31.356 17.4731 31.7887 18.007 31.7887H24.0857C24.6195 31.7887 25.0523 31.356 25.0523 30.8221C25.0523 30.2882 24.6195 29.8555 24.0857 29.8555H18.007ZM17.0404 35.2809C17.0404 34.747 17.4731 34.3143 18.007 34.3143H23.18C23.7138 34.3143 24.1466 34.747 24.1466 35.2809C24.1466 35.8148 23.7138 36.2475 23.18 36.2475H18.007C17.4731 36.2475 17.0404 35.8148 17.0404 35.2809ZM27.2644 35.0023C27.2644 31.1113 30.4186 27.957 34.3097 27.957C38.2006 27.957 41.3549 31.1113 41.3549 35.0023C41.3549 38.8933 38.2006 42.0475 34.3097 42.0475C30.4186 42.0475 27.2644 38.8933 27.2644 35.0023ZM34.3097 26.0238C29.3509 26.0238 25.331 30.0435 25.331 35.0023C25.331 39.961 29.3509 43.9809 34.3097 43.9809C39.2684 43.9809 43.2882 39.961 43.2882 35.0023C43.2882 30.0435 39.2684 26.0238 34.3097 26.0238Z"
        fill="#154398"
      />
      <path
        d="M34.2662 34.4158C36.0424 34.4158 37.4883 35.7011 37.4883 37.28C37.4883 38.61 36.4572 39.7217 35.0717 40.0421V40.7707C35.0717 41.2156 34.711 41.5762 34.2662 41.5762C33.8212 41.5762 33.4606 41.2156 33.4606 40.7707V40.0421C32.3616 39.7879 31.4857 39.036 31.1703 38.0722C31.032 37.6494 31.4046 37.28 31.8495 37.28C32.2944 37.28 32.6424 37.6706 32.8977 38.0349C33.1824 38.4411 33.6894 38.712 34.2662 38.712C35.1543 38.712 35.8772 38.0694 35.8772 37.28C35.8772 36.4905 35.1543 35.8479 34.2662 35.8479C32.49 35.8479 31.0439 34.5626 31.0439 32.9837C31.0439 31.6537 32.0751 30.542 33.4606 30.2216V29.493C33.4606 29.0482 33.8212 28.6875 34.2662 28.6875C34.711 28.6875 35.0717 29.0482 35.0717 29.493V30.2216C36.1706 30.4758 37.0466 31.2277 37.3619 32.1915C37.5003 32.6143 37.1277 32.9837 36.6828 32.9837C36.2379 32.9837 35.8899 32.5931 35.6346 32.2288C35.3499 31.8226 34.8428 31.5517 34.2662 31.5517C33.378 31.5517 32.6551 32.1943 32.6551 32.9837C32.6551 33.7732 33.378 34.4158 34.2662 34.4158Z"
        fill="#154398"
      />
    </svg>
  ),
  'order-step3': (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" fill="white" stroke="#154398" strokeWidth="2" />
      <path
        d="M43.0563 37.3135H41.9677V35.7329H43.0563C43.1247 35.7329 43.18 35.6772 43.18 35.6092V29.8996C43.18 29.8696 43.169 29.8407 43.1488 29.8178L37.455 23.4131C37.4317 23.3871 37.3977 23.3716 37.3625 23.3716H32.3658V35.7329H36.8291V37.3135H30.7852V21.791H37.3625C37.8486 21.791 38.3133 21.9993 38.6365 22.3628L44.3299 28.7675C44.6073 29.0793 44.7606 29.4815 44.7606 29.8996V35.6088C44.7606 36.5489 43.996 37.3135 43.0563 37.3135Z"
        fill="#154398"
      />
      <path
        d="M32.3665 37.3134H20.6643V35.7328H30.7858V19.953C30.7858 19.007 30.2057 18.2076 29.5194 18.2076H12.0448C11.358 18.208 10.7779 19.007 10.7779 19.953V35.3009C10.7779 35.5794 10.9292 35.7328 10.9794 35.7328H15.5296V37.3134H10.9794C9.99667 37.3134 9.19727 36.4108 9.19727 35.3009V19.953C9.19727 18.1191 10.4744 16.627 12.0448 16.627H29.5194C31.0893 16.627 32.3665 18.1187 32.3665 19.953V37.3134Z"
        fill="#154398"
      />
      <path
        d="M39.3987 39.7528C37.5462 39.7528 36.0391 38.2457 36.0391 36.3928C36.0391 34.5399 37.5458 33.0332 39.3987 33.0332C41.2516 33.0332 42.7583 34.5399 42.7583 36.3928C42.7583 38.2457 41.2512 39.7528 39.3987 39.7528ZM39.3987 34.6138C38.4179 34.6138 37.6197 35.412 37.6197 36.3928C37.6197 37.374 38.4179 38.1722 39.3987 38.1722C40.3795 38.1722 41.1777 37.374 41.1777 36.3928C41.1777 35.4116 40.3795 34.6138 39.3987 34.6138Z"
        fill="#154398"
      />
      <path
        d="M18.0959 39.7528C16.2435 39.7528 14.7363 38.2457 14.7363 36.3928C14.7363 34.5399 16.2435 33.0332 18.0959 33.0332C19.9484 33.0332 21.4556 34.5399 21.4556 36.3928C21.4556 38.2457 19.9484 39.7528 18.0959 39.7528ZM18.0959 34.6138C17.1152 34.6138 16.317 35.412 16.317 36.3928C16.317 37.374 17.1152 38.1722 18.0959 38.1722C19.0767 38.1722 19.8749 37.374 19.8749 36.3928C19.8749 35.4116 19.0767 34.6138 18.0959 34.6138Z"
        fill="#154398"
      />
      <path
        d="M43.9719 30.3433H35.936C35.0493 30.3433 34.3281 29.6221 34.3281 28.7354V22.582H35.9088V28.7358L43.9719 28.7627V30.3433Z"
        fill="#154398"
      />
    </svg>
  ),
  'order-step4': (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="27" cy="27" r="26" fill="white" stroke="#154398" strokeWidth="2" />
      <path
        d="M13 26L23 35.5L40 18"
        stroke="#154398"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'order-step5': (
    <svg width="54" height="54" viewBox="0 0 54 54" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle
        cx="27"
        cy="27"
        r="26"
        fill="url(#paint0_linear_1319_42017)"
        stroke="url(#paint1_linear_1319_42017)"
        strokeWidth="2"
      />
      <path
        d="M27.6203 35.8218L34.7128 40.3153C35.6194 40.8897 36.745 40.0354 36.476 38.9771L34.4268 30.9162C34.3691 30.6916 34.3759 30.4554 34.4465 30.2346C34.5171 30.0138 34.6486 29.8174 34.8258 29.668L41.1859 24.3744C42.0216 23.6788 41.5903 22.2919 40.5166 22.2222L32.2107 21.6832C31.987 21.6672 31.7724 21.588 31.592 21.4548C31.4116 21.3216 31.2727 21.1398 31.1915 20.9307L28.0938 13.1298C28.0096 12.9079 27.8598 12.7169 27.6645 12.582C27.4691 12.4472 27.2374 12.375 27 12.375C26.7626 12.375 26.5309 12.4472 26.3355 12.582C26.1402 12.7169 25.9905 12.9079 25.9062 13.1298L22.8085 20.9307C22.7273 21.1398 22.5885 21.3216 22.408 21.4548C22.2276 21.588 22.013 21.6672 21.7893 21.6832L13.4834 22.2222C12.4097 22.2919 11.9784 23.6788 12.8141 24.3744L19.1742 29.668C19.3514 29.8174 19.4829 30.0138 19.5535 30.2346C19.6241 30.4554 19.6309 30.6916 19.5732 30.9162L17.6728 38.3918C17.35 39.6617 18.7007 40.6869 19.7886 39.9976L26.3797 35.8218C26.5651 35.7038 26.7803 35.6411 27 35.6411C27.2197 35.6411 27.4349 35.7038 27.6203 35.8218V35.8218Z"
        fill="white"
        stroke="white"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1319_42017"
          x1="2"
          y1="27"
          x2="52"
          y2="27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154398" />
          <stop offset="1" stopColor="#ED1117" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1319_42017"
          x1="2"
          y1="27"
          x2="52"
          y2="27"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#154398" />
          <stop offset="1" stopColor="#ED1117" />
        </linearGradient>
      </defs>
    </svg>
  ),
  'call-received': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.0827 3.9249C15.7577 3.5999 15.2327 3.5999 14.9077 3.9249L5.83268 12.9916V8.33324C5.83268 7.8749 5.45768 7.4999 4.99935 7.4999C4.54102 7.4999 4.16602 7.8749 4.16602 8.33324V14.9999C4.16602 15.4582 4.54102 15.8332 4.99935 15.8332H11.666C12.1244 15.8332 12.4993 15.4582 12.4993 14.9999C12.4993 14.5416 12.1244 14.1666 11.666 14.1666H7.00768L16.0827 5.09157C16.3994 4.7749 16.3994 4.24157 16.0827 3.9249Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  'add-media-video': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M10.8333 17.5H3C2.72386 17.5 2.5 17.2762 2.5 17V3C2.5 2.72386 2.72386 2.5 3 2.5H17C17.2762 2.5 17.5 2.72386 17.5 3V10.8333"
        stroke="#ED1117"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.334 15.8335H15.834M18.334 15.8335H15.834M15.834 15.8335V13.3335M15.834 15.8335V18.3335"
        stroke="#ED1117"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.24807 7.09396C7.91474 6.90349 7.5 7.14417 7.5 7.52809V12.4716C7.5 12.8555 7.91474 13.0962 8.24807 12.9057L12.5736 10.4339C12.9095 10.242 12.9095 9.75766 12.5736 9.56574L8.24807 7.09396Z"
        stroke="#ED1117"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'filter-white': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.28784 3.75H16.7122C16.8332 3.75 16.9517 3.78517 17.0532 3.85124C17.1546 3.9173 17.2347 4.01142 17.2837 4.12215C17.3327 4.23288 17.3485 4.35546 17.3291 4.47498C17.3097 4.5945 17.2561 4.70583 17.1746 4.79542L12.0375 10.4462C11.9329 10.5613 11.875 10.7112 11.875 10.8666V15.2905C11.875 15.3934 11.8496 15.4947 11.801 15.5854C11.7525 15.6761 11.6823 15.7535 11.5967 15.8105L9.09669 17.4772C9.00256 17.54 8.89317 17.576 8.78018 17.5814C8.66718 17.5869 8.55483 17.5616 8.45509 17.5082C8.35535 17.4548 8.27197 17.3754 8.21383 17.2784C8.1557 17.1813 8.125 17.0703 8.125 16.9572V10.8666C8.125 10.7112 8.06705 10.5613 7.96246 10.4462L2.82538 4.79542C2.74393 4.70583 2.69026 4.5945 2.67089 4.47498C2.65152 4.35546 2.66729 4.23288 2.71627 4.12215C2.76525 4.01142 2.84535 3.9173 2.94682 3.85124C3.04829 3.78517 3.16676 3.75 3.28784 3.75V3.75Z"
        stroke="#666666"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'sort-up-down': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.3334 14.1759V9.16758C13.3334 8.70924 12.9584 8.33424 12.5 8.33424C12.0417 8.33424 11.6667 8.70924 11.6667 9.16758V14.1759H10.175C9.80002 14.1759 9.61669 14.6259 9.88336 14.8842L12.2084 17.2009C12.375 17.3592 12.6334 17.3592 12.8 17.2009L15.125 14.8842C15.3917 14.6259 15.2 14.1759 14.8334 14.1759H13.3334ZM7.20836 2.79258L4.88336 5.11758C4.61669 5.37591 4.80003 5.82591 5.17503 5.82591H6.66669V10.8342C6.66669 11.2926 7.04169 11.6676 7.50003 11.6676C7.95836 11.6676 8.33336 11.2926 8.33336 10.8342V5.82591H9.82503C10.2 5.82591 10.3834 5.37591 10.1167 5.11758L7.79169 2.79258C7.63336 2.63424 7.36669 2.63424 7.20836 2.79258Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
  'cancel-post': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.2496 4.75794C14.9246 4.43294 14.3996 4.43294 14.0746 4.75794L9.99961 8.82461L5.92461 4.74961C5.59961 4.42461 5.07461 4.42461 4.74961 4.74961C4.42461 5.07461 4.42461 5.59961 4.74961 5.92461L8.82461 9.99961L4.74961 14.0746C4.42461 14.3996 4.42461 14.9246 4.74961 15.2496C5.07461 15.5746 5.59961 15.5746 5.92461 15.2496L9.99961 11.1746L14.0746 15.2496C14.3996 15.5746 14.9246 15.5746 15.2496 15.2496C15.5746 14.9246 15.5746 14.3996 15.2496 14.0746L11.1746 9.99961L15.2496 5.92461C15.5663 5.60794 15.5663 5.07461 15.2496 4.75794Z"
        fill="#ED1117"
      />
    </svg>
  ),
  're-post': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.33333 7.50033V4.16699L2.5 10.0003L8.33333 15.8337V12.417C12.5 12.417 15.4167 13.7503 17.5 16.667C16.6667 12.5003 14.1667 8.33366 8.33333 7.50033Z"
        fill="#0D99FF"
      />
    </svg>
  ),
  'delete-black': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4.99935 15.8333C4.99935 16.75 5.74935 17.5 6.66602 17.5H13.3327C14.2493 17.5 14.9993 16.75 14.9993 15.8333V5.83333H4.99935V15.8333ZM6.66602 7.5H13.3327V15.8333H6.66602V7.5ZM12.916 3.33333L12.0827 2.5H7.91602L7.08268 3.33333H4.16602V5H15.8327V3.33333H12.916Z"
        fill="#666666"
      />
    </svg>
  ),
  'edit-black': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.7167 7.51667L12.4833 8.28333L4.93333 15.8333H4.16667V15.0667L11.7167 7.51667ZM14.7167 2.5C14.5083 2.5 14.2917 2.58333 14.1333 2.74167L12.6083 4.26667L15.7333 7.39167L17.2583 5.86667C17.5833 5.54167 17.5833 5.01667 17.2583 4.69167L15.3083 2.74167C15.1417 2.575 14.9333 2.5 14.7167 2.5ZM11.7167 5.15833L2.5 14.375V17.5H5.625L14.8417 8.28333L11.7167 5.15833Z"
        fill="#666666"
      />
    </svg>
  ),
  'search-black': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.5 14H14.71L14.43 13.73C15.41 12.59 16 11.11 16 9.5C16 5.91 13.09 3 9.5 3C5.91 3 3 5.91 3 9.5C3 13.09 5.91 16 9.5 16C11.11 16 12.59 15.41 13.73 14.43L14 14.71V15.5L19 20.49L20.49 19L15.5 14V14ZM9.5 14C7.01 14 5 11.99 5 9.5C5 7.01 7.01 5 9.5 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.5 14Z"
        fill="#666666"
      />
    </svg>
  ),
  dashboard: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8333 4.16667V5.83333H12.5V4.16667H15.8333ZM7.5 4.16667V9.16667H4.16667V4.16667H7.5ZM15.8333 10.8333V15.8333H12.5V10.8333H15.8333ZM7.5 14.1667V15.8333H4.16667V14.1667H7.5ZM17.5 2.5H10.8333V7.5H17.5V2.5ZM9.16667 2.5H2.5V10.8333H9.16667V2.5ZM17.5 9.16667H10.8333V17.5H17.5V9.16667ZM9.16667 12.5H2.5V17.5H9.16667V12.5Z"
        fill="#333"
      />
    </svg>
  ),
  dolar: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.83268 9.08333C7.94102 8.59167 7.33268 8.08333 7.33268 7.29167C7.33268 6.38333 8.17435 5.75 9.58268 5.75C10.766 5.75 11.3577 6.2 11.5743 6.91667C11.6743 7.25 11.9493 7.5 12.2993 7.5H12.5493C13.0993 7.5 13.491 6.95833 13.2993 6.44167C12.9493 5.45833 12.1327 4.64167 10.8327 4.325V3.75C10.8327 3.05833 10.2743 2.5 9.58268 2.5C8.89102 2.5 8.33268 3.05833 8.33268 3.75V4.3C6.71602 4.65 5.41602 5.7 5.41602 7.30833C5.41602 9.23333 7.00768 10.1917 9.33268 10.75C11.416 11.25 11.8327 11.9833 11.8327 12.7583C11.8327 13.3333 11.4243 14.25 9.58268 14.25C8.20768 14.25 7.49935 13.7583 7.22435 13.0583C7.09935 12.7333 6.81602 12.5 6.47435 12.5H6.24102C5.68268 12.5 5.29102 13.0667 5.49935 13.5833C5.97435 14.7417 7.08268 15.425 8.33268 15.6917V16.25C8.33268 16.9417 8.89102 17.5 9.58268 17.5C10.2743 17.5 10.8327 16.9417 10.8327 16.25V15.7083C12.4577 15.4 13.7493 14.4583 13.7493 12.75C13.7493 10.3833 11.7243 9.575 9.83268 9.08333Z"
        fill="#212529"
      />
    </svg>
  ),
  'shopping-icon': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.334 7.50026H14.3423L10.6923 2.03359C10.534 1.80026 10.2673 1.68359 10.0007 1.68359C9.73398 1.68359 9.46732 1.80026 9.30898 2.04193L5.65898 7.50026H1.66732C1.20898 7.50026 0.833984 7.87526 0.833984 8.33359C0.833984 8.40859 0.842318 8.48359 0.867318 8.55859L2.98398 16.2836C3.17565 16.9836 3.81732 17.5003 4.58398 17.5003H15.4173C16.184 17.5003 16.8257 16.9836 17.0257 16.2836L19.1423 8.55859L19.1673 8.33359C19.1673 7.87526 18.7923 7.50026 18.334 7.50026ZM10.0007 4.00026L12.334 7.50026H7.66732L10.0007 4.00026ZM15.4173 15.8336L4.59232 15.8419L2.75898 9.16693H17.2507L15.4173 15.8336ZM10.0007 10.8336C9.08398 10.8336 8.33398 11.5836 8.33398 12.5003C8.33398 13.4169 9.08398 14.1669 10.0007 14.1669C10.9173 14.1669 11.6673 13.4169 11.6673 12.5003C11.6673 11.5836 10.9173 10.8336 10.0007 10.8336Z"
        fill="#212529"
      />
    </svg>
  ),
  'check-box-buy-water': (
    <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="15" cy="15" r="15" fill="#DDDDDD" />
      <path d="M6 15L12.5 21L23 10" stroke="white" strokeWidth="3" />
    </svg>
  ),
  'dang-ky-mua-nuoc': (
    <svg width="38" height="36" viewBox="0 0 38 36" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.41618 6.01953C5.62829 6.01953 4.09807 7.45231 4.09807 9.33772V14.7157H1.85319C1.32721 14.7157 0.900879 15.142 0.900879 15.668C0.900879 16.1939 1.32721 16.6202 1.85319 16.6202H4.09807V26.0974H1.85319C1.32721 26.0974 0.900879 26.5237 0.900879 27.0497C0.900879 27.5756 1.32721 28.002 1.85319 28.002H4.09807V32.6126C4.09807 34.4005 5.53078 35.9308 7.41618 35.9308H22.8902C23.1427 35.9308 23.385 35.8304 23.5635 35.6518L29.9578 29.2577C30.1364 29.079 30.2367 28.8368 30.2367 28.5843V13.8776C30.2367 13.3517 29.8103 12.9253 29.2844 12.9253C28.7585 12.9253 28.3322 13.3517 28.3322 13.8776V27.568H22.8901C22.3642 27.568 21.9379 27.9943 21.9379 28.5203V34.0262H7.41618C6.61606 34.0262 6.00261 33.3824 6.00261 32.6126V28.002H8.24734C8.77332 28.002 9.19965 27.5756 9.19965 27.0497C9.19965 26.5237 8.77332 26.0974 8.24734 26.0974H6.00261V16.6202H8.24734C8.77332 16.6202 9.19965 16.1939 9.19965 15.668C9.19965 15.142 8.77332 14.7157 8.24734 14.7157H6.00261V9.33772C6.00261 8.53752 6.64642 7.92415 7.41618 7.92415H26.1513C26.6772 7.92415 27.1035 7.49775 27.1035 6.97184C27.1035 6.44593 26.6772 6.01953 26.1513 6.01953H7.41618ZM23.8424 32.6796L27.0494 29.4726H23.8424V32.6796Z"
        fill="#EAFEFF"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.1155 1.91945C30.9468 1.08823 32.0338 0.640625 33.1847 0.640625C34.2718 0.640625 35.3588 1.08823 36.1261 1.98343C36.9573 2.75068 37.4049 3.83774 37.4049 4.98869C37.4049 6.13965 36.9573 7.16273 36.19 7.99396L23.2098 20.9742C22.3785 21.7415 21.3555 22.1891 20.2685 22.1891H15.9204V17.841C15.9204 16.6901 16.368 15.667 17.1353 14.8997L30.1155 1.91945ZM22.7297 18.8918L32.6732 8.88916L29.1564 5.37232L19.213 15.375L22.7297 18.8918ZM17.9542 16.8097C17.796 17.124 17.7107 17.4718 17.7107 17.841V20.3987H20.2685C20.6376 20.3987 20.9855 20.3135 21.2998 20.1552L17.9542 16.8097ZM33.9521 7.67423L34.9112 6.65115C35.4227 6.20362 35.6785 5.56417 35.7424 4.86082C35.8064 4.22137 35.4866 3.51801 35.039 3.07041C34.5914 2.62281 33.9521 2.36706 33.2487 2.36706C32.5454 2.36706 31.9059 2.62281 31.4583 3.13439L30.4352 4.15747L33.9521 7.67423ZM29.8967 8.02705C30.2668 8.40063 30.2641 9.00359 29.8905 9.3737L22.9208 16.2795C22.5472 16.6496 21.9442 16.6469 21.5741 16.2733C21.2039 15.8996 21.2067 15.2968 21.5803 14.9266L28.55 8.02077C28.9235 7.65066 29.5265 7.6534 29.8967 8.02705Z"
        fill="#FFF501"
      />
    </svg>
  ),
  'tra-cuu-su-dung-nuoc': (
    <svg width="40" height="29" viewBox="0 0 40 29" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M20 0C8.97278 0 0 8.82788 0 19.677V23.819C0 26.6775 2.36058 29 5.26196 29H34.736C37.6374 29 40 26.6775 40 23.821V19.679C40 8.82788 31.0272 0 20 0ZM37.896 23.821C37.896 25.5337 36.4788 26.928 34.738 26.928H5.26196C3.5211 26.928 2.10399 25.5337 2.10399 23.821V20.714H5.26196C5.84222 20.714 6.31396 20.2499 6.31396 19.679C6.31594 19.1062 5.84421 18.6421 5.26196 18.6421H2.15726C2.40004 14.568 4.04817 10.8706 6.64167 8.00267L8.72788 10.0533C8.93516 10.2553 9.20358 10.3582 9.47398 10.3582C9.74439 10.3582 10.0128 10.2572 10.2201 10.0553C10.6306 9.65136 10.6306 8.99502 10.2201 8.59106L8.1338 6.54049C11.0491 3.98886 14.8071 2.36547 18.9478 2.12655V5.17923C18.9478 5.75012 19.4196 6.21423 19.9998 6.21423C20.5801 6.21423 21.0518 5.75012 21.0518 5.17923V2.12467C25.1928 2.36352 28.9508 3.98496 31.8658 6.53854L29.7795 8.58918C29.369 8.99307 29.369 9.64941 29.7795 10.0533C29.9868 10.2553 30.2572 10.3582 30.5256 10.3582C30.796 10.3582 31.0645 10.2572 31.2718 10.0553L33.358 8.00462C36.1706 11.1155 37.8977 15.1994 37.8977 19.681V23.8211L37.896 23.821Z"
        fill="white"
      />
      <path
        d="M32.7738 16.2152L25.1932 17.5333C24.4293 15.4727 22.5212 14 20.2787 14C17.3692 14 15 16.4669 15 19.5011C15 22.5352 17.3692 25 20.2787 25C23.1229 25 25.4328 22.6425 25.5377 19.7012L33.1183 18.3831C33.6923 18.2841 34.0822 17.7169 33.9852 17.1188C33.8921 16.5186 33.3459 16.1143 32.7739 16.2153L32.7738 16.2152ZM20.2788 22.8014C18.5331 22.8014 17.112 21.3205 17.112 19.5012C17.112 17.682 18.5331 16.201 20.2788 16.201C21.8484 16.201 23.1428 17.3973 23.3922 18.9608C23.4219 19.1383 23.4457 19.3176 23.4457 19.5012C23.4457 21.3205 22.0245 22.8014 20.2788 22.8014Z"
        fill="#FFF001"
      />
    </svg>
  ),
  'hoa-don-dien-tu': (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M33.2192 3.20672H27.4339C27.1195 2.27578 26.2384 1.60341 25.2026 1.60341H23.5576C22.8149 0.604781 21.6387 0 20.3926 0C19.1465 0 17.9702 0.604781 17.2276 1.60331H15.5826C14.5468 1.60331 13.6658 2.27569 13.3513 3.20663H7.56574C5.82518 3.20663 4.40918 4.62272 4.40918 6.36319V40.0333C4.40918 41.7739 5.82527 43.1899 7.56574 43.1899H23.5991C24.0142 43.1899 24.3507 42.8534 24.3507 42.4383C24.3507 42.0233 24.0143 41.6867 23.5991 41.6867H7.56574C6.65402 41.6867 5.91227 40.9449 5.91227 40.0332V6.36328C5.91227 5.45156 6.65402 4.70981 7.56574 4.70981H13.2277V7.16494C13.2277 7.57997 13.5641 7.91653 13.9793 7.91653H26.806C27.221 7.91653 27.5576 7.58006 27.5576 7.16494V4.70981H33.2192C34.1309 4.70981 34.8727 5.45156 34.8727 6.36328V28.0084C34.8727 28.4234 35.2091 28.76 35.6243 28.76C36.0393 28.76 36.3759 28.4235 36.3759 28.0084V6.36328C36.3758 4.62272 34.9598 3.20672 33.2192 3.20672ZM26.0545 6.41334H14.7309V3.96113C14.7309 3.96009 14.731 3.95925 14.731 3.95822C14.731 3.95775 14.7309 3.95719 14.7309 3.95681C14.7317 3.48769 15.1134 3.10641 15.5826 3.10641H17.6306C17.8982 3.10641 18.1456 2.96419 18.2802 2.73281C18.7285 1.96284 19.5181 1.50309 20.3926 1.50309C21.2671 1.50309 22.0568 1.96284 22.505 2.73281C22.6395 2.96409 22.887 3.10641 23.1546 3.10641H25.2026C25.6713 3.10641 26.0527 3.48694 26.0544 3.95531C26.0544 3.95634 26.0543 3.95719 26.0543 3.95822C26.0543 3.96019 26.0546 3.96206 26.0546 3.96403L26.0545 6.41334Z"
        fill="white"
      />
      <path
        d="M23.599 38.4809H9.11906V7.91725H10.7728C11.1878 7.91725 11.5244 7.58078 11.5244 7.16566C11.5244 6.75053 11.1879 6.41406 10.7728 6.41406H8.36756C7.95253 6.41406 7.61597 6.75053 7.61597 7.16566V39.2325C7.61597 39.6475 7.95244 39.9841 8.36756 39.9841H23.5991C24.0142 39.9841 24.3507 39.6476 24.3507 39.2325C24.3506 38.8173 24.0142 38.4809 23.599 38.4809Z"
        fill="white"
      />
      <path
        d="M32.4175 6.41406H30.0126C29.5975 6.41406 29.261 6.75053 29.261 7.16566C29.261 7.58078 29.5975 7.91725 30.0126 7.91725H31.666V28.0089C31.666 28.4239 32.0025 28.7605 32.4176 28.7605C32.8328 28.7605 33.1692 28.424 33.1692 28.0089V7.16566C33.1691 6.75063 32.8326 6.41406 32.4175 6.41406Z"
        fill="white"
      />
      <path
        d="M34.8225 30.4609C29.9876 30.4609 26.0542 34.3943 26.0542 39.2292C26.0542 44.0641 29.9877 47.9974 34.8225 47.9974C39.6572 47.9974 43.5907 44.0641 43.5907 39.2292C43.5907 34.3943 39.6573 30.4609 34.8225 30.4609ZM34.8225 46.4943C30.8164 46.4943 27.5573 43.2352 27.5573 39.2292C27.5573 35.2232 30.8164 31.964 34.8225 31.964C38.8285 31.964 42.0876 35.2232 42.0876 39.2292C42.0876 43.2352 38.8286 46.4943 34.8225 46.4943Z"
        fill="white"
      />
      <path
        d="M20.4006 3.20703H20.3926C19.9776 3.20703 19.645 3.5435 19.645 3.95862C19.645 4.37366 19.9854 4.71022 20.4006 4.71022C20.8156 4.71022 21.1521 4.37375 21.1521 3.95862C21.1522 3.5435 20.8158 3.20703 20.4006 3.20703Z"
        fill="white"
      />
      <path
        d="M39.3624 36.2944C39.0689 36.0008 38.593 36.0008 38.2995 36.2944L33.2192 41.3747L30.544 38.6994C30.2504 38.4059 29.7746 38.4059 29.4811 38.6994C29.1876 38.993 29.1876 39.4688 29.4811 39.7623L32.6879 42.969C32.8346 43.1157 33.0269 43.1891 33.2192 43.1891C33.4115 43.1891 33.6039 43.1158 33.7506 42.969L39.3623 37.3573C39.6558 37.0637 39.6558 36.5878 39.3624 36.2944Z"
        fill="#FFF501"
      />
      <path
        d="M17.1357 16.6221V13.5904C18.1946 13.7717 18.8392 14.3112 18.8392 14.705C18.8392 15.12 19.1757 15.4566 19.5908 15.4566C20.0059 15.4566 20.3424 15.1201 20.3424 14.705C20.3424 13.3765 18.9838 12.303 17.1357 12.0714V11.9743C17.1357 11.5592 16.7992 11.2227 16.3841 11.2227C15.969 11.2227 15.6325 11.5591 15.6325 11.9743V12.0714C13.7844 12.3029 12.4258 13.3764 12.4258 14.705C12.4258 16.5869 14.191 17.3101 15.6325 17.7482V20.7799C14.5736 20.5986 13.929 20.0592 13.929 19.6653C13.929 19.2503 13.5925 18.9137 13.1774 18.9137C12.7622 18.9137 12.4258 19.2502 12.4258 19.6653C12.4258 20.9938 13.7844 22.0673 15.6325 22.2989V22.3961C15.6325 22.8111 15.969 23.1477 16.3841 23.1477C16.7992 23.1477 17.1357 22.8112 17.1357 22.3961V22.2989C18.9838 22.0674 20.3424 20.9939 20.3424 19.6653C20.3423 17.7835 18.5772 17.0602 17.1357 16.6221ZM15.6325 16.1629C14.3646 15.7211 13.929 15.3226 13.929 14.705C13.929 14.4673 14.1386 14.2048 14.504 13.985C14.8128 13.7992 15.2046 13.6648 15.6325 13.5914V16.1629ZM18.2642 20.3853C17.9553 20.5711 17.5636 20.7055 17.1357 20.7789V18.2074C18.4036 18.6493 18.8392 19.0477 18.8392 19.6653C18.8392 19.9031 18.6296 20.1655 18.2642 20.3853Z"
        fill="#FFF501"
      />
      <path
        d="M27.6076 12.8281H23.5992C23.1842 12.8281 22.8477 13.1646 22.8477 13.5797C22.8477 13.9948 23.1841 14.3313 23.5992 14.3313H27.6076C28.0227 14.3313 28.3592 13.9948 28.3592 13.5797C28.3592 13.1646 28.0228 12.8281 27.6076 12.8281Z"
        fill="white"
      />
      <path
        d="M26.0042 16.0352H23.5993C23.1842 16.0352 22.8477 16.3716 22.8477 16.7867C22.8477 17.2019 23.1841 17.5383 23.5993 17.5383H26.0042C26.4192 17.5383 26.7558 17.2019 26.7558 16.7867C26.7558 16.3716 26.4192 16.0352 26.0042 16.0352Z"
        fill="white"
      />
      <path
        d="M27.6074 19.2383H23.599C23.184 19.2383 22.8474 19.5747 22.8474 19.9899C22.8474 20.405 23.1839 20.7415 23.599 20.7415H27.6074C28.0224 20.7415 28.359 20.405 28.359 19.9899C28.359 19.5747 28.0225 19.2383 27.6074 19.2383Z"
        fill="white"
      />
      <path
        d="M14.7809 26.457H13.1776C12.7626 26.457 12.426 26.7935 12.426 27.2086C12.426 27.6237 12.7625 27.9602 13.1776 27.9602H14.7809C15.196 27.9602 15.5325 27.6237 15.5325 27.2086C15.5325 26.7935 15.196 26.457 14.7809 26.457Z"
        fill="white"
      />
      <path
        d="M14.7807 32.8672H13.1774C12.7623 32.8672 12.4258 33.2037 12.4258 33.6188C12.4258 34.0339 12.7622 34.3704 13.1774 34.3704H14.7807C15.1957 34.3704 15.5323 34.0339 15.5323 33.6188C15.5323 33.2037 15.1957 32.8672 14.7807 32.8672Z"
        fill="white"
      />
      <path
        d="M14.7807 29.6641H13.1774C12.7623 29.6641 12.4258 30.0005 12.4258 30.4157C12.4258 30.8308 12.7622 31.1672 13.1774 31.1672H14.7807C15.1957 31.1672 15.5323 30.8308 15.5323 30.4157C15.5323 30.0005 15.1957 29.6641 14.7807 29.6641Z"
        fill="white"
      />
      <path
        d="M27.6075 26.457H17.9874C17.5724 26.457 17.2358 26.7935 17.2358 27.2086C17.2358 27.6237 17.5723 27.9602 17.9874 27.9602H27.6075C28.0225 27.9602 28.3591 27.6237 28.3591 27.2086C28.3591 26.7935 28.0226 26.457 27.6075 26.457Z"
        fill="white"
      />
      <path
        d="M25.2024 32.8672H17.9874C17.5724 32.8672 17.2358 33.2037 17.2358 33.6188C17.2358 34.0339 17.5723 34.3704 17.9874 34.3704H25.2024C25.6175 34.3704 25.954 34.0339 25.954 33.6188C25.954 33.2037 25.6175 32.8672 25.2024 32.8672Z"
        fill="white"
      />
      <path
        d="M27.6075 29.6641H17.9874C17.5724 29.6641 17.2358 30.0005 17.2358 30.4157C17.2358 30.8308 17.5723 31.1672 17.9874 31.1672H27.6075C28.0225 31.1672 28.3591 30.8308 28.3591 30.4157C28.3591 30.0005 28.0226 29.6641 27.6075 29.6641Z"
        fill="white"
      />
    </svg>
  ),
  'thanh-toan-truc-tuyen': (
    <svg width="32" height="35" viewBox="0 0 32 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7265 0.378906C19.9154 0.378906 20.0916 0.433056 20.2406 0.526728C20.3017 0.565068 20.3587 0.610352 20.4105 0.662212L27.3774 7.62911C27.5587 7.8104 27.6605 8.05625 27.6605 8.31259V15.3666C27.6605 15.9005 27.2278 16.3332 26.6939 16.3332C26.16 16.3332 25.7273 15.9005 25.7273 15.3666V9.27908H19.7265C19.1927 9.27908 18.7598 8.84633 18.7598 8.31244V2.31241H2.78875V32.3571H14.7109C15.2447 32.3571 15.6775 32.7898 15.6775 33.3237C15.6775 33.8576 15.2447 34.2903 14.7109 34.2903H1.82211C1.28822 34.2903 0.855469 33.8576 0.855469 33.3237V1.34577C0.855469 0.811881 1.28822 0.379053 1.82211 0.379053H19.7082L19.7265 0.378906ZM20.6932 7.3458V3.67893L24.36 7.3458H20.6932ZM8.6496 11.3167C8.11579 11.3167 7.68297 11.7495 7.68297 12.2834C7.68297 12.8173 8.11579 13.25 8.6496 13.25H19.1696C19.7035 13.25 20.1363 12.8173 20.1363 12.2834C20.1363 11.7495 19.7035 11.3167 19.1696 11.3167H8.6496ZM4.57369 16.7422C4.57369 16.2083 5.00644 15.7756 5.54033 15.7756H15.6773C16.2112 15.7756 16.644 16.2083 16.644 16.7422C16.644 17.2761 16.2112 17.7088 15.6773 17.7088H5.54033C5.00644 17.7088 4.57369 17.2761 4.57369 16.7422ZM5.86249 20.2344C5.32861 20.2344 4.89585 20.6671 4.89585 21.201C4.89585 21.7349 5.32861 22.1676 5.86249 22.1676H11.9411C12.4749 22.1676 12.9078 21.7349 12.9078 21.201C12.9078 20.6671 12.4749 20.2344 11.9411 20.2344H5.86249ZM4.89585 25.6598C4.89585 25.1259 5.32861 24.6932 5.86249 24.6932H11.0354C11.5693 24.6932 12.0021 25.1259 12.0021 25.6598C12.0021 26.1937 11.5693 26.6264 11.0354 26.6264H5.86249C5.32861 26.6264 4.89585 26.1937 4.89585 25.6598ZM15.1199 25.3812C15.1199 21.4902 18.2741 18.3359 22.1651 18.3359C26.0561 18.3359 29.2103 21.4902 29.2103 25.3812C29.2103 29.2722 26.0561 32.4264 22.1651 32.4264C18.2741 32.4264 15.1199 29.2722 15.1199 25.3812ZM22.1651 16.4027C17.2063 16.4027 13.1865 20.4224 13.1865 25.3812C13.1865 30.3399 17.2063 34.3598 22.1651 34.3598C27.1238 34.3598 31.1437 30.3399 31.1437 25.3812C31.1437 20.4224 27.1238 16.4027 22.1651 16.4027Z"
        fill="white"
      />
      <path
        d="M22.1216 24.7947C23.8979 24.7947 25.3438 26.08 25.3438 27.6589C25.3438 28.9889 24.3127 30.1006 22.9272 30.421V31.1496C22.9272 31.5945 22.5665 31.9551 22.1216 31.9551C21.6767 31.9551 21.316 31.5945 21.316 31.1496V30.421C20.2171 30.1668 19.3412 29.415 19.0258 28.4511C18.8874 28.0283 19.2601 27.6589 19.705 27.6589C20.1499 27.6589 20.4978 28.0495 20.7532 28.4138C21.0378 28.82 21.5449 29.0909 22.1216 29.0909C23.0098 29.0909 23.7327 28.4483 23.7327 27.6589C23.7327 26.8694 23.0098 26.2268 22.1216 26.2268C20.3454 26.2268 18.8994 24.9415 18.8994 23.3626C18.8994 22.0326 19.9305 20.9209 21.316 20.6005V19.8719C21.316 19.4271 21.6767 19.0664 22.1216 19.0664C22.5665 19.0664 22.9272 19.4271 22.9272 19.8719V20.6005C24.0261 20.8547 24.902 21.6066 25.2174 22.5704C25.3558 22.9932 24.9831 23.3626 24.5383 23.3626C24.0933 23.3626 23.7454 22.972 23.4901 22.6077C23.2054 22.2015 22.6983 21.9306 22.1216 21.9306C21.2335 21.9306 20.5105 22.5732 20.5105 23.3626C20.5105 24.1521 21.2335 24.7947 22.1216 24.7947Z"
        fill="#FFF001"
      />
    </svg>
  ),
  'sua-chua': (
    <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_552_10132)">
        <path
          d="M31.7058 10.5995C30.118 6.82871 27.1858 3.78242 23.4782 2.05204C19.7707 0.321651 15.5525 0.0306268 11.6425 1.23546C7.73244 2.4403 4.4096 5.05503 2.31902 8.57205C0.228435 12.0891 -0.480721 16.2574 0.329222 20.2679C1.13917 24.2784 3.41042 27.8448 6.70205 30.2749C9.99368 32.7049 14.0708 33.8252 18.142 33.4181C22.2131 33.0111 25.9878 31.1059 28.7332 28.0723C31.4786 25.0387 32.9988 21.0932 32.9988 17.0017C33.0017 14.8025 32.5619 12.6252 31.7058 10.5995ZM29.8124 22.6031C28.4233 25.9045 25.857 28.5719 22.6117 30.0874C19.3664 31.603 15.6737 31.8585 12.2506 30.8045C8.82747 29.7504 5.91817 27.4619 4.08752 24.3834C2.25687 21.3048 1.6355 17.6558 2.34405 14.1449C3.0526 10.634 5.04051 7.51156 7.92184 5.38394C10.8032 3.25632 14.3723 2.27528 17.9363 2.6313C21.5003 2.98732 24.8048 4.65499 27.2083 7.31053C29.6118 9.96607 30.9428 13.42 30.9429 17.0017C30.9455 18.9258 30.5611 20.8307 29.8124 22.6031V22.6031Z"
          fill="white"
        />
        <path
          d="M21.4629 18.4041C21.4014 18.342 21.3323 18.2881 21.2573 18.2435C22.1317 16.0269 21.6749 13.4015 19.8846 11.6116C19.0359 10.763 17.9582 10.1803 16.7834 9.93499C15.6086 9.68965 14.3878 9.79225 13.2704 10.2302C13.1113 10.2924 12.9702 10.3931 12.8599 10.5234C12.7495 10.6538 12.6734 10.8095 12.6383 10.9766C12.6033 11.1438 12.6104 11.317 12.659 11.4807C12.7077 11.6443 12.7964 11.7933 12.917 11.9142L14.795 13.7921L13.3414 15.2457L11.4647 13.369C11.3439 13.2484 11.1949 13.1597 11.0312 13.111C10.8675 13.0624 10.6943 13.0553 10.5272 13.0903C10.3601 13.1254 10.2043 13.2015 10.074 13.3119C9.9437 13.4223 9.84292 13.5633 9.7808 13.7224C9.33214 14.8715 9.23815 16.1287 9.51096 17.3318C9.78376 18.5348 10.4108 19.6285 11.3113 20.4717C12.2117 21.3149 13.3441 21.869 14.5625 22.0623C15.7809 22.2556 17.0292 22.0794 18.1464 21.5564L20.6974 24.1073C20.9093 24.3219 21.1615 24.4925 21.4396 24.6092C21.7176 24.7259 22.016 24.7865 22.3176 24.7874C22.6192 24.7884 22.918 24.7297 23.1968 24.6147C23.4756 24.4998 23.7289 24.3308 23.9421 24.1175C24.1554 23.9043 24.3243 23.651 24.4393 23.3722C24.5543 23.0934 24.613 22.7946 24.612 22.493C24.6111 22.1915 24.5505 21.8931 24.4338 21.615C24.317 21.3369 24.1465 21.0847 23.9319 20.8728L21.4629 18.4041ZM12.6157 18.8814C11.9074 18.1733 11.4819 17.2309 11.4191 16.2312L12.6157 17.4278C12.8085 17.6206 13.0699 17.7288 13.3425 17.7288C13.6151 17.7288 13.8765 17.6206 14.0693 17.4278L16.9768 14.5203C17.1695 14.3276 17.2778 14.0661 17.2778 13.7935C17.2778 13.521 17.1695 13.2595 16.9768 13.0667L15.7805 11.8698C16.4445 11.9115 17.0884 12.1137 17.657 12.459C18.2257 12.8043 18.702 13.2824 19.0452 13.8523C19.3884 14.4222 19.5882 15.0669 19.6275 15.731C19.6667 16.3951 19.5442 17.0588 19.2706 17.6652C18.9969 18.2715 18.5801 18.8024 18.0561 19.2123C17.5321 19.6222 16.9165 19.8988 16.2621 20.0184C15.6076 20.138 14.934 20.097 14.2989 19.899C13.6638 19.701 13.0862 19.3518 12.6157 18.8814V18.8814ZM22.4776 22.6534C22.4343 22.6967 22.3755 22.7211 22.3141 22.7211C22.2528 22.7211 22.194 22.6967 22.1506 22.6534L19.858 20.3607L19.884 20.3354C19.9853 20.2341 20.0817 20.1302 20.1731 20.0238L22.476 22.3267C22.4976 22.348 22.5148 22.3734 22.5266 22.4013C22.5383 22.4293 22.5445 22.4593 22.5447 22.4896C22.5449 22.52 22.5391 22.5501 22.5276 22.5782C22.5162 22.6062 22.4993 22.6318 22.478 22.6534H22.4776Z"
          fill="#FFF501"
        />
      </g>
      <defs>
        <clipPath id="clip0_552_10132">
          <rect width="33.0967" height="33" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  ),
  'lap-dat': (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_552_10119)">
        <path
          d="M6.79384 1.24144e-05C5.72135 1.24144e-05 4.74374 0.193885 3.76612 0.68063C3.18038 0.973502 2.98238 1.75312 3.47325 2.23986L6.79384 5.54808L5.62235 6.7175L2.30176 3.40723C2.21569 3.31168 2.10986 3.236 1.99163 3.18543C1.87339 3.13486 1.74557 3.11061 1.61702 3.11435C1.22515 3.11435 0.932279 3.31029 0.738406 3.7001C0.0952743 4.98114 -0.128307 6.43213 0.0993581 7.84735C0.327023 9.26258 0.994383 10.5702 2.00683 11.585C3.37425 12.9462 5.03661 13.5299 6.79384 13.5299C7.57758 13.5299 8.3572 13.4329 9.04194 13.1421L19.8844 23.9474C19.0058 26.3812 19.5915 29.1057 21.4478 31.0527C22.8152 32.4139 24.4755 32.9997 26.2327 32.9997C27.3093 32.9997 28.2849 32.8058 29.2645 32.319C29.8482 32.0262 30.0442 31.2466 29.5553 30.7598L26.2348 27.4516L27.4062 26.2822L30.7268 29.5924C30.8129 29.688 30.9187 29.7637 31.037 29.8142C31.1552 29.8648 31.283 29.8891 31.4116 29.8853C31.8034 29.8853 32.0963 29.6894 32.2902 29.2996C32.9333 28.0185 33.1569 26.5675 32.9292 25.1523C32.7016 23.7371 32.0342 22.4294 31.0218 21.4147C29.6544 20.0535 27.992 19.4698 26.2348 19.4698C25.451 19.4698 24.6714 19.5667 23.8897 19.8576L13.0493 9.05429C13.928 6.62057 13.3422 3.89603 11.486 1.94905C10.8717 1.32992 10.1407 0.838849 9.33524 0.504285C8.52981 0.169721 7.66599 -0.00168018 6.79384 1.24144e-05ZM5.52336 8.76142C5.77888 8.7595 6.03149 8.70693 6.26656 8.60674C6.50163 8.50655 6.7145 8.36074 6.89284 8.17774L8.06433 7.00831C8.24938 6.83294 8.39676 6.6217 8.49747 6.38749C8.59819 6.15327 8.65013 5.901 8.65013 5.64605C8.65013 5.3911 8.59819 5.13882 8.49747 4.90461C8.39676 4.67039 8.24938 4.45915 8.06433 4.28378L5.81623 2.04187C6.11116 2.04187 6.40403 1.94493 6.69691 1.94493C7.96739 1.94493 9.23582 2.43167 10.1165 3.40516C11.4839 4.7664 11.8737 6.71544 11.288 8.46649C10.9951 9.1471 11.191 9.92672 11.7768 10.5104L22.6192 21.3178C23.0111 21.7055 23.4999 21.8994 23.9867 21.8994C24.1826 21.8994 24.4755 21.8994 24.6714 21.8025C25.2021 21.6036 25.765 21.505 26.3317 21.5117C27.6022 21.5117 28.8727 21.9984 29.7513 22.9719C30.9228 24.1393 31.4116 25.6964 31.1187 27.2536L28.8706 25.0158C28.6927 24.8333 28.4806 24.6878 28.2462 24.5876C28.0119 24.4874 27.7601 24.4346 27.5052 24.4321C27.2497 24.434 26.9971 24.4866 26.762 24.5868C26.527 24.687 26.3141 24.8328 26.1358 25.0158L24.9643 26.1832C24.7812 26.3599 24.6352 26.5712 24.5346 26.8049C24.4341 27.0386 24.381 27.29 24.3785 27.5444C24.3805 27.7995 24.4333 28.0517 24.5338 28.2861C24.6344 28.5205 24.7808 28.7326 24.9643 28.9098L27.2124 31.1476C26.9174 31.1476 26.6246 31.2445 26.3317 31.2445C25.0612 31.2445 23.7928 30.7577 22.9121 29.7843C22.2613 29.1357 21.8062 28.3171 21.599 27.4219C21.3918 26.5268 21.4409 25.5915 21.7406 24.7229C22.0335 24.0423 21.8376 23.2627 21.2518 22.6811L10.4094 11.8737C10.2313 11.6909 10.0187 11.5453 9.78403 11.4451C9.54933 11.3449 9.29712 11.2922 9.04194 11.29C8.84601 11.29 8.65007 11.29 8.3572 11.387C7.82667 11.5865 7.26369 11.6858 6.69691 11.6798C5.42642 11.6798 4.15593 11.1931 3.27732 10.2196C2.10583 9.05017 1.61702 7.493 1.90989 5.93582L4.158 8.17568C4.5478 8.56342 5.03661 8.75936 5.52336 8.75936V8.76142Z"
          fill="white"
        />
        <path
          d="M10.2483 18.1749C9.99833 18.1771 9.75132 18.229 9.52155 18.3274C9.29178 18.4258 9.08383 18.5689 8.90974 18.7482L2.02106 25.6349C1.83966 25.8076 1.69525 26.0155 1.59658 26.2457C1.4979 26.476 1.44702 26.7239 1.44702 26.9744C1.44702 27.225 1.4979 27.4729 1.59658 27.7031C1.69525 27.9334 1.83966 28.1412 2.02106 28.314L4.70228 30.9911C4.87637 31.1705 5.08433 31.3135 5.31409 31.4119C5.54386 31.5104 5.79088 31.5622 6.04083 31.5645C6.29078 31.5622 6.5378 31.5104 6.76757 31.4119C6.99734 31.3135 7.20529 31.1705 7.37938 30.9911L14.2681 24.1045C14.4495 23.9317 14.5939 23.7239 14.6925 23.4936C14.7912 23.2633 14.8421 23.0154 14.8421 22.7649C14.8421 22.5144 14.7912 22.2665 14.6925 22.0362C14.5939 21.806 14.4495 21.5981 14.2681 21.4253L11.5848 18.7482C11.2981 18.3646 10.8217 18.1749 10.2462 18.1749H10.2483ZM6.1357 29.6526L3.45861 26.9734L10.3452 20.0889L13.0223 22.768L6.1357 29.6546V29.6526ZM29.3798 2.29585L30.7184 3.63647L27.371 6.98387L26.7007 6.31356L26.0304 5.64326L29.3798 2.29585ZM29.3798 0.000316533C29.2538 -0.00308617 29.1286 0.0209798 29.0129 0.0708426C28.8971 0.120706 28.7936 0.19517 28.7095 0.289063L24.0236 4.97501C23.9329 5.06132 23.8607 5.16514 23.8114 5.28019C23.7621 5.39524 23.7366 5.51911 23.7366 5.64429C23.7366 5.76946 23.7621 5.89334 23.8114 6.00838C23.8607 6.12343 23.9329 6.22726 24.0236 6.31356L24.6918 6.98387L20.0059 11.6698C19.9149 11.7561 19.8424 11.8601 19.7929 11.9753C19.7434 12.0906 19.7178 12.2147 19.7178 12.3401C19.7178 12.4656 19.7434 12.5897 19.7929 12.7049C19.8424 12.8201 19.9149 12.9241 20.0059 13.0104C20.1977 13.2002 20.4844 13.2951 20.6741 13.2951C20.925 13.2841 21.1632 13.1822 21.3444 13.0084L26.0304 8.32242L26.7007 8.99066C26.8925 9.18247 27.1792 9.2794 27.371 9.2794C27.6214 9.2674 27.8589 9.16478 28.0392 8.99066L32.7272 4.30471C32.8182 4.21838 32.8907 4.11443 32.9402 3.99919C32.9897 3.88395 33.0153 3.75983 33.0153 3.6344C33.0153 3.50897 32.9897 3.38486 32.9402 3.26962C32.8907 3.15438 32.8182 3.05043 32.7272 2.9641L30.0481 0.289063C29.9532 0.0951905 29.6665 0.000316533 29.3798 0.000316533Z"
          fill="#FFF501"
        />
      </g>
      <defs>
        <clipPath id="clip0_552_10119">
          <rect width="33" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'sang-ten': (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_552_10162)">
        <path
          d="M21.6777 0H7.17998C6.92368 0 6.6777 0.101967 6.49642 0.283241L0.283241 6.49642C0.101967 6.6777 0 6.92368 0 7.17998V29.9621C0 31.6372 1.36283 33 3.03786 33H21.6777C22.4896 33 23.2527 32.6838 23.8258 32.11C24.3995 31.5365 24.7155 30.7736 24.7155 29.9621V20L21 23.7605L18.5 22L24.7155 10.2324V3.03786C24.7155 2.2264 24.3995 1.46354 23.8263 0.890259C23.2527 0.316223 22.4896 0 21.6777 0ZM7.24896 2.26517V6.14445C7.24896 6.75348 6.75348 7.24871 6.1447 7.24871H2.26517L7.24896 2.26517ZM22.7822 29.9621C22.7822 30.257 22.6671 30.5342 22.4581 30.7431C22.2499 30.9516 21.9727 31.0664 21.6779 31.0664H3.03786C2.42908 31.0664 1.93359 30.5709 1.93359 29.9621V9.18256H6.14445C7.81947 9.18256 9.1823 7.81973 9.1823 6.1447V1.93359H21.6777C21.9727 1.93359 22.2499 2.0484 22.4586 2.25737C22.6671 2.46584 22.7819 2.74303 22.7819 3.03786L22.782 10.6558L17 23L21.5 25L22.7821 23.7605L22.7822 29.9621Z"
          fill="white"
        />
        <path
          d="M18.5711 12.4258H6.14453C5.61078 12.4258 5.17773 12.8586 5.17773 13.3926C5.17773 13.9266 5.61078 14.3594 6.14453 14.3594H18.5711C19.1051 14.3594 19.5379 13.9266 19.5379 13.3926C19.5379 12.8586 19.1051 12.4258 18.5711 12.4258Z"
          fill="white"
        />
        <path
          d="M16.7058 16.5703H6.00988C5.55047 16.5703 5.17773 17.0031 5.17773 17.5371C5.17773 18.0711 5.55047 18.5039 6.00988 18.5039H16.7058C17.1654 18.5039 17.5379 18.0711 17.5379 17.5371C17.5379 17.0031 17.1654 16.5703 16.7058 16.5703Z"
          fill="white"
        />
        <path
          d="M14.8404 20.7109H5.87523C5.49016 20.7109 5.17773 21.144 5.17773 21.6777C5.17773 22.2117 5.49016 22.6445 5.87523 22.6445H14.8404C15.2257 22.6445 15.5379 22.2117 15.5379 21.6777C15.5379 21.144 15.2257 20.7109 14.8404 20.7109Z"
          fill="white"
        />
        <path
          d="M12.358 24.8516H6.14453C5.61078 24.8516 5.17773 25.2844 5.17773 25.8184C5.17773 26.3521 5.61078 26.7852 6.14453 26.7852H12.358C12.8917 26.7852 13.3248 26.3521 13.3248 25.8184C13.3248 25.2844 12.892 24.8516 12.358 24.8516Z"
          fill="white"
        />
        <path
          d="M29.9562 2.30854C28.4445 1.58703 26.6276 2.22992 25.9061 3.74159L17.1955 21.9916C15.8261 24.8606 15.1332 28.057 15.1916 31.2354C15.1982 31.6015 15.4113 31.9325 15.7416 32.0902C16.0722 32.248 16.4634 32.2053 16.7524 31.9803C19.2599 30.0267 21.3094 27.4775 22.6787 24.6087L31.3892 6.35866C32.1107 4.847 31.4679 3.03004 29.9562 2.30854V2.30854ZM29.1233 4.05356C29.6727 4.31578 29.9064 4.97637 29.6442 5.52578L28.7225 7.45689L26.7294 6.50558L27.6511 4.57447C27.9133 4.02506 28.5737 3.79122 29.1233 4.05356ZM21.1395 23.3445L19.1463 22.3932L25.8965 8.2506L27.8896 9.20191L21.1395 23.3445ZM17.2157 29.0019C17.3825 27.3477 17.7712 25.7151 18.3664 24.1635L20.2537 25.0643C19.4216 26.5031 18.3966 27.8317 17.2157 29.0019Z"
          fill="#FFF501"
        />
        <g clipPath="url(#clip1_552_10162)">
          <path
            d="M292.9 -101L268 -125.9C247.75 -146.15 215 -146.15 194.75 -125.9L35.5 32.8C5.39999 62.8 -11.9 104.3 -12 146.8C-15.875 146.55 -19.5 144.413 -21.375 140.538C-33.255 116.658 -67.625 110.158 -87.375 126.418L-101.255 84.788C-104.5 74.9 -113.6 68.3 -124 68.3C-134.4 68.3 -143.5 74.925 -146.75 84.8L-165 139.4C-166.5 144 -170.75 147 -175.62 147H-188C-196.87 147 -204 154.1 -204 163C-204 171.9 -196.87 179 -188 179H-175.6C-156.98 179 -140.5 167.12 -134.62 149.5L-124 117.6L-107.2 168C-102.6 181.6 -84 182.9 -77.7 170.1L-69.951 154.72C-65.951 146.72 -54.261 146.22 -49.761 155.095C-42.6 169.6 -28.1 178.7 -12 178.9L20 179C86.84 179 132.1 132.7 134.1 131.5L292.9 -27.8C302.6 -37.5 308 -50.6 308 -64.4C308 -78.2 302.6 -91.2 292.9 -101ZM111.5 109C87.3 133.3 54.4 146.9 20 146.9C20 112.52 33.75 79.58 57.1 55.46L177.7 -64.44L230.45 -11.69L111.5 109ZM270.3 -50.4L249 -29.2L196.3 -82L217.42 -103.25C225.17 -110.875 237.67 -110.999 245.42 -103.25L270.3 -78.37C277.9 -70.6 277.9 -58.1 270.3 -50.4ZM96.4 211C89.771 211 83.3 214.795 81.2 221.1C76.1 233.8 65 243 50.1 243H-205.1C-222.72 243 -236.99 228.67 -236.99 211V-173C-236.99 -190.67 -222.71 -205 -205.1 -205H-77.5V-93C-77.5 -66.49 -56.08 -45 -29.66 -45H34.41C43.062 -45 50.07 -52.037 50.07 -60.72V-61.3C50.1 -70 43.9 -77 35.3 -77H-28.8C-37.6 -77 -44.7 -84.2 -44.7 -93V-202.92C-40.239 -201.354 -36.063 -199.074 -32.62 -195.621L57.23 -105.481C63.347 -99.342 73.27 -99.342 79.38 -105.481L79.7 -105.9C85.817 -112.039 85.817 -121.99 79.7 -128.13L-10.1 -218.25C-22.1 -230.258 -38.3 -237 -55.2 -237H-204.07C-239.3 -237 -268 -208.35 -268 -173L-267.993 211C-267.993 246.35 -239.293 275 -204.063 275H50.9365C79.1365 275 103.057 256.64 111.487 231.2C114.8 221.2 106.9 211 96.4 211Z"
            fill="black"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_552_10162">
          <rect width="33" height="33" fill="white" />
        </clipPath>
        <clipPath id="clip1_552_10162">
          <rect width="576" height="512" fill="white" transform="translate(-268 -237)" />
        </clipPath>
      </defs>
    </svg>
  ),
  'cap-lai': (
    <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_552_10145)">
        <path
          d="M21.6777 0H7.17998C6.92368 0 6.6777 0.101967 6.49642 0.283241L0.283241 6.49642C0.101967 6.6777 0 6.92368 0 7.17998V29.9621C0 31.6372 1.36283 33 3.03786 33H21.6777C22.4896 33 23.2527 32.6838 23.8258 32.11C24.3995 31.5365 24.7155 30.7736 24.7155 29.9621V3.03786C24.7155 2.2264 24.3995 1.46354 23.8263 0.890259C23.2527 0.316223 22.4896 0 21.6777 0V0ZM7.24896 2.26517V6.14445C7.24896 6.75348 6.75348 7.24871 6.1447 7.24871H2.26517L7.24896 2.26517ZM22.7822 29.9621C22.7822 30.257 22.6671 30.5342 22.4581 30.7431C22.2499 30.9516 21.9727 31.0664 21.6779 31.0664H3.03786C2.42908 31.0664 1.93359 30.5709 1.93359 29.9621V9.18256H6.14445C7.81947 9.18256 9.1823 7.81973 9.1823 6.1447V1.93359H21.6777C21.9727 1.93359 22.2499 2.0484 22.4586 2.25737C22.6671 2.46584 22.7819 2.74303 22.7819 3.03786V29.9621H22.7822Z"
          fill="white"
        />
        <path
          d="M18.5711 12.4258H6.14453C5.61078 12.4258 5.17773 12.8586 5.17773 13.3926C5.17773 13.9266 5.61078 14.3594 6.14453 14.3594H18.5711C19.1051 14.3594 19.5379 13.9266 19.5379 13.3926C19.5379 12.8586 19.1051 12.4258 18.5711 12.4258Z"
          fill="white"
        />
        <path
          d="M18.5711 16.5703H6.14453C5.61078 16.5703 5.17773 17.0031 5.17773 17.5371C5.17773 18.0711 5.61078 18.5039 6.14453 18.5039H18.5711C19.1051 18.5039 19.5379 18.0711 19.5379 17.5371C19.5379 17.0031 19.1051 16.5703 18.5711 16.5703Z"
          fill="white"
        />
        <path
          d="M18.571 20.7109H6.14441C5.61066 20.7109 5.17761 21.144 5.17761 21.6777C5.17761 22.2117 5.61066 22.6445 6.14441 22.6445H18.571C19.105 22.6445 19.5378 22.2117 19.5378 21.6777C19.5378 21.144 19.105 20.7109 18.571 20.7109Z"
          fill="white"
        />
        <path
          d="M12.358 24.8516H6.14453C5.61078 24.8516 5.17773 25.2844 5.17773 25.8184C5.17773 26.3521 5.61078 26.7852 6.14453 26.7852H12.358C12.8917 26.7852 13.3248 26.3521 13.3248 25.8184C13.3248 25.2844 12.892 24.8516 12.358 24.8516Z"
          fill="white"
        />
        <path
          d="M29.9622 0C28.2871 0 26.9243 1.36283 26.9243 3.03786V23.26C26.9243 26.4391 27.6758 29.6223 29.0976 32.4655C29.2612 32.793 29.5961 33 29.9622 33C30.3285 33 30.6631 32.793 30.827 32.4655C32.2485 29.6223 33 26.4389 33 23.26V3.03786C33 1.36283 31.6372 0 29.9622 0V0ZM29.9622 1.93359C30.571 1.93359 31.0664 2.42908 31.0664 3.03786V5.17765H28.8579V3.03786C28.8579 2.42908 29.3531 1.93359 29.9622 1.93359ZM31.0664 22.7822H28.8579V7.11124H31.0664V22.7822ZM29.9622 29.5779C29.4002 28.0132 29.0477 26.3724 28.9166 24.7158H31.0078C30.8766 26.3727 30.5239 28.0132 29.9622 29.5779Z"
          fill="#FFF501"
        />
      </g>
      <defs>
        <clipPath id="clip0_552_10145">
          <rect width="33" height="33" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'dang-ki-thay-doi': (
    <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M42.4597 30.923L39.5983 28.0547L29.9258 37.764L32.7872 40.6323L42.4597 30.923Z"
        stroke="#FFF001"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.7793 40.6286L29.0908 41.4656L29.9195 37.7656"
        stroke="#FFF001"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.5884 32.7985L37.7285 29.9297"
        stroke="#FFF001"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.7993 41.6244C21.6214 42.4881 17.2774 41.9801 13.4095 40.1757C9.54172 38.3712 6.35547 35.3661 4.32194 31.6047C2.28849 27.8432 1.51577 23.5252 2.11799 19.2892C2.72028 15.0532 4.66553 11.124 7.66614 8.08272C10.6668 5.04148 14.5635 3.04962 18.78 2.40174C22.9964 1.7538 27.3089 2.48419 31.0795 4.48499C34.8502 6.48571 37.8788 9.65054 39.7176 13.5115C41.5564 17.3724 42.1077 21.7245 41.29 25.924"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M26.5418 28.2386C26.1168 27.537 25.8571 26.7472 25.7822 25.9297"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5301 25.6758C17.4503 26.566 17.2105 27.4343 16.8223 28.2387"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.6904 27.3291H21.7882C23.1059 27.3291 24.4122 27.0578 24.9359 26.5325C25.6897 25.7764 29.0042 21.2279 28.4805 15.5654C28.0662 11.0688 25.2063 9.03125 21.6616 9.03125C18.1169 9.03125 15.3318 11.0573 14.8945 15.5654C14.3766 21.2279 17.6911 25.7764 18.4449 26.5325C18.9629 27.0578 20.2748 27.3233 21.5926 27.3291H21.6904Z"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M31.8983 30.5276C30.2046 29.5587 28.4075 28.7843 26.541 28.2188"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.8229 28.2383C16.8229 28.2383 9.67598 30.3104 8.93945 33.1793"
        stroke="white"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  'green-pencil': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.5 14.5501V17.0835C2.5 17.3168 2.68333 17.5001 2.91667 17.5001H5.45C5.55833 17.5001 5.66667 17.4585 5.74167 17.3751L14.8417 8.28346L11.7167 5.15846L2.625 14.2501C2.54167 14.3335 2.5 14.4335 2.5 14.5501ZM17.2583 5.8668C17.5833 5.5418 17.5833 5.0168 17.2583 4.6918L15.3083 2.7418C14.9833 2.4168 14.4583 2.4168 14.1333 2.7418L12.6083 4.2668L15.7333 7.3918L17.2583 5.8668Z"
        fill="#00C590"
      />
    </svg>
  ),

  information: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_363_15847)">
        <path
          d="M8 16C12.4187 16 16 12.4187 16 8C16 3.58125 12.4187 0 8 0C3.58125 0 0 3.58125 0 8C0 12.4187 3.58125 16 8 16ZM6.75 10.5H7.5V8.5H6.75C6.33437 8.5 6 8.16562 6 7.75C6 7.33437 6.33437 7 6.75 7H8.25C8.66562 7 9 7.33437 9 7.75V10.5H9.25C9.66562 10.5 10 10.8344 10 11.25C10 11.6656 9.66562 12 9.25 12H6.75C6.33437 12 6 11.6656 6 11.25C6 10.8344 6.33437 10.5 6.75 10.5ZM8 6C7.44688 6 7 5.55312 7 5C7 4.44688 7.44688 4 8 4C8.55313 4 9 4.44688 9 5C9 5.55312 8.55313 6 8 6Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_363_15847">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'download-red': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8333 10.8333V15C15.8333 15.4583 15.4583 15.8333 15 15.8333H5C4.54167 15.8333 4.16667 15.4583 4.16667 15V10.8333C4.16667 10.375 3.79167 10 3.33333 10C2.875 10 2.5 10.375 2.5 10.8333V15.8333C2.5 16.75 3.25 17.5 4.16667 17.5H15.8333C16.75 17.5 17.5 16.75 17.5 15.8333V10.8333C17.5 10.375 17.125 10 16.6667 10C16.2083 10 15.8333 10.375 15.8333 10.8333ZM10.8333 10.5583L12.4 8.99167C12.725 8.66667 13.25 8.66667 13.575 8.99167C13.9 9.31667 13.9 9.84167 13.575 10.1667L10.5833 13.1583C10.2583 13.4833 9.73333 13.4833 9.40833 13.1583L6.41667 10.1667C6.09167 9.84167 6.09167 9.31667 6.41667 8.99167C6.74167 8.66667 7.26667 8.66667 7.59167 8.99167L9.16667 10.5583V3.33333C9.16667 2.875 9.54167 2.5 10 2.5C10.4583 2.5 10.8333 2.875 10.8333 3.33333V10.5583Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'printer-red': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8333 6.66667H4.16667C2.78334 6.66667 1.66667 7.78333 1.66667 9.16667V12.5C1.66667 13.4167 2.41667 14.1667 3.33334 14.1667H5.00001V15.8333C5.00001 16.75 5.75001 17.5 6.66667 17.5H13.3333C14.25 17.5 15 16.75 15 15.8333V14.1667H16.6667C17.5833 14.1667 18.3333 13.4167 18.3333 12.5V9.16667C18.3333 7.78333 17.2167 6.66667 15.8333 6.66667ZM12.5 15.8333H7.50001C7.04167 15.8333 6.66667 15.4583 6.66667 15V11.6667H13.3333V15C13.3333 15.4583 12.9583 15.8333 12.5 15.8333ZM15.8333 10C15.375 10 15 9.625 15 9.16667C15 8.70833 15.375 8.33333 15.8333 8.33333C16.2917 8.33333 16.6667 8.70833 16.6667 9.16667C16.6667 9.625 16.2917 10 15.8333 10ZM14.1667 2.5H5.83334C5.37501 2.5 5.00001 2.875 5.00001 3.33333V5C5.00001 5.45833 5.37501 5.83333 5.83334 5.83333H14.1667C14.625 5.83333 15 5.45833 15 5V3.33333C15 2.875 14.625 2.5 14.1667 2.5Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'eye-red': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.99998 3.75C5.83331 3.75 2.27498 6.34167 0.833313 10C2.27498 13.6583 5.83331 16.25 9.99998 16.25C14.1666 16.25 17.725 13.6583 19.1666 10C17.725 6.34167 14.1666 3.75 9.99998 3.75ZM9.99998 14.1667C7.69998 14.1667 5.83331 12.3 5.83331 10C5.83331 7.7 7.69998 5.83333 9.99998 5.83333C12.3 5.83333 14.1666 7.7 14.1666 10C14.1666 12.3 12.3 14.1667 9.99998 14.1667ZM9.99998 7.5C8.61665 7.5 7.49998 8.61667 7.49998 10C7.49998 11.3833 8.61665 12.5 9.99998 12.5C11.3833 12.5 12.5 11.3833 12.5 10C12.5 8.61667 11.3833 7.5 9.99998 7.5Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'clear-orange': (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.9397 2.76904L1.8138 12.338C0.728733 13.3634 0.728733 15.0245 1.8138 16.0499L5.28602 19.3312C5.80686 19.8233 6.51432 20.0981 7.25217 20.0981H11.8225H12.2305H21.5447C22.3129 20.0981 22.9336 19.5116 22.9336 18.7856C22.9336 18.0597 22.3129 17.4731 21.5447 17.4731H16.1584L21.8312 12.1165C22.9162 11.0911 22.9162 9.42998 21.8312 8.40459L15.872 2.76904C14.7869 1.74365 13.0291 1.74365 11.944 2.76904H11.9397ZM12.2305 17.4772H11.8225H7.24783L3.77561 14.196L9.18793 9.08135L15.1515 14.7169L12.2305 17.4772Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'save-orange': (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.59 3.59C17.21 3.21 16.7 3 16.17 3H5C3.89 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V7.83C21 7.3 20.79 6.79 20.41 6.42L17.59 3.59ZM12 19C10.34 19 9 17.66 9 16C9 14.34 10.34 13 12 13C13.66 13 15 14.34 15 16C15 17.66 13.66 19 12 19ZM13 9H7C5.9 9 5 8.1 5 7C5 5.9 5.9 5 7 5H13C14.1 5 15 5.9 15 7C15 8.1 14.1 9 13 9Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'download-white': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_363_13605)">
        <path
          d="M11.25 1.25C11.25 0.558594 10.6914 0 10 0C9.30859 0 8.75 0.558594 8.75 1.25V10.7305L5.88281 7.86328C5.39453 7.375 4.60156 7.375 4.11328 7.86328C3.625 8.35156 3.625 9.14453 4.11328 9.63281L9.11328 14.6328C9.60156 15.1211 10.3945 15.1211 10.8828 14.6328L15.8828 9.63281C16.3711 9.14453 16.3711 8.35156 15.8828 7.86328C15.3945 7.375 14.6016 7.375 14.1133 7.86328L11.25 10.7305V1.25ZM2.5 13.75C1.12109 13.75 0 14.8711 0 16.25V17.5C0 18.8789 1.12109 20 2.5 20H17.5C18.8789 20 20 18.8789 20 17.5V16.25C20 14.8711 18.8789 13.75 17.5 13.75H13.5352L11.7656 15.5195C10.7891 16.4961 9.20703 16.4961 8.23047 15.5195L6.46484 13.75H2.5ZM16.875 17.8125C16.3555 17.8125 15.9375 17.3945 15.9375 16.875C15.9375 16.3555 16.3555 15.9375 16.875 15.9375C17.3945 15.9375 17.8125 16.3555 17.8125 16.875C17.8125 17.3945 17.3945 17.8125 16.875 17.8125Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_363_13605">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'qr-code': (
    <svg width="20" height="23" viewBox="0 0 20 23" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.14286 1.42773C0.959821 1.42773 0 2.38756 0 3.57059V7.85631C0 9.03934 0.959821 9.99916 2.14286 9.99916H6.42857C7.61161 9.99916 8.57143 9.03934 8.57143 7.85631V3.57059C8.57143 2.38756 7.61161 1.42773 6.42857 1.42773H2.14286ZM5.71429 4.28488V7.14202H2.85714V4.28488H5.71429ZM2.14286 12.8563C0.959821 12.8563 0 13.8161 0 14.9992V19.2849C0 20.4679 0.959821 21.4277 2.14286 21.4277H6.42857C7.61161 21.4277 8.57143 20.4679 8.57143 19.2849V14.9992C8.57143 13.8161 7.61161 12.8563 6.42857 12.8563H2.14286ZM5.71429 15.7134V18.5706H2.85714V15.7134H5.71429ZM11.4286 3.57059V7.85631C11.4286 9.03934 12.3884 9.99916 13.5714 9.99916H17.8571C19.0402 9.99916 20 9.03934 20 7.85631V3.57059C20 2.38756 19.0402 1.42773 17.8571 1.42773H13.5714C12.3884 1.42773 11.4286 2.38756 11.4286 3.57059ZM14.2857 4.28488H17.1429V7.14202H14.2857V4.28488ZM15.7143 19.9992V21.4277H17.1429V19.9992H15.7143ZM20 19.9992H18.5714V21.4277H20V19.9992ZM18.5714 12.8563V14.2849H15.7143V12.8563H11.4286V17.142V21.4277H14.2857V17.142H15.7143V18.5706H20V15.7134V14.2849V12.8563H18.5714Z"
        fill="#00C590"
      />
    </svg>
  ),

  'small-image-red': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 16.6673H3.33333V5.00065H10.8333V3.33398H3.33333C2.41667 3.33398 1.66667 4.08398 1.66667 5.00065V16.6673C1.66667 17.584 2.41667 18.334 3.33333 18.334H15C15.9167 18.334 16.6667 17.584 16.6667 16.6673V9.16732H15V16.6673ZM8.50833 14.0257L6.875 12.059L4.58333 15.0007H13.75L10.8 11.0757L8.50833 14.0257ZM16.6667 3.33398V0.833984H15V3.33398H12.5C12.5083 3.34232 12.5 5.00065 12.5 5.00065H15V7.49232C15.0083 7.50065 16.6667 7.49232 16.6667 7.49232V5.00065H19.1667V3.33398H16.6667Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'user-setting': (
    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_363_13524)">
        <path
          d="M7 8C4.79063 8 3 6.20937 3 4C3 1.79062 4.79063 0 7 0C9.20938 0 11 1.79062 11 4C11 6.20937 9.20938 8 7 8ZM5.57188 9.5H8.42813C8.79688 9.5 9.15938 9.5375 9.50625 9.60312C9.44063 10.1812 9.7375 10.7156 10.1875 11.0031C9.66875 11.3344 9.35312 11.9906 9.5625 12.6687C9.6875 13.0719 9.85625 13.4656 10.075 13.8437C10.2937 14.2219 10.55 14.5656 10.8375 14.875C11.3281 15.4031 12.075 15.45 12.625 15.1469V15.175C12.625 15.4625 12.7094 15.7531 12.8719 15.9969H0.928125C0.415625 16 0 15.5844 0 15.0719C0 11.9937 2.49375 9.5 5.57188 9.5ZM13.625 6.81875C13.625 6.6 13.7656 6.40312 13.9781 6.35625C14.3062 6.28125 14.65 6.24062 15 6.24062C15.35 6.24062 15.6938 6.28125 16.0219 6.35625C16.2344 6.40312 16.375 6.6 16.375 6.81875V7.775C16.6219 7.88125 16.8562 8.01562 17.0719 8.175L17.85 7.72812C18.0406 7.61875 18.2781 7.64375 18.4281 7.80312C18.6656 8.05625 18.875 8.34062 19.0562 8.65312C19.2375 8.96562 19.3781 9.29062 19.4781 9.62187C19.5437 9.83125 19.4437 10.05 19.2531 10.1594L18.4719 10.6094C18.4844 10.7344 18.4937 10.8625 18.4937 10.9937C18.4937 11.125 18.4875 11.25 18.4719 11.3781L19.2531 11.8281C19.4437 11.9375 19.5406 12.1562 19.4781 12.3656C19.375 12.6969 19.2344 13.0219 19.0562 13.3344C18.8781 13.6469 18.6656 13.9312 18.4281 14.1844C18.2781 14.3437 18.0375 14.3687 17.85 14.2594L17.0719 13.8125C16.8562 13.9719 16.625 14.1062 16.375 14.2125V15.1687C16.375 15.3875 16.2344 15.5844 16.0219 15.6312C15.6938 15.7062 15.35 15.7469 15 15.7469C14.65 15.7469 14.3062 15.7062 13.9781 15.6312C13.7656 15.5844 13.625 15.3875 13.625 15.1687V14.2125C13.375 14.1062 13.1375 13.9719 12.9219 13.8094L12.15 14.2562C11.9594 14.3656 11.7219 14.3406 11.5719 14.1812C11.3344 13.9281 11.125 13.6437 10.9438 13.3312C10.7625 13.0187 10.6219 12.6937 10.5219 12.3625C10.4563 12.1531 10.5562 11.9344 10.7469 11.825L11.5219 11.3781C11.5094 11.25 11.5 11.1219 11.5 10.9906C11.5 10.8594 11.5063 10.7312 11.5219 10.6031L10.7437 10.1562C10.5531 10.0469 10.4563 9.82812 10.5188 9.61875C10.6219 9.2875 10.7594 8.9625 10.9406 8.65C11.1219 8.3375 11.3313 8.05312 11.5688 7.8C11.7188 7.64062 11.9563 7.61562 12.1469 7.725L12.9219 8.17187C13.1375 8.0125 13.375 7.87812 13.625 7.76875V6.81875ZM16.5031 10.9906C16.5031 10.1625 15.8313 9.49062 15 9.49062C14.1687 9.49062 13.4969 10.1625 13.4969 10.9906C13.4969 11.8187 14.1687 12.4906 15 12.4906C15.8313 12.4906 16.5031 11.8187 16.5031 10.9906Z"
          fill="#00C590"
        />
      </g>
      <defs>
        <clipPath id="clip0_363_13524">
          <rect width="20" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  'speed-icon': (
    <svg width="53" height="8" viewBox="0 0 53 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="49" cy="4" r="4" fill="#ED1117" />
      <path
        d="M49 4.00044C49 6 17 6.00045 0 4.00044C17 3.00045 49 2.5 49 4.00044Z"
        fill="#ED1117"
      />
    </svg>
  ),
  'close-tag': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 2C6.47 2 2 6.47 2 12C2 17.53 6.47 22 12 22C17.53 22 22 17.53 22 12C22 6.47 17.53 2 12 2ZM16.3 16.3C15.91 16.69 15.28 16.69 14.89 16.3L12 13.41L9.11 16.3C8.72 16.69 8.09 16.69 7.7 16.3C7.31 15.91 7.31 15.28 7.7 14.89L10.59 12L7.7 9.11C7.31 8.72 7.31 8.09 7.7 7.7C8.09 7.31 8.72 7.31 9.11 7.7L12 10.59L14.89 7.7C15.28 7.31 15.91 7.31 16.3 7.7C16.69 8.09 16.69 8.72 16.3 9.11L13.41 12L16.3 14.89C16.68 15.27 16.68 15.91 16.3 16.3Z"
        fill="#838383"
      />
    </svg>
  ),
  'small-image': (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21.02 5H19V2.98C19 2.44 18.56 2 18.02 2H17.99C17.44 2 17 2.44 17 2.98V5H14.99C14.45 5 14.01 5.44 14 5.98V6.01C14 6.56 14.44 7 14.99 7H17V9.01C17 9.55 17.44 10 17.99 9.99H18.02C18.56 9.99 19 9.55 19 9.01V7H21.02C21.56 7 22 6.56 22 6.02V5.98C22 5.44 21.56 5 21.02 5ZM16 9.01V8H14.99C14.46 8 13.96 7.79 13.58 7.42C13.21 7.04 13 6.54 13 5.98C13 5.62 13.1 5.29 13.27 5H5C3.9 5 3 5.9 3 7V19C3 20.1 3.9 21 5 21H17C18.1 21 19 20.1 19 19V10.72C18.7 10.89 18.36 11 17.98 11C16.89 10.99 16 10.1 16 9.01ZM15.96 19H6C5.59 19 5.35 18.53 5.6 18.2L7.58 15.57C7.79 15.29 8.2 15.31 8.4 15.59L10 18L12.61 14.52C12.81 14.26 13.2 14.25 13.4 14.51L16.35 18.19C16.61 18.52 16.38 19 15.96 19Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),

  'arrow-orange': (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66663 9.99967C1.66663 14.5997 5.39996 18.333 9.99996 18.333C14.6 18.333 18.3333 14.5997 18.3333 9.99967C18.3333 5.39967 14.6 1.66634 9.99996 1.66634C5.39996 1.66634 1.66663 5.39967 1.66663 9.99967ZM12.2083 10.2913L9.88329 12.6163C9.61663 12.883 9.16663 12.6997 9.16663 12.3247V7.66634C9.16663 7.29134 9.61663 7.10801 9.87496 7.37467L12.2 9.69967C12.3666 9.86634 12.3666 10.133 12.2083 10.2913Z"
        fill="#F88C00"
      />
    </svg>
  ),
  'shopping-cart': (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.55 13.5C16.3 13.5 16.96 13.09 17.3 12.47L20.88 5.98C21.25 5.32 20.77 4.5 20.01 4.5H5.21L4.27 2.5H1V4.5H3L6.6 12.09L5.25 14.53C4.52 15.87 5.48 17.5 7 17.5H19V15.5H7L8.1 13.5H15.55ZM6.16 6.5H18.31L15.55 11.5H8.53L6.16 6.5ZM7 18.5C5.9 18.5 5.01 19.4 5.01 20.5C5.01 21.6 5.9 22.5 7 22.5C8.1 22.5 9 21.6 9 20.5C9 19.4 8.1 18.5 7 18.5ZM17 18.5C15.9 18.5 15.01 19.4 15.01 20.5C15.01 21.6 15.9 22.5 17 22.5C18.1 22.5 19 21.6 19 20.5C19 19.4 18.1 18.5 17 18.5Z"
        fill="black"
        fillOpacity="0.54"
      />
    </svg>
  ),
}
